const isTauriApp = window.__TAURI__ !== undefined;
const AI_PANE_MODE_STORAGE_KEY = 'memora.ai_pane_mode_v1';
const MEMORA_PDF_EXPLANATION_FEATURE_KEY = 'memora.pdf_explanation_feature_enabled_v1';
const AI_PANE_MODE_AI = 'ai';
const AI_PANE_MODE_PDF_EXPLANATION = 'pdf-explanation';
const AI_PANE_MODE_GEMINI_LIVE = 'gemini-live';
const GEMINI_TTS_API_BASE = 'https://generativelanguage.googleapis.com/v1beta/models';
const GEMINI_TTS_MODEL = 'gemini-3.8-live';
const GEMINI_TTS_OUTPUT_RATE = 24000;
const GEMINI_TTS_API_VERSION = 'v1alpha';
const AI_EXPL_READER_ENGINES = Object.freeze({
    LOCAL: 'local',
    GEMINI: 'gemini'
});
// `name` is the Gemini voice id sent to the API; `title` is the simpler name the student sees.
// `desc` is the personality line the voice modal's carousel shows under the name; `label` stays the
// "Name - Trait" form the older list-style pickers render.
const AI_EXPL_GEMINI_VOICES = Object.freeze([
    { name: 'Kore', title: 'Kora', label: 'Kora - Firm', desc: 'Firm and steady' },
    { name: 'Leda', title: 'Leda', label: 'Leda - Bright', desc: 'Youthful and bright' },
    { name: 'Callirrhoe', title: 'Callie', label: 'Callie - Warm', desc: 'Easy-going and warm' },
    { name: 'Algieba', title: 'Albie', label: 'Albie - Smooth', desc: 'Smooth and rounded' },
    { name: 'Algenib', title: 'Gene', label: 'Gene - Gravelly', desc: 'Gravelly and low' },
    { name: 'Rasalgethi', title: 'Russ', label: 'Russ - Crisp', desc: 'Informative and crisp' },
    { name: 'Alnilam', title: 'Neil', label: 'Neil - Direct', desc: 'Firm and direct' }
]);
/* The canonical speed enum for every surface that offers one: the Agent panel, the explanation
 * reader and the PDF tutor's settings all read this list. A Live session is asked to speak at this
 * pace rather than having its audio resampled, so the voice keeps its pitch; the recorded-audio
 * path resamples with preservesPitch. The steps are uniform 0.1 increments either way. */
const AI_EXPL_READER_SPEED_OPTIONS = Object.freeze([
    { value: '1', label: '1.0x' },
    { value: '1.1', label: '1.1x' },
    { value: '1.2', label: '1.2x' },
    { value: '1.3', label: '1.3x' },
    { value: '1.4', label: '1.4x' },
    { value: '1.5', label: '1.5x' },
    { value: '1.6', label: '1.6x' },
    { value: '1.7', label: '1.7x' },
    { value: '1.8', label: '1.8x' },
    { value: '1.9', label: '1.9x' },
    { value: '2', label: '2.0x' }
]);

function isMemoraPdfExplanationEnabled() {
    return false;
}

let aiPaneMode = (() => {
    try {
        const stored = (localStorage.getItem(AI_PANE_MODE_STORAGE_KEY) || '').trim();
        if (stored === AI_PANE_MODE_AI || stored === AI_PANE_MODE_PDF_EXPLANATION || stored === AI_PANE_MODE_GEMINI_LIVE) {
            if (stored === AI_PANE_MODE_PDF_EXPLANATION && !isMemoraPdfExplanationEnabled()) {
                return AI_PANE_MODE_AI;
            }
            return (stored === AI_PANE_MODE_GEMINI_LIVE && !isVoiceAgentAccessibilityEnabled())
                ? AI_PANE_MODE_AI
                : stored;
        }
    } catch (_err) { }
    return AI_PANE_MODE_AI;
})();
let lastOpenedAiUrl = 'https://gemini.google.com/app';
let lastOpenedAiTitle = 'Gemini';
var isTrioMode = false;
let aiPaneModeSyncInFlight = false;
let aiPaneModeSyncPromise = null;
let pendingAiPaneModeSyncArgs = null;
const AI_EXPL_READER_SETTINGS_KEY = 'memora.ai_expl_reader_settings_v2';
const AI_EXPL_READER_SETTINGS_LEGACY_KEY = 'memora.ai_expl_reader_settings_v1';
// Legacy localStorage preview cache: read once to migrate, then removed.
const AI_EXPL_READER_PREVIEW_CACHE_KEY = 'memora.ai_expl_preview_cache_v1';
const AI_EXPL_READER_PREVIEW_STORE_PREFIX = 'voice_preview::v1::';
const AI_EXPL_REGEN_PROMPT_STORAGE_KEY = 'memora.ai_expl_regen_prompt_v1';
const AI_EXPL_READER_AUDIO_CACHE_LIMIT = 36;
const AI_EXPL_READER_DEFAULT_SETTINGS = {
    engine: AI_EXPL_READER_ENGINES.GEMINI,
    voiceURI: 'auto',
    geminiVoice: 'Leda',
    rate: '1'
};

function normalizeAiExplanationReaderStoredSettings(raw) {
    const source = (raw && typeof raw === 'object') ? raw : {};
    const storedVoice = String(source.geminiVoice || '').trim();
    const voiceFromStore = AI_EXPL_GEMINI_VOICES.some((voice) => voice.name === storedVoice)
        ? storedVoice
        : '';
    return {
        engine: AI_EXPL_READER_ENGINES.GEMINI,
        voiceURI: typeof source.voiceURI === 'string' && source.voiceURI.trim()
            ? source.voiceURI.trim()
            : AI_EXPL_READER_DEFAULT_SETTINGS.voiceURI,
        geminiVoice: voiceFromStore || AI_EXPL_READER_DEFAULT_SETTINGS.geminiVoice,
        rate: normalizeAiExplanationReaderRate(source.rate)
    };
}

function normalizeAiExplanationReaderRate(value) {
    const clean = String(value ?? '').trim();
    if (AI_EXPL_READER_SPEED_OPTIONS.some((option) => option.value === clean)) return clean;
    /* Settings saved before the 1.0x-2.0x range existed can hold 0.85 or 1.35. Snapping to the
     * nearest surviving step keeps a student who chose "fast" on a fast setting instead of quietly
     * resetting them to 1.0x. */
    const parsed = Number(clean);
    if (!Number.isFinite(parsed) || parsed <= 0) return AI_EXPL_READER_DEFAULT_SETTINGS.rate;
    let nearest = AI_EXPL_READER_DEFAULT_SETTINGS.rate;
    let nearestDelta = Infinity;
    AI_EXPL_READER_SPEED_OPTIONS.forEach((option) => {
        const delta = Math.abs(Number(option.value) - parsed);
        if (delta < nearestDelta) {
            nearestDelta = delta;
            nearest = option.value;
        }
    });
    return nearest;
}

function loadAiExplanationReaderSettings() {
    try {
        const rawCurrent = localStorage.getItem(AI_EXPL_READER_SETTINGS_KEY);
        if (rawCurrent) {
            return normalizeAiExplanationReaderStoredSettings(JSON.parse(rawCurrent));
        }

        const rawLegacy = localStorage.getItem(AI_EXPL_READER_SETTINGS_LEGACY_KEY);
        if (rawLegacy) {
            const migrated = normalizeAiExplanationReaderStoredSettings(JSON.parse(rawLegacy));
            localStorage.setItem(AI_EXPL_READER_SETTINGS_KEY, JSON.stringify(migrated));
            return migrated;
        }
    } catch (_err) { }
    return { ...AI_EXPL_READER_DEFAULT_SETTINGS };
}

const aiExplanationReaderState = {
    voices: [],
    text: '',
    pdfName: '',
    isPlaying: false,
    isPaused: false,
    chunks: [],
    chunkIndex: 0,
    utterance: null,
    audioElement: null,
    audioObjectUrl: '',
    audioPlayResolve: null,
    audioPlayReject: null,
    orbContext: null,
    orbSource: null,
    orbAnalyser: null,
    orbFreqData: null,
    orbTimeData: null,
    orbMeterRaf: 0,
    abortController: null,
    prefetchAbortController: null,
    prefetchedChunkIndex: -1,
    prefetchedAudioBlob: null,
    prefetchedAudioPromise: null,
    chunkAudioCache: new Map(),
    // Legacy clips have no sample-text identity, so keep only validated IndexedDB previews.
    previewCache: new Map(),
    previewStorePromise: null,
    previewPrimeTimer: null,
    previewPrefetchKey: '',
    previewPrefetchPromise: null,
    previewPrefetchAbortController: null,
    requestToken: 0,
    delayTimerId: null,
    delayStartedAt: 0,
    delayRemainingMs: 0,
    pendingContinuationKind: '',
    pendingContinuationToken: 0,
    interruptedForConversation: false,
    resumeAfterInterrupt: false,
    resumeAfterPaneHide: false,
    liveSession: null,
    liveVoiceName: '',
    liveSocket: null,
    liveReady: false,
    liveConnecting: false,
    liveSdkPromise: null,
    liveConnectionId: 0,
    livePlaybackContext: null,
    livePlaybackTime: 0,
    livePlaybackSources: [],
    livePlaybackAnalyser: null,
    livePlaybackAnalyserData: null,
    livePlaybackAnalyserTimeData: null,
    livePlaybackMeterRaf: 0,
    liveTurnResolve: null,
    liveTurnReject: null,
    liveTurnServerComplete: false,
    liveTurnHadAudio: false,
    liveTurnAudioChunks: [],
    voiceEventsBound: false,
    voiceMenuBound: false,
    panelOpen: true,
    settings: loadAiExplanationReaderSettings()
};

function isVoiceAgentAccessibilityEnabled() {
    return typeof window.isAccessibilityVoiceAgentEnabled === 'function'
        ? !!window.isAccessibilityVoiceAgentEnabled()
        : false;
}

function syncMemoraPdfExplanationFeatureUi() {
    const enabled = isMemoraPdfExplanationEnabled();
    const toggleBtn = $('pdf-explanation-feature-toggle');
    const toggleLabel = $('pdf-explanation-feature-label') || toggleBtn?.querySelector?.('.gradient-text');
    const pdfExplBtn = $('ai-pane-pdf-expl-btn');
    const modeSelect = $('ai-pane-mode');
    const pdfExplOption = modeSelect?.querySelector?.(`option[value="${AI_PANE_MODE_PDF_EXPLANATION}"]`);

    if (toggleBtn) {
        toggleBtn.classList.toggle('active', enabled);
        toggleBtn.setAttribute('aria-pressed', enabled ? 'true' : 'false');
        toggleBtn.title = enabled
            ? 'PDF Explanation is on for legacy generation and pane mode'
            : 'PDF Explanation is off; Ask Memoraful is the default AI panel';
    }
    if (toggleLabel) toggleLabel.textContent = `PDF Explanation: ${enabled ? 'On' : 'Off'}`;
    if (pdfExplBtn) {
        pdfExplBtn.hidden = !enabled;
        pdfExplBtn.disabled = !enabled;
    }
    if (pdfExplOption) {
        pdfExplOption.disabled = !enabled;
        pdfExplOption.hidden = !enabled;
    }
    if (!enabled && aiPaneMode === AI_PANE_MODE_PDF_EXPLANATION) {
        persistAiPaneMode(AI_PANE_MODE_AI);
        if (modeSelect) modeSelect.value = AI_PANE_MODE_AI;
    }
    if (typeof window.syncQuizGenPdfExplanationFeatureUi === 'function') {
        window.syncQuizGenPdfExplanationFeatureUi(enabled);
    }
}

function setMemoraPdfExplanationEnabled(enabled, options = {}) {
    const next = false;
    const previous = isMemoraPdfExplanationEnabled();
    try {
        localStorage.setItem(MEMORA_PDF_EXPLANATION_FEATURE_KEY, next ? '1' : '0');
    } catch (_err) { }

    if (!next && aiPaneMode === AI_PANE_MODE_PDF_EXPLANATION) {
        preserveAiExplanationReaderForResume('Reader paused. PDF Explanation was turned off.');
        persistAiPaneMode(AI_PANE_MODE_AI);
    }

    syncMemoraPdfExplanationFeatureUi();

    if (previous !== next) {
        try {
            window.dispatchEvent(new CustomEvent('memora:pdf-explanation-feature-changed', {
                detail: { enabled: next }
            }));
        } catch (_err) { }
    }

    if (options?.syncPane !== false) {
        void syncAiPaneModeView(next ? aiPaneMode : AI_PANE_MODE_AI);
    }
    if (options?.showNotice && typeof showPopup === 'function') {
        showPopup(`PDF Explanation ${next ? 'ON' : 'OFF'}`, null, false);
    }
    return next;
}

function toggleMemoraPdfExplanationFeature(options = {}) {
    return setMemoraPdfExplanationEnabled(!isMemoraPdfExplanationEnabled(), options);
}

window.isMemoraPdfExplanationEnabled = isMemoraPdfExplanationEnabled;
window.setMemoraPdfExplanationEnabled = setMemoraPdfExplanationEnabled;
window.toggleMemoraPdfExplanationFeature = toggleMemoraPdfExplanationFeature;

function persistAiPaneMode(mode) {
    const nextMode = [AI_PANE_MODE_AI, AI_PANE_MODE_PDF_EXPLANATION, AI_PANE_MODE_GEMINI_LIVE].includes(mode)
        ? mode
        : AI_PANE_MODE_AI;
    aiPaneMode = (!isMemoraPdfExplanationEnabled() && nextMode === AI_PANE_MODE_PDF_EXPLANATION)
        ? AI_PANE_MODE_AI
        : (!isVoiceAgentAccessibilityEnabled() && nextMode === AI_PANE_MODE_GEMINI_LIVE)
        ? AI_PANE_MODE_AI
        : nextMode;
    try {
        localStorage.setItem(AI_PANE_MODE_STORAGE_KEY, aiPaneMode);
    } catch (_err) { }
}

function getAiExplanationSpeechApi() {
    return typeof window !== 'undefined' && 'speechSynthesis' in window ? window.speechSynthesis : null;
}

function persistAiExplanationReaderSettings() {
    try {
        localStorage.setItem(AI_EXPL_READER_SETTINGS_KEY, JSON.stringify(aiExplanationReaderState.settings));
    } catch (_err) { }
}


function getAiExplanationReaderRateSetting() {
    return String(aiExplanationReaderState.settings.rate || AI_EXPL_READER_DEFAULT_SETTINGS.rate).trim()
        || AI_EXPL_READER_DEFAULT_SETTINGS.rate;
}

function getAiExplanationReaderGeminiVoiceSetting() {
    return String(aiExplanationReaderState.settings.geminiVoice || AI_EXPL_READER_DEFAULT_SETTINGS.geminiVoice).trim()
        || AI_EXPL_READER_DEFAULT_SETTINGS.geminiVoice;
}

function getAiExplanationReaderApiKey() {
    return localStorage.getItem('gemini_api_key') || '';
}

function aiExplanationBase64ToUint8Array(base64) {
    const binary = atob(String(base64 || ''));
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i += 1) {
        bytes[i] = binary.charCodeAt(i);
    }
    return bytes;
}

function aiExplanationPcm16BytesToFloat32(bytes) {
    const view = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    const samples = new Float32Array(bytes.byteLength / 2);
    for (let i = 0; i < samples.length; i += 1) {
        samples[i] = view.getInt16(i * 2, true) / 32768;
    }
    return samples;
}

function pcm16ToWaveBlob(pcmBytes, sampleRate = GEMINI_TTS_OUTPUT_RATE, channels = 1) {
    const bytes = pcmBytes instanceof Uint8Array ? pcmBytes : new Uint8Array(pcmBytes || []);
    const header = new ArrayBuffer(44);
    const view = new DataView(header);
    const byteRate = sampleRate * channels * 2;
    const blockAlign = channels * 2;

    const writeString = (offset, value) => {
        for (let i = 0; i < value.length; i += 1) {
            view.setUint8(offset + i, value.charCodeAt(i));
        }
    };

    writeString(0, 'RIFF');
    view.setUint32(4, 36 + bytes.length, true);
    writeString(8, 'WAVE');
    writeString(12, 'fmt ');
    view.setUint32(16, 16, true);
    view.setUint16(20, 1, true);
    view.setUint16(22, channels, true);
    view.setUint32(24, sampleRate, true);
    view.setUint32(28, byteRate, true);
    view.setUint16(32, blockAlign, true);
    view.setUint16(34, 16, true);
    writeString(36, 'data');
    view.setUint32(40, bytes.length, true);

    return new Blob([header, bytes], { type: 'audio/wav' });
}

function concatUint8Arrays(chunks) {
    const parts = Array.isArray(chunks) ? chunks.filter((chunk) => chunk instanceof Uint8Array && chunk.length > 0) : [];
    if (!parts.length) return new Uint8Array(0);
    const totalLength = parts.reduce((sum, chunk) => sum + chunk.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    parts.forEach((chunk) => {
        merged.set(chunk, offset);
        offset += chunk.length;
    });
    return merged;
}

function normalizeAiExplanationPreviewVoice(voiceName = aiExplanationReaderState.settings.geminiVoice) {
    return String(voiceName || AI_EXPL_READER_DEFAULT_SETTINGS.geminiVoice).trim() || AI_EXPL_READER_DEFAULT_SETTINGS.geminiVoice;
}

function makeAiExplanationPreviewCacheKey(voiceName = aiExplanationReaderState.settings.geminiVoice) {
    return `gemini-live-preview::${normalizeAiExplanationPreviewVoice(voiceName)}`;
}

function dataUrlToBlob(dataUrl) {
    const match = String(dataUrl || '').match(/^data:([^;]+);base64,(.+)$/);
    if (!match) return null;
    const mimeType = match[1] || 'audio/wav';
    return new Blob([aiExplanationBase64ToUint8Array(match[2])], { type: mimeType });
}

function writeAiExplanationPreviewRecord(voiceName, blob) {
    if (typeof IDB === 'undefined' || typeof IDB.put !== 'function') return Promise.resolve(false);
    const voice = normalizeAiExplanationPreviewVoice(voiceName);
    return IDB.put('settings', `${AI_EXPL_READER_PREVIEW_STORE_PREFIX}${voice}`, {
        voice,
        text: buildAiExplanationVoiceSampleText(voice),
        blob,
        savedAt: Date.now()
    }).then(() => true, (error) => {
        console.warn('Voice preview could not be saved:', error);
        return false;
    });
}

/* Each voice's sample is fetched from Live once per browser and kept in IndexedDB, so browsing the
 * carousel replays saved audio instead of opening a Live session per voice. The old localStorage
 * cache held six clips and was usually over quota, so it is moved across once and then dropped. A
 * saved clip whose sample text no longer matches is discarded, so rewording the sample retires it. */
function hydrateAiExplanationPreviewStore() {
    if (aiExplanationReaderState.previewStorePromise) return aiExplanationReaderState.previewStorePromise;
    aiExplanationReaderState.previewStorePromise = (async () => {
        if (typeof IDB === 'undefined' || typeof IDB.getAllKeys !== 'function') return;
        const keys = (await IDB.getAllKeys('settings') || [])
            .map((key) => String(key || ''))
            .filter((key) => key.startsWith(AI_EXPL_READER_PREVIEW_STORE_PREFIX));
        for (const key of keys) {
            const voice = key.slice(AI_EXPL_READER_PREVIEW_STORE_PREFIX.length);
            const record = await IDB.get('settings', key);
            if (!(record?.blob instanceof Blob) || record.blob.size <= 0 || record.text !== buildAiExplanationVoiceSampleText(voice)) {
                void IDB.del('settings', key).catch(() => { });
                continue;
            }
            const cacheKey = makeAiExplanationPreviewCacheKey(voice);
            if (!aiExplanationReaderState.previewCache.get(cacheKey)?.blob) {
                aiExplanationReaderState.previewCache.set(cacheKey, { blob: record.blob, ts: Number(record.savedAt) || Date.now() });
            }
        }
        for (const [cacheKey, entry] of aiExplanationReaderState.previewCache) {
            if (entry.blob || !entry.dataUrl) continue;
            const blob = dataUrlToBlob(entry.dataUrl);
            if (!blob?.size) continue;
            aiExplanationReaderState.previewCache.set(cacheKey, { blob, ts: entry.ts });
            await writeAiExplanationPreviewRecord(cacheKey.slice('gemini-live-preview::'.length), blob);
        }
        try { localStorage.removeItem(AI_EXPL_READER_PREVIEW_CACHE_KEY); } catch (_err) { }
    })().catch((error) => {
        console.warn('Saved voice previews could not be read:', error);
    });
    return aiExplanationReaderState.previewStorePromise;
}

function getCachedAiExplanationPreviewBlob(voiceName = aiExplanationReaderState.settings.geminiVoice) {
    const entry = aiExplanationReaderState.previewCache.get(makeAiExplanationPreviewCacheKey(voiceName));
    if (!entry) return null;
    if (!(entry.blob instanceof Blob) && entry.dataUrl) entry.blob = dataUrlToBlob(entry.dataUrl);
    return entry.blob instanceof Blob && entry.blob.size > 0 ? entry.blob : null;
}

function makeAiExplanationChunkAudioCacheKey(chunk, chunkIndex = -1) {
    const details = getAiExplanationChunkDetails(chunk);
    const pdfName = String(aiExplanationReaderState.pdfName || '').trim();
    const voiceName = String(aiExplanationReaderState.settings.geminiVoice || AI_EXPL_READER_DEFAULT_SETTINGS.geminiVoice).trim()
        || AI_EXPL_READER_DEFAULT_SETTINGS.geminiVoice;
    const rate = String(aiExplanationReaderState.settings.rate || AI_EXPL_READER_DEFAULT_SETTINGS.rate).trim()
        || AI_EXPL_READER_DEFAULT_SETTINGS.rate;
    const slideNumber = Number.isFinite(details.slideNumber) && details.slideNumber > 0 ? details.slideNumber : 0;
    const normalizedText = String(details.text || '').replace(/\s+/g, ' ').trim();
    const textFingerprint = typeof hashFNV1a === 'function'
        ? hashFNV1a(normalizedText)
        : normalizedText;
    return [
        pdfName || 'no-pdf',
        String(chunkIndex),
        String(slideNumber),
        voiceName,
        rate,
        textFingerprint
    ].join('::');
}

function getCachedAiExplanationChunkAudioBlob(chunk, chunkIndex = -1) {
    const key = makeAiExplanationChunkAudioCacheKey(chunk, chunkIndex);
    const entry = aiExplanationReaderState.chunkAudioCache.get(key);
    if (!(entry?.blob instanceof Blob) || entry.blob.size <= 0) return null;
    entry.ts = Date.now();
    return entry.blob;
}

function storeAiExplanationChunkAudioBlob(chunk, chunkIndex, blob) {
    if (!(blob instanceof Blob) || blob.size <= 0) return;
    const key = makeAiExplanationChunkAudioCacheKey(chunk, chunkIndex);
    aiExplanationReaderState.chunkAudioCache.set(key, {
        blob,
        ts: Date.now()
    });
    while (aiExplanationReaderState.chunkAudioCache.size > AI_EXPL_READER_AUDIO_CACHE_LIMIT) {
        const oldest = Array.from(aiExplanationReaderState.chunkAudioCache.entries())
            .sort((a, b) => Number(a[1]?.ts || 0) - Number(b[1]?.ts || 0))[0];
        if (!oldest) break;
        aiExplanationReaderState.chunkAudioCache.delete(oldest[0]);
    }
}

// Every voice keeps its clip: the carousel is small, and an evicted clip costs a Live session.
function storeAiExplanationPreviewBlob(voiceName, blob) {
    if (!(blob instanceof Blob) || blob.size <= 0) return;
    aiExplanationReaderState.previewCache.set(makeAiExplanationPreviewCacheKey(voiceName), { blob, ts: Date.now() });
    void writeAiExplanationPreviewRecord(voiceName, blob);
}

function clearAiExplanationPreviewPrime({ abort = true } = {}) {
    if (aiExplanationReaderState.previewPrimeTimer) {
        clearTimeout(aiExplanationReaderState.previewPrimeTimer);
        aiExplanationReaderState.previewPrimeTimer = null;
    }
    /* Rescheduling only moves the timer. Forgetting the in-flight fetch here left it unabortable, so
     * the next voice waited out the old voice's whole Live session before it could start its own. */
    if (!abort) return;
    if (aiExplanationReaderState.previewPrefetchAbortController) {
        try { aiExplanationReaderState.previewPrefetchAbortController.abort(); } catch (_err) { }
    }
    aiExplanationReaderState.previewPrefetchAbortController = null;
    aiExplanationReaderState.previewPrefetchKey = '';
    aiExplanationReaderState.previewPrefetchPromise = null;
}

async function primeAiExplanationVoicePreview(voiceName = aiExplanationReaderState.settings.geminiVoice, { force = false } = {}) {
    const selectedVoice = String(voiceName || AI_EXPL_READER_DEFAULT_SETTINGS.geminiVoice).trim() || AI_EXPL_READER_DEFAULT_SETTINGS.geminiVoice;
    const cacheKey = makeAiExplanationPreviewCacheKey(selectedVoice);
    if (!force) await hydrateAiExplanationPreviewStore();
    const cached = !force ? getCachedAiExplanationPreviewBlob(selectedVoice) : null;
    if (cached) return cached;
    if (!force && aiExplanationReaderState.previewPrefetchKey === cacheKey && aiExplanationReaderState.previewPrefetchPromise) {
        return aiExplanationReaderState.previewPrefetchPromise;
    }

    clearAiExplanationPreviewPrime();
    const abortController = new AbortController();
    aiExplanationReaderState.previewPrefetchAbortController = abortController;
    aiExplanationReaderState.previewPrefetchKey = cacheKey;
    aiExplanationReaderState.previewPrefetchPromise = requestGeminiExplanationAudioChunk(
        buildAiExplanationVoiceSampleText(selectedVoice),
        abortController.signal,
        0,
        selectedVoice
    ).then(async (blob) => {
        if (blob instanceof Blob && blob.size > 0) {
            await storeAiExplanationPreviewBlob(selectedVoice, blob);
        }
        if (aiExplanationReaderState.previewPrefetchKey === cacheKey) {
            aiExplanationReaderState.previewPrefetchAbortController = null;
            aiExplanationReaderState.previewPrefetchPromise = null;
        }
        return blob;
    }).catch((error) => {
        if (error?.name !== 'AbortError') {
            console.warn('Voice preview prefetch failed:', error);
        }
        if (aiExplanationReaderState.previewPrefetchKey === cacheKey) {
            aiExplanationReaderState.previewPrefetchAbortController = null;
            aiExplanationReaderState.previewPrefetchPromise = null;
        }
        throw error;
    });
    return aiExplanationReaderState.previewPrefetchPromise;
}

function scheduleAiExplanationVoicePreviewPrime(voiceName = aiExplanationReaderState.settings.geminiVoice) {
    clearAiExplanationPreviewPrime({ abort: false });
    aiExplanationReaderState.previewPrimeTimer = window.setTimeout(() => {
        aiExplanationReaderState.previewPrimeTimer = null;
        void primeAiExplanationVoicePreview(voiceName).catch(() => { });
    }, 180);
}

function cleanupAiExplanationAudioElement() {
    if (typeof aiExplanationReaderState.audioPlayReject === 'function') {
        aiExplanationReaderState.audioPlayReject(new DOMException('Aborted', 'AbortError'));
    }
    aiExplanationReaderState.audioPlayResolve = null;
    aiExplanationReaderState.audioPlayReject = null;
    stopAiExplanationOrbMeter();
    if (aiExplanationReaderState.audioElement) {
        aiExplanationReaderState.audioElement.pause();
        aiExplanationReaderState.audioElement.onended = null;
        aiExplanationReaderState.audioElement.onerror = null;
        aiExplanationReaderState.audioElement.onpause = null;
        aiExplanationReaderState.audioElement.src = '';
    }
    if (aiExplanationReaderState.audioObjectUrl) {
        try { URL.revokeObjectURL(aiExplanationReaderState.audioObjectUrl); } catch (_err) { }
    }
    aiExplanationReaderState.audioObjectUrl = '';
}

function getAiExplanationAudioElement() {
    if (!aiExplanationReaderState.audioElement) {
        aiExplanationReaderState.audioElement = new Audio();
        aiExplanationReaderState.audioElement.preload = 'auto';
    }
    return aiExplanationReaderState.audioElement;
}

function computeAiExplanationVoiceOrbSignalFromAnalyser(analyser, freqData, timeData) {
    if (!analyser || !freqData || !timeData) {
        return { level: 0, shift: 0.5 };
    }
    analyser.getByteFrequencyData(freqData);
    analyser.getByteTimeDomainData(timeData);

    let sum = 0;
    let weighted = 0;
    for (let i = 0; i < freqData.length; i++) {
        const value = freqData[i] / 255;
        sum += value;
        weighted += value * i;
    }
    const energy = sum / Math.max(1, freqData.length);
    const shift = sum > 0 ? (weighted / sum) / freqData.length : 0.5;

    let rms = 0;
    for (let i = 0; i < timeData.length; i++) {
        const sample = (timeData[i] - 128) / 128;
        rms += sample * sample;
    }
    rms = Math.sqrt(rms / Math.max(1, timeData.length));
    const level = Math.min(1, Math.max(0, (rms * 1.4) + (energy * 0.6)));

    return { level, shift };
}

function ensureAiExplanationOrbAnalyser(audio) {
    if (!audio) return null;
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return null;
    if (!aiExplanationReaderState.orbContext) {
        aiExplanationReaderState.orbContext = new Ctx();
    }
    const context = aiExplanationReaderState.orbContext;
    if (!aiExplanationReaderState.orbAnalyser || aiExplanationReaderState.orbAnalyser.context !== context) {
        const analyser = context.createAnalyser();
        analyser.fftSize = 1024;
        analyser.smoothingTimeConstant = 0.78;
        analyser.minDecibels = -90;
        analyser.maxDecibels = -10;
        analyser.connect(context.destination);
        aiExplanationReaderState.orbAnalyser = analyser;
        aiExplanationReaderState.orbFreqData = new Uint8Array(analyser.frequencyBinCount);
        aiExplanationReaderState.orbTimeData = new Uint8Array(analyser.fftSize);
    }
    if (!aiExplanationReaderState.orbSource) {
        try {
            aiExplanationReaderState.orbSource = context.createMediaElementSource(audio);
            aiExplanationReaderState.orbSource.connect(aiExplanationReaderState.orbAnalyser);
        } catch (_err) {
            return aiExplanationReaderState.orbAnalyser;
        }
    }
    if (context.state === 'suspended') {
        context.resume().catch(() => { });
    }
    return aiExplanationReaderState.orbAnalyser;
}

function startAiExplanationOrbMeter() {
    if (aiExplanationReaderState.orbMeterRaf) return;
    const tick = () => {
        const audio = aiExplanationReaderState.audioElement;
        if (!audio || audio.paused || !aiExplanationReaderState.orbAnalyser) {
            aiExplanationReaderState.orbMeterRaf = 0;
            window.setMemoraVoiceOrbSignal?.({ level: 0, shift: 0.5 });
            return;
        }
        const signal = computeAiExplanationVoiceOrbSignalFromAnalyser(
            aiExplanationReaderState.orbAnalyser,
            aiExplanationReaderState.orbFreqData,
            aiExplanationReaderState.orbTimeData
        );
        window.setMemoraVoiceOrbSignal?.(signal);
        aiExplanationReaderState.orbMeterRaf = requestAnimationFrame(tick);
    };
    aiExplanationReaderState.orbMeterRaf = requestAnimationFrame(tick);
}

function stopAiExplanationOrbMeter() {
    if (aiExplanationReaderState.orbMeterRaf) {
        cancelAnimationFrame(aiExplanationReaderState.orbMeterRaf);
        aiExplanationReaderState.orbMeterRaf = 0;
    }
    window.setMemoraVoiceOrbSignal?.({ level: 0, shift: 0.5 });
}

/* Reader audio (voice previews and read-aloud) is speech the Astral Veil should show, but it is not
 * a Live turn, so it is flagged beside the modal's Live state rather than overwriting it. */
function setAiExplanationReaderSpeaking(speaking) {
    const modal = document.getElementById('voice-agent-modal');
    if (!modal) return;
    if (speaking) modal.dataset.readerState = 'speaking';
    else delete modal.dataset.readerState;
    window.MemoraVoicePresence?.render?.(0, performance.now(), { force: true });
    window.startMemoraVoiceOrbLoop?.();
}

function bindAiExplanationOrbAudioEvents(audio) {
    if (!audio || audio.dataset.orbBound) return;
    audio.dataset.orbBound = 'true';
    const stop = () => {
        stopAiExplanationOrbMeter();
        setAiExplanationReaderSpeaking(false);
    };
    audio.addEventListener('play', () => {
        startAiExplanationOrbMeter();
        setAiExplanationReaderSpeaking(true);
    });
    audio.addEventListener('pause', () => {
        if (audio.paused) stop();
    });
    audio.addEventListener('ended', stop);
    audio.addEventListener('emptied', stop);
}

// The reader holds a Live gate slot (shared with every Live user of the key) from connect until
// its session closes (plan D-L3); the gate lives in the lazy ai feature, so this is a no-op before it loads.
function releaseAiExplanationLiveSlot() {
    const release = aiExplanationReaderState.releaseLiveSlot;
    aiExplanationReaderState.releaseLiveSlot = null;
    if (typeof release === 'function') release();
}

function closeAiExplanationLiveSession() {
    aiExplanationReaderState.liveReady = false;
    aiExplanationReaderState.liveConnecting = false;
    aiExplanationReaderState.liveVoiceName = '';
    aiExplanationReaderState.liveTurnServerComplete = false;
    aiExplanationReaderState.liveTurnHadAudio = false;
    if (typeof aiExplanationReaderState.liveTurnReject === 'function') {
        aiExplanationReaderState.liveTurnReject(new Error('Gemini Live voice session closed'));
    }
    aiExplanationReaderState.liveTurnResolve = null;
    aiExplanationReaderState.liveTurnReject = null;
    aiExplanationReaderState.liveTurnAudioChunks = [];
    if (aiExplanationReaderState.liveSocket && aiExplanationReaderState.liveSocket.readyState <= 1) {
        try { aiExplanationReaderState.liveSocket.close(1000, 'Reader closed'); } catch (_err) { }
    }
    if (aiExplanationReaderState.liveSession && typeof aiExplanationReaderState.liveSession.close === 'function') {
        try { aiExplanationReaderState.liveSession.close(); } catch (_err) { }
    }
    aiExplanationReaderState.liveSession = null;
    if (typeof releaseAiExplanationLiveSlot === 'function') releaseAiExplanationLiveSlot();
    aiExplanationReaderState.liveSocket = null;
}

async function ensureAiExplanationLivePlaybackContext() {
    if (!aiExplanationReaderState.livePlaybackContext) {
        const Ctx = window.AudioContext || window.webkitAudioContext;
        if (!Ctx) throw new Error('This browser does not support AudioContext playback.');
        aiExplanationReaderState.livePlaybackContext = new Ctx({ sampleRate: GEMINI_TTS_OUTPUT_RATE });
        aiExplanationReaderState.livePlaybackTime = aiExplanationReaderState.livePlaybackContext.currentTime;
    }
    if (aiExplanationReaderState.livePlaybackContext.state === 'suspended') {
        await aiExplanationReaderState.livePlaybackContext.resume();
    }
    return aiExplanationReaderState.livePlaybackContext;
}

function ensureAiExplanationLivePlaybackAnalyser(context) {
    if (!context) return null;
    if (aiExplanationReaderState.livePlaybackAnalyser && aiExplanationReaderState.livePlaybackAnalyser.context === context) {
        return aiExplanationReaderState.livePlaybackAnalyser;
    }
    const analyser = context.createAnalyser();
    analyser.fftSize = 1024;
    analyser.smoothingTimeConstant = 0.78;
    analyser.minDecibels = -90;
    analyser.maxDecibels = -10;
    analyser.connect(context.destination);
    aiExplanationReaderState.livePlaybackAnalyser = analyser;
    aiExplanationReaderState.livePlaybackAnalyserData = new Uint8Array(analyser.frequencyBinCount);
    aiExplanationReaderState.livePlaybackAnalyserTimeData = new Uint8Array(analyser.fftSize);
    return analyser;
}

function hasAiExplanationLivePlaybackActivity() {
    return aiExplanationReaderState.livePlaybackSources.length > 0;
}

function startAiExplanationLivePlaybackMeter() {
    if (aiExplanationReaderState.livePlaybackMeterRaf) return;
    const tick = () => {
        if (!aiExplanationReaderState.livePlaybackAnalyser || !hasAiExplanationLivePlaybackActivity()) {
            aiExplanationReaderState.livePlaybackMeterRaf = 0;
            window.setMemoraVoiceOrbSignal?.({ level: 0, shift: 0.5 });
            return;
        }
        const signal = computeAiExplanationVoiceOrbSignalFromAnalyser(
            aiExplanationReaderState.livePlaybackAnalyser,
            aiExplanationReaderState.livePlaybackAnalyserData,
            aiExplanationReaderState.livePlaybackAnalyserTimeData
        );
        window.setMemoraVoiceOrbSignal?.(signal);
        aiExplanationReaderState.livePlaybackMeterRaf = requestAnimationFrame(tick);
    };
    aiExplanationReaderState.livePlaybackMeterRaf = requestAnimationFrame(tick);
}

function stopAiExplanationLivePlaybackMeter() {
    if (aiExplanationReaderState.livePlaybackMeterRaf) {
        cancelAnimationFrame(aiExplanationReaderState.livePlaybackMeterRaf);
        aiExplanationReaderState.livePlaybackMeterRaf = 0;
    }
    window.setMemoraVoiceOrbSignal?.({ level: 0, shift: 0.5 });
}

async function playAiExplanationLiveAudioChunk(base64Data) {
    if (!base64Data) return;
    const context = await ensureAiExplanationLivePlaybackContext();
    const samples = aiExplanationPcm16BytesToFloat32(aiExplanationBase64ToUint8Array(base64Data));
    if (!samples.length) return;

    const buffer = context.createBuffer(1, samples.length, GEMINI_TTS_OUTPUT_RATE);
    buffer.copyToChannel(samples, 0);
    const source = context.createBufferSource();
    source.buffer = buffer;
    const analyser = ensureAiExplanationLivePlaybackAnalyser(context);
    if (analyser) {
        source.connect(analyser);
    } else {
        source.connect(context.destination);
    }
    const startTime = Math.max(context.currentTime, aiExplanationReaderState.livePlaybackTime || context.currentTime);
    source.start(startTime);
    aiExplanationReaderState.livePlaybackTime = startTime + buffer.duration;
    aiExplanationReaderState.livePlaybackSources.push(source);
    startAiExplanationLivePlaybackMeter();
    source.onended = () => {
        aiExplanationReaderState.livePlaybackSources = aiExplanationReaderState.livePlaybackSources.filter((item) => item !== source);
        if (!hasAiExplanationLivePlaybackActivity()) {
            stopAiExplanationLivePlaybackMeter();
        }
        maybeResolveAiExplanationLiveTurn();
    };
}

function stopAiExplanationLivePlayback() {
    aiExplanationReaderState.livePlaybackSources.forEach((source) => {
        try { source.stop(); } catch (_err) { }
    });
    aiExplanationReaderState.livePlaybackSources = [];
    stopAiExplanationLivePlaybackMeter();
    if (aiExplanationReaderState.livePlaybackContext) {
        aiExplanationReaderState.livePlaybackTime = aiExplanationReaderState.livePlaybackContext.currentTime;
    } else {
        aiExplanationReaderState.livePlaybackTime = 0;
    }
}

function maybeResolveAiExplanationLiveTurn() {
    if (!aiExplanationReaderState.liveTurnServerComplete) return;
    if (typeof aiExplanationReaderState.liveTurnResolve !== 'function') return;
    const done = aiExplanationReaderState.liveTurnResolve;
    const audioBlob = aiExplanationReaderState.liveTurnHadAudio
        ? pcm16ToWaveBlob(concatUint8Arrays(aiExplanationReaderState.liveTurnAudioChunks))
        : null;
    aiExplanationReaderState.liveTurnResolve = null;
    aiExplanationReaderState.liveTurnReject = null;
    aiExplanationReaderState.liveTurnServerComplete = false;
    aiExplanationReaderState.liveTurnHadAudio = false;
    aiExplanationReaderState.liveTurnAudioChunks = [];
    done(audioBlob);
}

function clearAiExplanationReaderDelayTimer({ preserveRemaining = false } = {}) {
    if (aiExplanationReaderState.delayTimerId) {
        clearTimeout(aiExplanationReaderState.delayTimerId);
        aiExplanationReaderState.delayTimerId = null;
        if (preserveRemaining && aiExplanationReaderState.delayStartedAt) {
            const elapsed = Date.now() - aiExplanationReaderState.delayStartedAt;
            aiExplanationReaderState.delayRemainingMs = Math.max(0, Number(aiExplanationReaderState.delayRemainingMs || 0) - elapsed);
        } else if (!preserveRemaining) {
            aiExplanationReaderState.delayRemainingMs = 0;
        }
    } else if (!preserveRemaining) {
        aiExplanationReaderState.delayRemainingMs = 0;
    }
    aiExplanationReaderState.delayStartedAt = 0;
    if (!preserveRemaining) {
        aiExplanationReaderState.pendingContinuationKind = '';
        aiExplanationReaderState.pendingContinuationToken = 0;
    }
}

function scheduleAiExplanationReaderContinuation(kind, requestToken = 0, delayMs = 0) {
    clearAiExplanationReaderDelayTimer();
    aiExplanationReaderState.pendingContinuationKind = kind;
    aiExplanationReaderState.pendingContinuationToken = Number(requestToken || 0);
    aiExplanationReaderState.delayRemainingMs = Math.max(0, Number(delayMs || 0));

    const run = () => {
        aiExplanationReaderState.delayTimerId = null;
        aiExplanationReaderState.delayStartedAt = 0;
        aiExplanationReaderState.delayRemainingMs = 0;
        const nextKind = aiExplanationReaderState.pendingContinuationKind;
        const nextToken = aiExplanationReaderState.pendingContinuationToken;
        aiExplanationReaderState.pendingContinuationKind = '';
        aiExplanationReaderState.pendingContinuationToken = 0;
        if (!aiExplanationReaderState.isPlaying || aiExplanationReaderState.isPaused) return;
        if (nextKind === 'gemini') {
            void speakNextGeminiExplanationChunk(nextToken);
            return;
        }
        speakNextLocalAiExplanationChunk();
    };

    if (aiExplanationReaderState.delayRemainingMs > 0) {
        aiExplanationReaderState.delayStartedAt = Date.now();
        aiExplanationReaderState.delayTimerId = window.setTimeout(run, aiExplanationReaderState.delayRemainingMs);
        return;
    }
    run();
}

function hasAiExplanationReaderResumePoint() {
    return Array.isArray(aiExplanationReaderState.chunks)
        && aiExplanationReaderState.chunks.length > 0
        && aiExplanationReaderState.chunkIndex < aiExplanationReaderState.chunks.length;
}

function formatAiExplanationChunkProgress(index, action = 'Reading') {
    const chunk = getAiExplanationChunkDetails(aiExplanationReaderState.chunks[index]);
    const sectionNumber = Math.max(1, Number(index) + 1);
    const totalSections = Math.max(1, aiExplanationReaderState.chunks.length);
    const slideLabel = Number.isFinite(chunk.slideNumber) && chunk.slideNumber > 0
        ? `slide ${chunk.slideNumber}`
        : `section ${sectionNumber}`;
    return `${action} ${slideLabel} (${sectionNumber} of ${totalSections})`;
}

function announceAiExplanationInterrupt(message, tone = 'pending') {
    const clean = String(message || '').trim();
    if (!clean) return;
    setAiExplanationReaderStatus(clean, tone);
    if (typeof window.setGeminiLiveStatusText === 'function') {
        window.setGeminiLiveStatusText(clean, tone);
    }
}

async function playAiExplanationAudioBlob(blob, { playbackRate = null } = {}) {
    if (!(blob instanceof Blob) || blob.size <= 0) {
        throw new Error('Gemini Live voice did not return playable audio.');
    }
    cleanupAiExplanationAudioElement();
    const audio = getAiExplanationAudioElement();
    const objectUrl = URL.createObjectURL(blob);
    aiExplanationReaderState.audioObjectUrl = objectUrl;
    audio.src = objectUrl;
    audio.currentTime = 0;
    /* An HTMLMediaElement can resample without transposing, so unlike the Live path this one keeps
     * the voice's pitch at 2.0x. defaultPlaybackRate is set as well because loading a new src
     * resets playbackRate back to it. */
    const requestedRate = Number(playbackRate ?? getAiExplanationReaderRateSetting());
    const safeRate = Number.isFinite(requestedRate) && requestedRate > 0
        ? Math.min(2, Math.max(0.5, requestedRate))
        : 1;
    audio.defaultPlaybackRate = safeRate;
    audio.playbackRate = safeRate;
    try {
        audio.preservesPitch = true;
        audio.mozPreservesPitch = true;
        audio.webkitPreservesPitch = true;
    } catch (_err) { }
    ensureAiExplanationOrbAnalyser(audio);
    bindAiExplanationOrbAudioEvents(audio);

    await new Promise((resolve, reject) => {
        aiExplanationReaderState.audioPlayResolve = resolve;
        aiExplanationReaderState.audioPlayReject = reject;

        const clearHandlers = () => {
            audio.onended = null;
            audio.onerror = null;
            aiExplanationReaderState.audioPlayResolve = null;
            aiExplanationReaderState.audioPlayReject = null;
        };

        audio.onended = () => {
            clearHandlers();
            resolve();
        };
        audio.onerror = () => {
            clearHandlers();
            reject(new Error('Gemini Live voice playback failed.'));
        };

        const playPromise = audio.play();
        if (playPromise && typeof playPromise.then === 'function') {
            playPromise.catch((error) => {
                clearHandlers();
                reject(error);
            });
        }
    });
}

async function waitForAiExplanationReaderPause(timeoutMs = 250) {
    const audio = aiExplanationReaderState.audioElement;
    if (!audio || audio.paused) {
        await new Promise((resolve) => window.setTimeout(resolve, 0));
        return;
    }

    await new Promise((resolve) => {
        let settled = false;
        const finish = () => {
            if (settled) return;
            settled = true;
            clearTimeout(timer);
            audio.removeEventListener('pause', finish);
            resolve();
        };
        const timer = window.setTimeout(finish, timeoutMs);
        audio.addEventListener('pause', finish, { once: true });
        try { audio.pause(); } catch (_err) { }
    });
}

function rankAiExplanationVoice(voice) {
    const name = String(voice?.name || '').toLowerCase();
    const lang = String(voice?.lang || '').toLowerCase();
    let score = 0;

    if (lang.startsWith('en-us')) score += 140;
    else if (lang.startsWith('en-gb')) score += 126;
    else if (lang.startsWith('en-au') || lang.startsWith('en-ca')) score += 116;
    else if (lang.startsWith('en')) score += 96;
    else score -= 320;

    if (voice?.default) score += 18;
    if (voice?.localService === false) score += 26;
    if (/neural|natural|online|premium|enhanced|studio|wavenet/.test(name)) score += 68;
    if (/microsoft/.test(name)) score += 24;
    if (/aria|jenny|guy|davis|natasha|sara|ava|emma|andrew|christopher|google us english|samantha|alex|zira/.test(name)) score += 42;
    if (/english/.test(name)) score += 12;

    return score;
}

function getSortedAiExplanationVoices() {
    const speech = getAiExplanationSpeechApi();
    if (!speech) return [];
    return speech.getVoices()
        .slice()
        .sort((a, b) => rankAiExplanationVoice(b) - rankAiExplanationVoice(a) || String(a.name || '').localeCompare(String(b.name || '')));
}

function ensureAiExplanationVoiceInventory() {
    aiExplanationReaderState.voices = getSortedAiExplanationVoices();
    return aiExplanationReaderState.voices;
}

function getPreferredAiExplanationVoice() {
    const voices = ensureAiExplanationVoiceInventory();
    if (!voices.length) return null;
    if (aiExplanationReaderState.settings.voiceURI && aiExplanationReaderState.settings.voiceURI !== 'auto') {
        const selected = voices.find((voice) => voice.voiceURI === aiExplanationReaderState.settings.voiceURI);
        if (selected) return selected;
    }
    return voices[0] || null;
}

function splitAiExplanationSpeechText(text, maxChunkChars = 240) {
    const clean = String(text || '')
        .replace(/\r/g, '')
        .replace(/[ \t]+\n/g, '\n')
        .trim();
    if (!clean) return [];

    const chunks = [];
    const paragraphs = clean
        .split(/\n{2,}/)
        .map((paragraph) => paragraph.replace(/\s+/g, ' ').trim())
        .filter(Boolean);

    const extractSlideNumber = (value) => {
        const match = String(value || '').match(/\b(?:slide|page|pg|section)\s*:?\s*(\d+)\b/i);
        if (!match) return null;
        const parsed = parseInt(match[1], 10);
        return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
    };

    const getParagraphPauseMs = (paragraph) => {
        const compact = String(paragraph || '').trim();
        if (!compact) return 0;
        if (/^(slide|page|section|chapter|part)\b/i.test(compact)) return 960;
        if (compact.length <= 90 && !/[.?!]/.test(compact)) return 880;
        if (/:$/.test(compact)) return 720;
        return 416;
    };

    const pushSentenceChunks = (segment, paragraphPauseMs, paragraphSlideNumber) => {
        const sentences = segment.match(/[^.!?]+[.!?]+|[^.!?]+$/g) || [segment];
        let current = '';
        sentences.forEach((sentence) => {
            const next = sentence.trim();
            if (!next) return;
            const candidate = current ? `${current} ${next}` : next;
            if (candidate.length <= maxChunkChars) {
                current = candidate;
                return;
            }
            if (current) chunks.push({ text: current, pauseMs: 240, slideNumber: paragraphSlideNumber });
            if (next.length <= maxChunkChars) {
                current = next;
                return;
            }
            const words = next.split(/\s+/);
            current = '';
            words.forEach((word) => {
                const wordCandidate = current ? `${current} ${word}` : word;
                if (wordCandidate.length <= maxChunkChars) {
                    current = wordCandidate;
                    return;
                }
                if (current) chunks.push({ text: current, pauseMs: 240, slideNumber: paragraphSlideNumber });
                current = word;
            });
        });
        if (current) chunks.push({ text: current, pauseMs: paragraphPauseMs, slideNumber: paragraphSlideNumber });
    };

    let activeSlideNumber = null;
    paragraphs.forEach((paragraph) => {
        const detectedSlideNumber = extractSlideNumber(paragraph);
        if (Number.isFinite(detectedSlideNumber) && detectedSlideNumber > 0) {
            activeSlideNumber = detectedSlideNumber;
        }
        pushSentenceChunks(paragraph, getParagraphPauseMs(paragraph), activeSlideNumber);
    });
    return chunks.filter(Boolean);
}

function getAiExplanationChunkDetails(chunk) {
    if (chunk && typeof chunk === 'object' && typeof chunk.text === 'string') {
        return {
            text: chunk.text,
            pauseMs: Number(chunk.pauseMs || 0),
            slideNumber: Number.isFinite(Number(chunk.slideNumber)) ? Number(chunk.slideNumber) : null
        };
    }
    return {
        text: String(chunk || '').trim(),
        pauseMs: 0,
        slideNumber: null
    };
}

function normalizeAiExplanationContextText(text, maxChars = 0) {
    const clean = String(text || '')
        .replace(/\s+/g, ' ')
        .trim();
    if (!clean) return '';
    if (maxChars > 0 && clean.length > maxChars) {
        return `${clean.slice(0, Math.max(0, maxChars - 1)).trim()}…`;
    }
    return clean;
}

function getAiExplanationCurrentChunkIndex(chunks = aiExplanationReaderState.chunks) {
    if (!Array.isArray(chunks) || !chunks.length) return -1;
    const rawIndex = Number(aiExplanationReaderState.chunkIndex || 0);
    if (!Number.isFinite(rawIndex)) return 0;
    return Math.max(0, Math.min(chunks.length - 1, Math.floor(rawIndex)));
}

function getAiExplanationSlideCardByNumber(slideNumber) {
    const content = $('ai-expl-content');
    if (!content || !Number.isFinite(slideNumber) || slideNumber < 1) return null;
    const cards = Array.from(content.querySelectorAll('.ai-expl-slide-card'));
    return cards.find((card) => extractAiExplanationSlideNumberFromCard(card) === slideNumber) || null;
}

function getAiExplanationLiveContextSnapshot() {
    const text = String(aiExplanationReaderState.text || '').trim();
    const pdfName = String(aiExplanationReaderState.pdfName || '').trim();
    if (!text || !pdfName) return null;

    const chunks = Array.isArray(aiExplanationReaderState.chunks) && aiExplanationReaderState.chunks.length
        ? aiExplanationReaderState.chunks
        : splitAiExplanationSpeechText(text, 900);
    if (!chunks.length) return null;

    const chunkIndex = getAiExplanationCurrentChunkIndex(chunks);
    if (chunkIndex < 0) return null;
    const details = getAiExplanationChunkDetails(chunks[chunkIndex]);
    const slideNumber = Number.isFinite(details.slideNumber) && details.slideNumber > 0 ? details.slideNumber : null;
    const slideCard = slideNumber ? getAiExplanationSlideCardByNumber(slideNumber) : null;
    let cardHeaderText = '';
    let cardText = '';

    if (slideCard instanceof HTMLElement) {
        cardHeaderText = normalizeAiExplanationContextText(
            slideCard.querySelector('.dd-section-header')?.textContent || '',
            180
        );
        const clone = slideCard.cloneNode(true);
        clone.querySelectorAll('.ai-expl-slide-audio-btn, .ai-expl-slide-expand-btn').forEach((node) => node.remove());
        cardText = normalizeAiExplanationContextText(clone.textContent || '', 1800);
    }

    return {
        pdfName,
        slideNumber,
        chunkIndex,
        totalChunks: chunks.length,
        chunkText: normalizeAiExplanationContextText(details.text || '', 420),
        cardHeaderText,
        cardText,
        readerState: aiExplanationReaderState.interruptedForConversation
            ? 'interrupted'
            : (aiExplanationReaderState.isPaused ? 'paused' : (aiExplanationReaderState.isPlaying ? 'playing' : 'ready'))
    };
}

function scrollAiExplanationReaderCardToSlide(slideNumber, smooth = true) {
    const content = $('ai-expl-content');
    const view = $('ai-expl-view');
    if (!content || !view || !Number.isFinite(slideNumber) || slideNumber < 1) return false;

    const cards = Array.from(content.querySelectorAll('.ai-expl-slide-card'));
    if (!cards.length) return false;

    let exactCard = null;
    let nextCard = null;
    cards.forEach((card) => {
        const cardSlide = extractAiExplanationSlideNumberFromCard(card);
        if (!Number.isFinite(cardSlide) || cardSlide < 1) return;
        if (cardSlide === slideNumber && !exactCard) {
            exactCard = card;
            return;
        }
        if (cardSlide > slideNumber && !nextCard) {
            nextCard = card;
        }
    });

    const targetCard = exactCard || nextCard || cards[cards.length - 1];
    if (!(targetCard instanceof HTMLElement)) return false;
    let stickyOffset = 10;
    if (typeof getAiExplanationStickyHeaderOffset === 'function') {
        try {
            stickyOffset = Math.max(10, Number(getAiExplanationStickyHeaderOffset()) || 10);
        } catch (_err) { }
    }
    const viewRect = view.getBoundingClientRect();
    const targetRect = targetCard.getBoundingClientRect();
    const maxScrollTop = Math.max(0, view.scrollHeight - view.clientHeight);
    const nextScrollTop = Math.max(
        0,
        Math.min(
            maxScrollTop,
            view.scrollTop + (targetRect.top - viewRect.top) - stickyOffset
        )
    );
    view.scrollTo({ top: nextScrollTop, behavior: smooth ? 'smooth' : 'auto' });
    return true;
}

function syncAiExplanationReaderSlideContext(chunk) {
    const details = getAiExplanationChunkDetails(chunk);
    const slideNumber = details.slideNumber;
    if (!Number.isFinite(slideNumber) || slideNumber < 1) return;

    let explanationScrolled = false;
    if (typeof scrollAiExplanationToSlide === 'function') {
        try {
            explanationScrolled = !!scrollAiExplanationToSlide(slideNumber, true);
        } catch (_err) { }
    }
    if (!explanationScrolled) {
        scrollAiExplanationReaderCardToSlide(slideNumber, true);
    }

    if (typeof autoEvidence !== 'undefined' && autoEvidence && aiExplanationReaderState.pdfName && typeof loadPdfInPane === 'function') {
        try {
            loadPdfInPane(aiExplanationReaderState.pdfName, {
                page: slideNumber,
                searchTerm: '',
                smooth: true,
                ensureViewer: false,
                maintainScale: true,
                forceReload: false
            });
        } catch (_err) { }
    }
}

function syncAiExplanationReaderPanelState() {
    const { shell, panelBody } = getAiExplanationReaderElements();
    if (!shell || !panelBody) return;
    aiExplanationReaderState.panelOpen = true;
    shell.dataset.open = 'true';
    panelBody.hidden = false;
    window.syncVoiceAgentModalLayout?.({ preservePosition: true });
}


// An empty status hides the pill: with nothing loaded there is nothing to report, not an absence to name.
function setAiExplanationReaderStatus(text, tone = 'idle') {
    const { status } = getAiExplanationReaderElements();
    if (!status) return;
    const label = String(text || '').trim();
    const preview = status.querySelector('.voice-modal-preview-status');
    if (preview && label === 'Voice Updated') {
        status.querySelector('.voice-modal-status-copy').textContent = label;
        if (window.MemoraMotion?.isReduced?.()) preview.remove();
        else {
            preview.classList.add('is-finishing');
            preview.addEventListener('transitionend', () => preview.remove(), { once: true });
        }
    } else if (label.startsWith('Previewing')) {
        const prefix = document.createElement('span');
        prefix.className = 'voice-modal-preview-status';
        const shimmer = document.createElement('span');
        shimmer.className = 'voice-modal-preview-label';
        shimmer.textContent = 'Previewing';
        const separator = document.createElement('span');
        separator.textContent = ' · ';
        prefix.append(shimmer, separator);
        const copy = document.createElement('span');
        copy.className = 'voice-modal-status-copy';
        copy.textContent = label.replace(/^Previewing\s*(?:·\s*)?/, '');
        status.replaceChildren(prefix, copy);
    } else status.textContent = label;
    status.hidden = !label;
    status.dataset.tone = tone || 'idle';
}

function getAiExplanationReaderElements() {
    const root = $('ai-expl-content');
    return {
        root,
        shell: $('ai-expl-reader-shell'),
        panelToggle: $('ai-expl-reader-toggle'),
        panelBody: $('ai-expl-reader-body'),
        playBtn: $('ai-expl-reader-play-btn'),
        pauseBtn: $('ai-expl-reader-pause-btn'),
        stopBtn: $('ai-expl-reader-stop-btn'),
        readQuestionBtn: $('ai-expl-reader-read-question-btn'),
        interruptBtn: $('ai-expl-reader-interrupt-btn'),
        closeBtn: $('ai-expl-reader-close-btn'),
        voiceSelect: $('ai-expl-reader-voice-select'),
        voiceTrigger: $('ai-expl-reader-voice-trigger'),
        voiceLabel: $('ai-expl-reader-voice-label'),
        voiceMenu: $('ai-expl-reader-voice-menu'),
        rateTrigger: $('ai-expl-reader-rate-trigger'),
        rateLabel: $('ai-expl-reader-rate-label'),
        rateMenu: $('ai-expl-reader-rate-menu'),
        status: $('ai-expl-reader-status'),
        note: $('ai-expl-reader-note')
    };
}

function stopAiExplanationReader({ keepStatus = false } = {}) {
    const speech = getAiExplanationSpeechApi();
    if (speech) {
        try { speech.cancel(); } catch (_err) { }
    }
    if (aiExplanationReaderState.abortController) {
        try { aiExplanationReaderState.abortController.abort(); } catch (_err) { }
    }
    stopAiExplanationLivePlayback();
    closeAiExplanationLiveSession();
    clearAiExplanationReaderDelayTimer();
    cleanupAiExplanationAudioElement();
    aiExplanationReaderState.isPlaying = false;
    aiExplanationReaderState.isPaused = false;
    aiExplanationReaderState.chunks = [];
    aiExplanationReaderState.chunkIndex = 0;
    aiExplanationReaderState.utterance = null;
    aiExplanationReaderState.abortController = null;
    if (aiExplanationReaderState.prefetchAbortController) {
        try { aiExplanationReaderState.prefetchAbortController.abort(); } catch (_err) { }
    }
    aiExplanationReaderState.prefetchAbortController = null;
    aiExplanationReaderState.prefetchedChunkIndex = -1;
    aiExplanationReaderState.prefetchedAudioBlob = null;
    aiExplanationReaderState.prefetchedAudioPromise = null;
    aiExplanationReaderState.interruptedForConversation = false;
    aiExplanationReaderState.resumeAfterInterrupt = false;
    aiExplanationReaderState.resumeAfterPaneHide = false;
    aiExplanationReaderState.requestToken += 1;
    if (!keepStatus) {
        setAiExplanationReaderStatus(aiExplanationReaderState.text ? 'Ready to read' : '', 'idle');
    }
    syncAiExplanationReaderControls();
}

function clearAiExplanationReaderPrefetch({ abort = true } = {}) {
    if (abort && aiExplanationReaderState.prefetchAbortController) {
        try { aiExplanationReaderState.prefetchAbortController.abort(); } catch (_err) { }
    }
    aiExplanationReaderState.prefetchAbortController = null;
    aiExplanationReaderState.prefetchedChunkIndex = -1;
    aiExplanationReaderState.prefetchedAudioBlob = null;
    aiExplanationReaderState.prefetchedAudioPromise = null;
}

function preserveAiExplanationReaderForResume(message = 'Reader paused. Reopen PDF Explanation to resume.') {
    if (!hasAiExplanationReaderResumePoint()) return false;
    if (!aiExplanationReaderState.isPaused && (aiExplanationReaderState.isPlaying || aiExplanationReaderState.abortController || aiExplanationReaderState.delayTimerId)) {
        pauseAiExplanationReader();
    }
    aiExplanationReaderState.resumeAfterPaneHide = true;
    aiExplanationReaderState.interruptedForConversation = false;
    setAiExplanationReaderStatus(message, 'pending');
    syncAiExplanationReaderControls();
    return true;
}

function findAiExplanationChunkIndexForSlide(slideNumber) {
    const targetSlide = Math.max(1, Number(slideNumber) || 0);
    if (!targetSlide) return -1;
    let nextHigherIndex = -1;
    let lastKnownIndex = -1;
    for (let i = 0; i < aiExplanationReaderState.chunks.length; i += 1) {
        const details = getAiExplanationChunkDetails(aiExplanationReaderState.chunks[i]);
        if (!Number.isFinite(details.slideNumber) || details.slideNumber < 1) continue;
        lastKnownIndex = i;
        if (details.slideNumber === targetSlide) return i;
        if (details.slideNumber > targetSlide && nextHigherIndex === -1) {
            nextHigherIndex = i;
        }
    }
    return nextHigherIndex !== -1 ? nextHigherIndex : lastKnownIndex;
}

function getAiExplanationReaderCurrentQuestionStartChunkIndex() {
    if (!String(aiExplanationReaderState.text || '').trim()) return -1;
    if (!Array.isArray(aiExplanationReaderState.chunks) || !aiExplanationReaderState.chunks.length) return -1;

    const hasQuizContext = typeof questions !== 'undefined'
        && Array.isArray(questions)
        && typeof filteredIndices !== 'undefined'
        && Array.isArray(filteredIndices)
        && typeof currentQIndex !== 'undefined';
    if (!hasQuizContext) return -1;

    const questionIndex = Number(filteredIndices[currentQIndex]);
    const question = Number.isInteger(questionIndex) ? questions[questionIndex] : null;
    if (!question) return -1;

    let targetPdf = '';
    if (typeof findBestPdfForQuestion === 'function') {
        try {
            targetPdf = String(findBestPdfForQuestion(question) || '').trim();
        } catch (_err) { }
    }
    if (targetPdf && aiExplanationReaderState.pdfName && targetPdf !== aiExplanationReaderState.pdfName) {
        return -1;
    }

    let targetSlide = 0;
    if (typeof getQuestionCitationInfo === 'function') {
        try {
            targetSlide = Number(getQuestionCitationInfo(question)?.page || 0);
        } catch (_err) { }
    }
    if (!Number.isFinite(targetSlide) || targetSlide < 1) return -1;

    return findAiExplanationChunkIndexForSlide(targetSlide);
}

function jumpAiExplanationReaderToChunk(targetIndex, { autoplay = false } = {}) {
    const nextIndex = Math.max(0, Number(targetIndex) || 0);
    if (!Array.isArray(aiExplanationReaderState.chunks) || nextIndex >= aiExplanationReaderState.chunks.length) {
        setAiExplanationReaderStatus('That slide is not available in this explanation.', 'error');
        syncAiExplanationReaderControls();
        return false;
    }

    const speech = getAiExplanationSpeechApi();
    if (speech) {
        try { speech.cancel(); } catch (_err) { }
    }
    if (aiExplanationReaderState.abortController) {
        try { aiExplanationReaderState.abortController.abort(); } catch (_err) { }
    }
    clearAiExplanationReaderPrefetch();
    clearAiExplanationReaderDelayTimer();
    stopAiExplanationLivePlayback();
    cleanupAiExplanationAudioElement();
    aiExplanationReaderState.utterance = null;
    aiExplanationReaderState.abortController = null;
    aiExplanationReaderState.chunkIndex = nextIndex;
    aiExplanationReaderState.requestToken += 1;
    aiExplanationReaderState.resumeAfterPaneHide = false;

    const chunk = getAiExplanationChunkDetails(aiExplanationReaderState.chunks[nextIndex]);
    syncAiExplanationReaderSlideContext(chunk);

    if (autoplay) {
        aiExplanationReaderState.isPlaying = true;
        aiExplanationReaderState.isPaused = false;
        setAiExplanationReaderStatus(`Jumping to slide ${chunk.slideNumber || '?'}`, 'pending');
        syncAiExplanationReaderControls();
        startAiExplanationReaderPrefetch(nextIndex, aiExplanationReaderState.requestToken);
        void speakNextGeminiExplanationChunk(aiExplanationReaderState.requestToken);
        return true;
    }

    aiExplanationReaderState.isPlaying = false;
    aiExplanationReaderState.isPaused = true;
    setAiExplanationReaderStatus(`Ready to resume from slide ${chunk.slideNumber || '?'}`, 'pending');
    syncAiExplanationReaderControls();
    return true;
}

function beginAiExplanationReaderPlayback({ slideNumber = null, restartFromBeginning = false } = {}) {
    if (!isVoiceAgentAccessibilityEnabled()) {
        setAiExplanationReaderStatus('Voice Agent is off', 'idle');
        syncAiExplanationReaderControls();
        return false;
    }
    const text = String(aiExplanationReaderState.text || '').trim();
    if (!text) {
        setAiExplanationReaderStatus('', 'idle');
        syncAiExplanationReaderControls();
        return false;
    }

    if (!String(getAiExplanationReaderApiKey() || '').trim()) {
        setAiExplanationReaderStatus('Gemini Live Voice needs a saved Gemini API key.', 'error');
        syncAiExplanationReaderControls();
        return false;
    }

    if (window.MemoraVoiceAgent?.stopPlayback) {
        window.MemoraVoiceAgent.stopPlayback({ except: 'explanation', keepStatus: false });
    } else {
        try { window.stopGeminiLiveQuestionReadout?.({ keepStatus: false }); } catch (_err) { }
    }
    stopAiExplanationReader({ keepStatus: true });
    aiExplanationReaderState.chunks = splitAiExplanationSpeechText(text, 900);

    let startChunkIndex = 0;
    if (restartFromBeginning) {
        startChunkIndex = 0;
    } else if (Number.isFinite(Number(slideNumber)) && Number(slideNumber) > 0) {
        const requestedChunkIndex = findAiExplanationChunkIndexForSlide(Number(slideNumber));
        if (requestedChunkIndex < 0) {
            setAiExplanationReaderStatus(`Slide ${Math.max(1, Number(slideNumber) || 0)} was not found in this explanation.`, 'error');
            syncAiExplanationReaderControls();
            return false;
        }
        startChunkIndex = requestedChunkIndex;
    } else {
        const preferredChunkIndex = getAiExplanationReaderCurrentQuestionStartChunkIndex();
        startChunkIndex = preferredChunkIndex >= 0 ? preferredChunkIndex : 0;
    }

    aiExplanationReaderState.interruptedForConversation = false;
    aiExplanationReaderState.resumeAfterPaneHide = false;
    return jumpAiExplanationReaderToChunk(startChunkIndex, { autoplay: true });
}

function skipAiExplanationReaderToSlide(slideNumber) {
    const targetSlide = Math.max(1, Number(slideNumber) || 0);
    if (!targetSlide) {
        setAiExplanationReaderStatus('Enter a valid slide number.', 'error');
        syncAiExplanationReaderControls();
        return false;
    }
    if (!aiExplanationReaderState.chunks.length && aiExplanationReaderState.text) {
        aiExplanationReaderState.chunks = splitAiExplanationSpeechText(aiExplanationReaderState.text, 900);
    }
    const targetIndex = findAiExplanationChunkIndexForSlide(targetSlide);
    if (targetIndex < 0) {
        setAiExplanationReaderStatus(`Slide ${targetSlide} was not found in this explanation.`, 'error');
        syncAiExplanationReaderControls();
        return false;
    }
    const autoplay = aiExplanationReaderState.isPlaying && !aiExplanationReaderState.isPaused;
    return jumpAiExplanationReaderToChunk(targetIndex, { autoplay });
}

function startAiExplanationReaderFromSlideNumber(slideNumber) {
    const targetSlide = Math.max(1, Number(slideNumber) || 0);
    if (!targetSlide) {
        setAiExplanationReaderStatus('No explanation is ready to read yet.', 'error');
        syncAiExplanationReaderControls();
        return false;
    }
    return beginAiExplanationReaderPlayback({ slideNumber: targetSlide });
}

function extractAiExplanationSlideNumberFromCard(card) {
    const explicit = parseInt(card?.dataset?.slideNumber || '', 10);
    if (Number.isFinite(explicit) && explicit > 0) return explicit;
    const headerText = String(card?.querySelector?.('.dd-section-header')?.textContent || '');
    const match = headerText.match(/\b(?:slide|page|section)\s*:?\s*(\d+)\b/i);
    const parsed = match ? parseInt(match[1], 10) : 0;
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
}

function startAiExplanationReaderPrefetch(chunkIndex, requestToken) {
    if (!aiExplanationReaderState.isPlaying || aiExplanationReaderState.isPaused) return;
    if (requestToken !== aiExplanationReaderState.requestToken) return;
    if (chunkIndex >= aiExplanationReaderState.chunks.length) return;
    if (aiExplanationReaderState.prefetchedChunkIndex === chunkIndex) return;

    clearAiExplanationReaderPrefetch();
    const chunk = getAiExplanationChunkDetails(aiExplanationReaderState.chunks[chunkIndex]);
    const cachedBlob = getCachedAiExplanationChunkAudioBlob(chunk, chunkIndex);
    if (cachedBlob instanceof Blob && cachedBlob.size > 0) {
        aiExplanationReaderState.prefetchedChunkIndex = chunkIndex;
        aiExplanationReaderState.prefetchedAudioBlob = cachedBlob;
        aiExplanationReaderState.prefetchedAudioPromise = Promise.resolve(cachedBlob);
        return;
    }
    const abortController = new AbortController();
    aiExplanationReaderState.prefetchAbortController = abortController;
    aiExplanationReaderState.prefetchedChunkIndex = chunkIndex;
    aiExplanationReaderState.prefetchedAudioBlob = null;
    aiExplanationReaderState.prefetchedAudioPromise = requestGeminiExplanationAudioChunk(chunk.text, abortController.signal)
        .then((blob) => {
            if (requestToken !== aiExplanationReaderState.requestToken || aiExplanationReaderState.prefetchedChunkIndex !== chunkIndex) {
                return blob;
            }
            storeAiExplanationChunkAudioBlob(chunk, chunkIndex, blob);
            aiExplanationReaderState.prefetchedAudioBlob = blob;
            return blob;
        })
        .catch((error) => {
            if (error?.name !== 'AbortError') {
                console.warn('Explanation reader prefetch failed:', error);
            }
            if (aiExplanationReaderState.prefetchedChunkIndex === chunkIndex) {
                aiExplanationReaderState.prefetchedAudioBlob = null;
                aiExplanationReaderState.prefetchedAudioPromise = null;
                aiExplanationReaderState.prefetchAbortController = null;
                aiExplanationReaderState.prefetchedChunkIndex = -1;
            }
            return null;
        });
}

function syncAiExplanationReaderControls() {
    const { playBtn, pauseBtn, stopBtn, readQuestionBtn, interruptBtn, voiceTrigger, rateTrigger, note } = getAiExplanationReaderElements();
    const hasText = !!String(aiExplanationReaderState.text || '').trim();
    const hasApiKey = !!String(getAiExplanationReaderApiKey() || '').trim();
    const voiceAgentEnabled = isVoiceAgentAccessibilityEnabled();
    const supported = hasApiKey && voiceAgentEnabled;
    const hasVisibleQuestion = typeof window.getAskMemoraCurrentQuestionInfo === 'function'
        ? !!window.getAskMemoraCurrentQuestionInfo()?.context?.question
        : !!String(els?.qText?.innerText || '').trim();
    const hasResumePoint = hasAiExplanationReaderResumePoint();
    const hasStarted = aiExplanationReaderState.isPlaying || aiExplanationReaderState.isPaused || hasResumePoint;
    const canInterrupt = aiExplanationReaderState.interruptedForConversation
        || aiExplanationReaderState.isPlaying
        || aiExplanationReaderState.isPaused
        || hasResumePoint;

    if (playBtn) {
        playBtn.disabled = !supported || !hasText;
        playBtn.textContent = hasStarted ? 'Restart Explanation' : 'Read Explanation';
    }
    if (pauseBtn) {
        const hasLiveReadout = typeof window.hasGeminiLivePlaybackActivity === 'function'
            ? !!window.hasGeminiLivePlaybackActivity()
            : false;
        const livePaused = typeof window.isGeminiLivePlaybackPaused === 'function'
            ? !!window.isGeminiLivePlaybackPaused()
            : false;
        pauseBtn.hidden = !(hasStarted || hasLiveReadout);
        pauseBtn.disabled = !supported || (!(aiExplanationReaderState.isPlaying || aiExplanationReaderState.isPaused) && !hasLiveReadout);
        pauseBtn.textContent = (aiExplanationReaderState.isPaused || livePaused) ? 'Resume' : 'Pause';
    }
    if (stopBtn) stopBtn.hidden = true;
    if (readQuestionBtn) {
        readQuestionBtn.disabled = !supported || !hasVisibleQuestion;
        readQuestionBtn.textContent = 'Read Question';
    }
    if (interruptBtn) {
        interruptBtn.disabled = !supported || !canInterrupt;
        interruptBtn.textContent = 'I';
        interruptBtn.title = aiExplanationReaderState.interruptedForConversation
            ? 'Resume the explanation reader'
            : 'Interrupt the reader and switch to Gemini Live';
        interruptBtn.setAttribute('aria-label', interruptBtn.title);
    }
    if (voiceTrigger) voiceTrigger.disabled = !supported;
    if (rateTrigger) rateTrigger.disabled = !supported;
    if (note) {
        const hasByokKey = typeof window.hasMemoraVoiceByokKey === 'function'
            ? window.hasMemoraVoiceByokKey()
            : hasApiKey;
        note.textContent = !voiceAgentEnabled
            ? 'Connect Voice Agent to start talking.'
            : (hasByokKey ? '' : 'Voice mode needs your own Gemini API key (Settings > AI).');
    }
    window.refreshGeminiLiveInterruptButton?.();
}

async function triggerAiExplanationReadQuestionShortcutAction() {
    if (!isVoiceAgentAccessibilityEnabled()) return false;
    stopAiExplanationReader({ keepStatus: false });
    if (window.MemoraVoiceAgent?.readQuestion) {
        return window.MemoraVoiceAgent.readQuestion({
            reason: 'voice-reader-read-question-shortcut',
            ensureMicActive: true
        });
    }
    return window.requestGeminiLiveQuestionReadout?.({
        includeChoices: true,
        reason: 'voice-reader-read-question-shortcut',
        ensureMicActive: true
    }) || false;
}

function triggerAiExplanationReadExplanationVoiceAction() {
    if (!isVoiceAgentAccessibilityEnabled()) return false;
    return !!playAiExplanationReader();
}

function getAiExplanationSelectedVoice() {
    const selected = AI_EXPL_GEMINI_VOICES.find((voice) => voice.name === aiExplanationReaderState.settings.geminiVoice);
    return selected || AI_EXPL_GEMINI_VOICES[0] || { name: AI_EXPL_READER_DEFAULT_SETTINGS.geminiVoice, label: AI_EXPL_READER_DEFAULT_SETTINGS.geminiVoice };
}

function getAiExplanationSelectedRateOption() {
    const normalized = normalizeAiExplanationReaderRate(aiExplanationReaderState.settings.rate);
    const selected = AI_EXPL_READER_SPEED_OPTIONS.find((option) => option.value === normalized);
    return selected || AI_EXPL_READER_SPEED_OPTIONS[0];
}

function closeAiExplanationVoiceMenu({ restoreFocus = false } = {}) {
    const { voiceTrigger, voiceMenu } = getAiExplanationReaderElements();
    if (!voiceMenu || voiceMenu.hidden) return;
    voiceMenu.hidden = true;
    voiceMenu.dataset.open = 'false';
    if (voiceTrigger) {
        voiceTrigger.setAttribute('aria-expanded', 'false');
        if (restoreFocus) voiceTrigger.focus();
    }
}

function openAiExplanationVoiceMenu() {
    const { voiceTrigger, voiceMenu } = getAiExplanationReaderElements();
    if (!voiceMenu || !voiceTrigger) return;
    closeAiExplanationSpeedMenu();
    renderAiExplanationVoiceMenu();
    voiceMenu.hidden = false;
    voiceMenu.dataset.open = 'true';
    voiceTrigger.setAttribute('aria-expanded', 'true');
    scheduleAiExplanationVoicePreviewPrime(aiExplanationReaderState.settings.geminiVoice);
}

function toggleAiExplanationVoiceMenu({ restoreFocus = false } = {}) {
    const { voiceMenu } = getAiExplanationReaderElements();
    if (!voiceMenu) return;
    if (voiceMenu.hidden) {
        openAiExplanationVoiceMenu();
        return;
    }
    closeAiExplanationVoiceMenu({ restoreFocus });
}

function renderAiExplanationVoiceMenu() {
    const { voiceLabel, voiceMenu } = getAiExplanationReaderElements();
    if (voiceLabel) {
        voiceLabel.textContent = getAiExplanationSelectedVoice().label;
    }
    if (!voiceMenu) return;
    voiceMenu.innerHTML = '';

    AI_EXPL_GEMINI_VOICES.forEach((voice) => {
        const row = document.createElement('div');
        row.className = 'ai-expl-reader-voice-option';
        row.dataset.selected = voice.name === aiExplanationReaderState.settings.geminiVoice ? 'true' : 'false';

        const optionBtn = document.createElement('button');
        optionBtn.type = 'button';
        optionBtn.className = 'ai-expl-reader-voice-option-btn';
        optionBtn.dataset.voice = voice.name;
        optionBtn.textContent = voice.label;
        optionBtn.setAttribute('aria-pressed', voice.name === aiExplanationReaderState.settings.geminiVoice ? 'true' : 'false');

        const previewBtn = document.createElement('button');
        previewBtn.type = 'button';
        previewBtn.className = 'ai-expl-reader-voice-preview-btn';
        previewBtn.dataset.voice = voice.name;
        previewBtn.title = `Preview ${voice.label}`;
        previewBtn.setAttribute('aria-label', `Preview ${voice.label}`);
        previewBtn.innerHTML = '&#128266;';

        row.appendChild(optionBtn);
        row.appendChild(previewBtn);
        voiceMenu.appendChild(row);
    });
}

function populateAiExplanationVoiceSelect() {
    renderAiExplanationVoiceMenu();
}

function selectAiExplanationReaderVoice(voiceName, { restoreFocus = true } = {}) {
    aiExplanationReaderState.settings.geminiVoice = String(
        voiceName || AI_EXPL_READER_DEFAULT_SETTINGS.geminiVoice
    ).trim() || AI_EXPL_READER_DEFAULT_SETTINGS.geminiVoice;
    persistAiExplanationReaderSettings();
    closeAiExplanationVoiceMenu({ restoreFocus });
    populateAiExplanationVoiceSelect();
    renderVoiceModalCard();
    setAiExplanationReaderStatus(
        aiExplanationReaderState.isPlaying ? 'Voice updated for the next read' : 'Voice Updated',
        'idle'
    );
    syncAiExplanationReaderControls();
    scheduleAiExplanationVoicePreviewPrime(aiExplanationReaderState.settings.geminiVoice);
    // An open Voice conversation picks up the new voice at its next pause.
    if (typeof window.syncGeminiLiveDeliverySettings === 'function') window.syncGeminiLiveDeliverySettings();
}

function closeAiExplanationSpeedMenu({ restoreFocus = false } = {}) {
    const { rateTrigger, rateMenu } = getAiExplanationReaderElements();
    if (!rateMenu || rateMenu.hidden) return;
    rateMenu.hidden = true;
    rateMenu.dataset.open = 'false';
    if (rateTrigger) {
        rateTrigger.setAttribute('aria-expanded', 'false');
        if (restoreFocus) rateTrigger.focus();
    }
}

function openAiExplanationSpeedMenu() {
    const { rateTrigger, rateMenu } = getAiExplanationReaderElements();
    if (!rateMenu || !rateTrigger) return;
    closeAiExplanationVoiceMenu();
    renderAiExplanationSpeedMenu();
    rateMenu.hidden = false;
    rateMenu.dataset.open = 'true';
    rateTrigger.setAttribute('aria-expanded', 'true');
}

function toggleAiExplanationSpeedMenu({ restoreFocus = false } = {}) {
    const { rateMenu } = getAiExplanationReaderElements();
    if (!rateMenu) return;
    if (rateMenu.hidden) {
        openAiExplanationSpeedMenu();
        return;
    }
    closeAiExplanationSpeedMenu({ restoreFocus });
}

function renderAiExplanationSpeedMenu() {
    const { rateLabel, rateMenu } = getAiExplanationReaderElements();
    const selected = getAiExplanationSelectedRateOption();
    if (rateLabel) {
        rateLabel.textContent = selected.label;
    }
    if (!rateMenu) return;
    rateMenu.innerHTML = '';

    AI_EXPL_READER_SPEED_OPTIONS.forEach((option) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'ai-expl-reader-speed-option';
        button.dataset.rate = option.value;
        button.dataset.selected = option.value === selected.value ? 'true' : 'false';
        button.setAttribute('role', 'menuitemradio');
        button.setAttribute('aria-checked', option.value === selected.value ? 'true' : 'false');
        button.textContent = option.label;
        rateMenu.appendChild(button);
    });
}

function selectAiExplanationReaderRate(rateValue, { restoreFocus = true } = {}) {
    const nextRate = normalizeAiExplanationReaderRate(rateValue);
    aiExplanationReaderState.settings.rate = nextRate;
    persistAiExplanationReaderSettings();
    closeAiExplanationSpeedMenu({ restoreFocus });
    renderAiExplanationSpeedMenu();
    renderVoiceModalCard();
    /* Live playback reads the rate per chunk, so a change lands on the very next chunk of an
     * answer already being spoken rather than waiting for the next question. */
    setAiExplanationReaderStatus(`Speed ${getAiExplanationSelectedRateOption().label}`, 'idle');
    syncAiExplanationReaderControls();
    // An open Voice conversation is told the new delivery tempo.
    if (typeof window.syncGeminiLiveDeliverySettings === 'function') window.syncGeminiLiveDeliverySettings();
}

async function requestGeminiExplanationAudioChunk(text, signal, retryAttempt = 0, voiceOverride = '') {
    const apiKey = String(getAiExplanationReaderApiKey() || '').trim();
    const requestedVoice = String(voiceOverride || aiExplanationReaderState.settings.geminiVoice || AI_EXPL_READER_DEFAULT_SETTINGS.geminiVoice).trim()
        || AI_EXPL_READER_DEFAULT_SETTINGS.geminiVoice;
    if (!apiKey) {
        if (typeof showPopup === 'function') {
            showPopup('Please set your Gemini API key first', null, true);
        }
        if (typeof openAPIKeyModal === 'function') {
            openAPIKeyModal();
        }
        throw new Error('Gemini API key required');
    }

    if (signal?.aborted) throw new DOMException('Aborted', 'AbortError');
    if (!aiExplanationReaderState.liveSdkPromise) {
        // The shared loader, so this session is counted with every other Live session on the key.
        aiExplanationReaderState.liveSdkPromise = typeof loadGeminiLiveSdk === 'function'
            ? loadGeminiLiveSdk()
            : import('https://esm.sh/@google/genai@2.19.0');
    }
    const sdk = await aiExplanationReaderState.liveSdkPromise;
    const GoogleGenAI = sdk?.GoogleGenAI;
    if (!GoogleGenAI) {
        throw new Error('Failed to load Gemini Live SDK');
    }

    if (aiExplanationReaderState.liveSession && aiExplanationReaderState.liveReady && aiExplanationReaderState.liveVoiceName && aiExplanationReaderState.liveVoiceName !== requestedVoice) {
        closeAiExplanationLiveSession();
    }

    if (!aiExplanationReaderState.liveSession || !aiExplanationReaderState.liveReady) {
        if (aiExplanationReaderState.liveConnecting) {
            /* Another request owns the connection. Wait for it to settle either way and start over:
             * its session may already be the voice wanted, or it failed or was cancelled, and then
             * this request connects its own rather than reporting the other one's failure. */
            await new Promise((resolve, reject) => {
                const startedAt = Date.now();
                const timer = setInterval(() => {
                    if (signal?.aborted) {
                        clearInterval(timer);
                        reject(new DOMException('Aborted', 'AbortError'));
                        return;
                    }
                    if (!aiExplanationReaderState.liveConnecting) {
                        clearInterval(timer);
                        resolve();
                        return;
                    }
                    if (Date.now() - startedAt > 15000) {
                        clearInterval(timer);
                        reject(new Error('Gemini Live voice connection timed out'));
                    }
                }, 60);
            });
            return requestGeminiExplanationAudioChunk(text, signal, retryAttempt, requestedVoice);
        } else {
            aiExplanationReaderState.liveConnecting = true;
            aiExplanationReaderState.liveReady = false;
            const connectionId = aiExplanationReaderState.liveConnectionId + 1;
            aiExplanationReaderState.liveConnectionId = connectionId;
            if (typeof releaseAiExplanationLiveSlot === 'function') releaseAiExplanationLiveSlot();
            try {
                aiExplanationReaderState.releaseLiveSlot = typeof holdMemoraLiveSlot === 'function'
                    ? await holdMemoraLiveSlot(apiKey, { urgent: true, signal })
                    : null;
            } catch (error) {
                aiExplanationReaderState.liveConnecting = false;
                throw error;
            }
            const ai = new GoogleGenAI({
                apiKey,
                httpOptions: {
                    apiVersion: GEMINI_TTS_API_VERSION
                }
            });
            const readyPromise = new Promise((resolve, reject) => {
                let setupReceived = false;
                let sessionReceived = false;
                let setupFailed = false;
                let setupDone = false;
                const finishSetup = () => {
                    if (setupFailed || connectionId !== aiExplanationReaderState.liveConnectionId || !setupReceived || !sessionReceived) return;
                    clearTimeout(timeout);
                    setupDone = true;
                    aiExplanationReaderState.liveReady = true;
                    aiExplanationReaderState.liveConnecting = false;
                    resolve();
                };
                const timeout = setTimeout(() => {
                    setupFailed = true;
                    if (connectionId === aiExplanationReaderState.liveConnectionId) closeAiExplanationLiveSession();
                    reject(new Error('Gemini Live voice connection timed out'));
                }, 15000);
                /* A newer selection cancels this one mid-setup: retire the connection id at once, so
                 * its late setup, error and close callbacks are ignored and the handle it still
                 * delivers is closed, and the next voice connects without waiting. After setup the
                 * turn's own abort handling applies and the session stays open for reuse. */
                signal?.addEventListener?.('abort', () => {
                    if (setupDone || setupFailed || connectionId !== aiExplanationReaderState.liveConnectionId) return;
                    setupFailed = true;
                    clearTimeout(timeout);
                    aiExplanationReaderState.liveConnectionId += 1;
                    closeAiExplanationLiveSession();
                    reject(new DOMException('Aborted', 'AbortError'));
                }, { once: true });
                aiExplanationReaderState.liveTurnResolve = null;
                aiExplanationReaderState.liveTurnReject = null;
                aiExplanationReaderState.liveTurnServerComplete = false;
                aiExplanationReaderState.liveTurnHadAudio = false;
                aiExplanationReaderState.liveTurnAudioChunks = [];
                ai.live.connect({
                    model: GEMINI_TTS_MODEL,
                    config: {
                        responseModalities: [sdk.Modality.AUDIO],
                        speechConfig: {
                            voiceConfig: {
                                prebuiltVoiceConfig: {
                                    voiceName: requestedVoice
                                }
                            }
                        },
                        systemInstruction: {
                            parts: [{
                                text: 'You are Memoraful Voice Reader. Read the provided text aloud exactly as written. Do not add commentary, answers, summaries, or extra framing. Speak only the provided text in audio.'
                            }]
                        }
                    },
                    callbacks: {
                        onmessage: (message) => {
                            if (connectionId !== aiExplanationReaderState.liveConnectionId) return;
                            const payload = message?.data && typeof message.data === 'object' ? message.data : message;
                            if (payload?.setupComplete) {
                                setupReceived = true;
                                finishSetup();
                                return;
                            }
                            const serverContent = payload?.serverContent;
                            if (!serverContent) return;
                            const parts = Array.isArray(serverContent.modelTurn?.parts) ? serverContent.modelTurn.parts : [];
                            parts.forEach((part) => {
                                const audioBase64 = part?.inlineData?.data || part?.data || '';
                                if (audioBase64) {
                                    aiExplanationReaderState.liveTurnHadAudio = true;
                                    aiExplanationReaderState.liveTurnAudioChunks.push(aiExplanationBase64ToUint8Array(audioBase64));
                                }
                            });
                            if (serverContent.turnComplete || serverContent.generationComplete) {
                                aiExplanationReaderState.liveTurnServerComplete = true;
                                if (!aiExplanationReaderState.liveTurnHadAudio) {
                                    maybeResolveAiExplanationLiveTurn();
                                } else {
                                    window.setTimeout(() => {
                                        maybeResolveAiExplanationLiveTurn();
                                    }, 0);
                                }
                            }
                        },
                        onerror: (event) => {
                            if (connectionId !== aiExplanationReaderState.liveConnectionId) return;
                            setupFailed = true;
                            clearTimeout(timeout);
                            aiExplanationReaderState.liveConnecting = false;
                            aiExplanationReaderState.liveReady = false;
                            reject(new Error(event?.message || event?.error?.message || 'Gemini Live voice connection failed'));
                        },
                        onclose: (event) => {
                            if (connectionId !== aiExplanationReaderState.liveConnectionId) return;
                            setupFailed = true;
                            clearTimeout(timeout);
                            aiExplanationReaderState.liveConnecting = false;
                            aiExplanationReaderState.liveReady = false;
                            aiExplanationReaderState.liveSession = null;
                            if (typeof releaseAiExplanationLiveSlot === 'function') releaseAiExplanationLiveSlot();
                            aiExplanationReaderState.liveSocket = null;
                            /* The close frame carries the only useful text Google sends - the quota,
                             * key or model rejection. Dropping it left the connect promise to time
                             * out into a bare "voice is not ready", which reads as an app bug rather
                             * than an account limit. */
                            const closeCode = Number(event?.code || 0);
                            const closeReason = String(event?.reason || '').trim();
                            const closeError = new Error(closeReason
                                ? `Gemini Live voice closed (${closeCode}): ${closeReason}`
                                : `Gemini Live voice closed (${closeCode})`);
                            if (typeof aiExplanationReaderState.liveTurnReject === 'function') {
                                const fail = aiExplanationReaderState.liveTurnReject;
                                aiExplanationReaderState.liveTurnResolve = null;
                                aiExplanationReaderState.liveTurnReject = null;
                                fail(closeError);
                            }
                            // A close before setupComplete never settles the connect promise on its own.
                            reject(closeError);
                        }
                    }
                }).then((session) => {
                    if (setupFailed || connectionId !== aiExplanationReaderState.liveConnectionId) {
                        try { session?.close?.(); } catch (_err) { }
                        reject(new DOMException('Voice preview was replaced', 'AbortError'));
                        return;
                    }
                    aiExplanationReaderState.liveSession = session;
                    aiExplanationReaderState.liveVoiceName = requestedVoice;
                    aiExplanationReaderState.liveSocket = session?.conn || null;
                    sessionReceived = true;
                    finishSetup();
                }).catch((error) => {
                    if (typeof releaseAiExplanationLiveSlot === 'function') releaseAiExplanationLiveSlot();
                    clearTimeout(timeout);
                    aiExplanationReaderState.liveConnecting = false;
                    aiExplanationReaderState.liveReady = false;
                    reject(error);
                });
            });
            await readyPromise;
        }
    }

    if (signal?.aborted) throw new DOMException('Aborted', 'AbortError');
    if (!aiExplanationReaderState.liveSession || !aiExplanationReaderState.liveReady) {
        throw new Error('Gemini Live voice connection ended before playback. Try the voice again.');
    }
    if (aiExplanationReaderState.liveVoiceName !== requestedVoice) {
        closeAiExplanationLiveSession();
        return requestGeminiExplanationAudioChunk(text, signal, retryAttempt, requestedVoice);
    }

    const audioBlob = await new Promise((resolve, reject) => {
        aiExplanationReaderState.liveTurnServerComplete = false;
        aiExplanationReaderState.liveTurnHadAudio = false;
        aiExplanationReaderState.liveTurnAudioChunks = [];
        aiExplanationReaderState.liveTurnResolve = resolve;
        aiExplanationReaderState.liveTurnReject = reject;
        if (signal) {
            signal.addEventListener('abort', () => {
                if (typeof aiExplanationReaderState.liveTurnReject === 'function') {
                    const fail = aiExplanationReaderState.liveTurnReject;
                    aiExplanationReaderState.liveTurnResolve = null;
                    aiExplanationReaderState.liveTurnReject = null;
                    aiExplanationReaderState.liveTurnAudioChunks = [];
                    fail(new DOMException('Aborted', 'AbortError'));
                }
            }, { once: true });
        }
        aiExplanationReaderState.liveSession.sendRealtimeInput({
            text: buildGeminiExplanationSpeechPrompt(text)
        });
    });
    if (!(audioBlob instanceof Blob) || audioBlob.size <= 0) {
        if (signal?.aborted) {
            throw new DOMException('Aborted', 'AbortError');
        }
        if (retryAttempt < 1) {
            closeAiExplanationLiveSession();
            return requestGeminiExplanationAudioChunk(text, signal, retryAttempt + 1, requestedVoice);
        }
        throw new Error('Gemini Live voice did not return playable audio.');
    }
    return audioBlob;
}

function buildGeminiExplanationSpeechPrompt(text) {
    const cleanText = String(text || '').trim();
    /* Speed is applied to the returned audio in playAiExplanationAudioBlob. Asking the model to
     * hurry as well would stack on top of that and make 2.0x unlistenable. */
    const speed = Number(aiExplanationReaderState.settings.rate || '1');
    const paceInstruction = Number.isFinite(speed) && speed > 0 && speed < 1
        ? 'Speak slowly and clearly, with extra spacing for study review.'
        : 'Speak at a natural study pace.';

    return `Read the following text aloud exactly as written in a clean, high-yield tutoring tone. ${paceInstruction} Do not add extra commentary before or after the text.\n\n${cleanText}`;
}

function buildAiExplanationVoiceSampleText(voiceOverride = '') {
    const voiceName = String(voiceOverride || aiExplanationReaderState.settings.geminiVoice || AI_EXPL_READER_DEFAULT_SETTINGS.geminiVoice).trim()
        || AI_EXPL_READER_DEFAULT_SETTINGS.geminiVoice;
    return `Hi, I’m ${voiceName}. Nice to meet you.`;
}

function speakNextLocalAiExplanationChunk() {
    const speech = getAiExplanationSpeechApi();
    if (!speech || !aiExplanationReaderState.isPlaying) return;

    if (aiExplanationReaderState.chunkIndex >= aiExplanationReaderState.chunks.length) {
        aiExplanationReaderState.isPlaying = false;
        aiExplanationReaderState.isPaused = false;
        aiExplanationReaderState.utterance = null;
        setAiExplanationReaderStatus('Finished reading', 'live');
        syncAiExplanationReaderControls();
        return;
    }

    const chunk = getAiExplanationChunkDetails(aiExplanationReaderState.chunks[aiExplanationReaderState.chunkIndex]);
    syncAiExplanationReaderSlideContext(chunk);
    const utterance = new SpeechSynthesisUtterance(chunk.text);
    const voice = getPreferredAiExplanationVoice();
    if (voice) {
        utterance.voice = voice;
        utterance.lang = voice.lang || 'en-US';
    } else {
        utterance.lang = 'en-US';
    }
    utterance.rate = Number(aiExplanationReaderState.settings.rate || '1');
    utterance.pitch = 1;
    utterance.onend = () => {
        if (!aiExplanationReaderState.isPlaying || aiExplanationReaderState.isPaused) return;
        aiExplanationReaderState.chunkIndex += 1;
        const delayMs = Math.max(0, chunk.pauseMs || 0);
        if (delayMs > 0) {
            setAiExplanationReaderStatus(`Pausing ${Math.round(delayMs / 100) / 10}s before the next section`, 'pending');
            syncAiExplanationReaderControls();
            scheduleAiExplanationReaderContinuation('local', 0, delayMs);
            return;
        }
        scheduleAiExplanationReaderContinuation('local', 0, 0);
    };
    utterance.onerror = (event) => {
        console.warn('PDF explanation voice reader failed:', event);
        aiExplanationReaderState.isPlaying = false;
        aiExplanationReaderState.isPaused = false;
        aiExplanationReaderState.utterance = null;
        setAiExplanationReaderStatus('Voice playback failed', 'error');
        syncAiExplanationReaderControls();
    };

    aiExplanationReaderState.utterance = utterance;
    const currentNumber = aiExplanationReaderState.chunkIndex + 1;
    setAiExplanationReaderStatus(`Reading section ${currentNumber} of ${aiExplanationReaderState.chunks.length}`, 'live');
    syncAiExplanationReaderControls();
    speech.speak(utterance);
}

async function speakNextGeminiExplanationChunk(requestToken) {
    if (!aiExplanationReaderState.isPlaying || aiExplanationReaderState.settings.engine !== AI_EXPL_READER_ENGINES.GEMINI) return;

    if (aiExplanationReaderState.chunkIndex >= aiExplanationReaderState.chunks.length) {
        aiExplanationReaderState.isPlaying = false;
        aiExplanationReaderState.isPaused = false;
        aiExplanationReaderState.abortController = null;
        setAiExplanationReaderStatus('Finished reading', 'live');
        syncAiExplanationReaderControls();
        return;
    }

    const currentIndex = aiExplanationReaderState.chunkIndex;

    try {
        const chunk = getAiExplanationChunkDetails(aiExplanationReaderState.chunks[currentIndex]);
        syncAiExplanationReaderSlideContext(chunk);
        let audioBlob = getCachedAiExplanationChunkAudioBlob(chunk, currentIndex);
        if (aiExplanationReaderState.prefetchedChunkIndex === currentIndex) {
            setAiExplanationReaderStatus(formatAiExplanationChunkProgress(currentIndex, 'Preparing audio for'), 'pending');
            syncAiExplanationReaderControls();
            audioBlob = aiExplanationReaderState.prefetchedAudioBlob
                || (aiExplanationReaderState.prefetchedAudioPromise ? await aiExplanationReaderState.prefetchedAudioPromise : null);
            aiExplanationReaderState.prefetchAbortController = null;
            aiExplanationReaderState.prefetchedAudioBlob = null;
            aiExplanationReaderState.prefetchedAudioPromise = null;
            aiExplanationReaderState.prefetchedChunkIndex = -1;
        }
        if (!(audioBlob instanceof Blob) || audioBlob.size <= 0) {
            aiExplanationReaderState.abortController = new AbortController();
            setAiExplanationReaderStatus(formatAiExplanationChunkProgress(currentIndex, 'Generating audio for'), 'pending');
            syncAiExplanationReaderControls();
            audioBlob = await requestGeminiExplanationAudioChunk(
                chunk.text,
                aiExplanationReaderState.abortController.signal
            );
            storeAiExplanationChunkAudioBlob(chunk, currentIndex, audioBlob);
        }
        if (requestToken !== aiExplanationReaderState.requestToken || !aiExplanationReaderState.isPlaying) return;
        aiExplanationReaderState.abortController = null;
        startAiExplanationReaderPrefetch(currentIndex + 1, requestToken);
        setAiExplanationReaderStatus(formatAiExplanationChunkProgress(currentIndex, 'Reading'), 'live');
        syncAiExplanationReaderControls();
        await playAiExplanationAudioBlob(audioBlob);
        if (requestToken !== aiExplanationReaderState.requestToken || !aiExplanationReaderState.isPlaying || aiExplanationReaderState.isPaused) return;
        aiExplanationReaderState.chunkIndex += 1;
        if (aiExplanationReaderState.chunkIndex >= aiExplanationReaderState.chunks.length) {
            aiExplanationReaderState.isPlaying = false;
            aiExplanationReaderState.isPaused = false;
            setAiExplanationReaderStatus('Finished reading', 'live');
            syncAiExplanationReaderControls();
            return;
        }
        const delayMs = Math.max(0, chunk.pauseMs || 0);
        if (delayMs > 0) {
            setAiExplanationReaderStatus(`Pausing ${Math.round(delayMs / 100) / 10}s before the next section`, 'pending');
            syncAiExplanationReaderControls();
            scheduleAiExplanationReaderContinuation('gemini', requestToken, delayMs);
            return;
        }
        scheduleAiExplanationReaderContinuation('gemini', requestToken, 0);
    } catch (error) {
        if (error?.name === 'AbortError') return;
        console.error('Gemini explanation voice error:', error);
        aiExplanationReaderState.isPlaying = false;
        aiExplanationReaderState.isPaused = false;
        aiExplanationReaderState.abortController = null;
        clearAiExplanationReaderPrefetch();
        setAiExplanationReaderStatus(error?.message || 'Gemini voice failed', 'error');
        syncAiExplanationReaderControls();
    }
}

function resumeAiExplanationReader() {
    if (!aiExplanationReaderState.isPaused) return;

    aiExplanationReaderState.isPaused = false;
    aiExplanationReaderState.isPlaying = true;
    aiExplanationReaderState.resumeAfterPaneHide = false;
    if (aiExplanationReaderState.pendingContinuationKind) {
        const nextKind = aiExplanationReaderState.pendingContinuationKind;
        const nextToken = aiExplanationReaderState.pendingContinuationToken;
        const remainingMs = Math.max(0, Number(aiExplanationReaderState.delayRemainingMs || 0));
        setAiExplanationReaderStatus(
            remainingMs > 0
                ? `Pausing ${Math.round(remainingMs / 100) / 10}s before the next section`
                : formatAiExplanationChunkProgress(aiExplanationReaderState.chunkIndex, 'Reading'),
            remainingMs > 0 ? 'pending' : 'live'
        );
        syncAiExplanationReaderControls();
        scheduleAiExplanationReaderContinuation(nextKind, nextToken, remainingMs);
        return;
    }
    const audio = aiExplanationReaderState.audioElement;
    if (audio && audio.src && audio.paused && audio.currentTime > 0 && (!Number.isFinite(audio.duration) || audio.currentTime < audio.duration)) {
        setAiExplanationReaderStatus(formatAiExplanationChunkProgress(aiExplanationReaderState.chunkIndex, 'Reading'), 'live');
        syncAiExplanationReaderControls();
        void audio.play().catch((error) => {
            console.error('Gemini explanation resume failed:', error);
            setAiExplanationReaderStatus(error?.message || 'Resume failed', 'error');
            syncAiExplanationReaderControls();
        });
        return;
    }
    setAiExplanationReaderStatus(formatAiExplanationChunkProgress(aiExplanationReaderState.chunkIndex, 'Generating audio for'), 'pending');
    syncAiExplanationReaderControls();
    aiExplanationReaderState.requestToken += 1;
    void speakNextGeminiExplanationChunk(aiExplanationReaderState.requestToken);
}

function playAiExplanationReader() {
    const hasStarted = aiExplanationReaderState.isPlaying || aiExplanationReaderState.isPaused || hasAiExplanationReaderResumePoint();
    return beginAiExplanationReaderPlayback({ restartFromBeginning: hasStarted });
}

function pauseAiExplanationReader() {
    if (aiExplanationReaderState.isPaused) {
        resumeAiExplanationReader();
        return true;
    }
    if (!aiExplanationReaderState.isPlaying) return false;

    clearAiExplanationReaderDelayTimer({ preserveRemaining: true });
    aiExplanationReaderState.isPaused = true;
    if (aiExplanationReaderState.abortController) {
        try { aiExplanationReaderState.abortController.abort(); } catch (_err) { }
        aiExplanationReaderState.abortController = null;
    }
    if (aiExplanationReaderState.audioElement && !aiExplanationReaderState.audioElement.paused) {
        try { aiExplanationReaderState.audioElement.pause(); } catch (_err) { }
    }
    setAiExplanationReaderStatus('Paused', 'pending');
    syncAiExplanationReaderControls();
    return true;
}

async function toggleAiExplanationInterrupt() {
    const hasResumePoint = hasAiExplanationReaderResumePoint();
    if (aiExplanationReaderState.interruptedForConversation) {
        announceAiExplanationInterrupt('Resuming the explanation reader...', 'pending');
        aiExplanationReaderState.interruptedForConversation = false;
        aiExplanationReaderState.resumeAfterInterrupt = true;
        if (window.MemoraVoiceAgent?.disconnect) {
            await window.MemoraVoiceAgent.disconnect({ keepMessages: true });
        } else if (typeof window.disconnectGeminiLiveConversation === 'function') {
            await window.disconnectGeminiLiveConversation({ keepMessages: true });
        } else {
            const disconnectBtn = $('ai-live-disconnect-btn');
            if (disconnectBtn && !disconnectBtn.disabled) {
                disconnectBtn.click();
            } else {
                const micStopBtn = $('ai-live-mic-stop-btn');
                if (micStopBtn && !micStopBtn.disabled) {
                    micStopBtn.click();
                }
            }
        }
        persistAiPaneMode(AI_PANE_MODE_PDF_EXPLANATION);
        await syncAiPaneModeView(AI_PANE_MODE_PDF_EXPLANATION, aiExplanationReaderState.pdfName || '');
        aiExplanationReaderState.resumeAfterInterrupt = false;
        if (hasResumePoint) {
            resumeAiExplanationReader();
        } else {
            setAiExplanationReaderStatus(aiExplanationReaderState.text ? 'Ready to read' : '', 'idle');
            syncAiExplanationReaderControls();
        }
        window.refreshGeminiLiveInterruptButton?.();
        return;
    }

    if (!hasResumePoint && !aiExplanationReaderState.isPlaying && !aiExplanationReaderState.isPaused) {
        announceAiExplanationInterrupt('Start the reader first, then interrupt into Gemini Live.', 'pending');
        syncAiExplanationReaderControls();
        return;
    }

    announceAiExplanationInterrupt('Interrupting the reader and opening Gemini Live...', 'pending');
    if (!aiExplanationReaderState.isPaused && aiExplanationReaderState.isPlaying) {
        pauseAiExplanationReader();
        await waitForAiExplanationReaderPause();
    }
    aiExplanationReaderState.interruptedForConversation = true;
    setAiExplanationReaderStatus('Paused - Connected. You are speaking to Gemini Live now. Press I again to disconnect and resume reading.', 'pending');
    syncAiExplanationReaderControls();
    persistAiPaneMode(AI_PANE_MODE_PDF_EXPLANATION);
    await syncAiPaneModeView(AI_PANE_MODE_PDF_EXPLANATION, aiExplanationReaderState.pdfName || '');

    const startVoice = window.MemoraVoiceAgent?.startConversation
        ? () => window.MemoraVoiceAgent.startConversation({ reason: 'explanation-interrupt' })
        : typeof window.beginGeminiLiveVoiceConversation === 'function'
            ? () => window.beginGeminiLiveVoiceConversation({ reason: 'explanation-interrupt' })
            : null;
    if (startVoice) {
        let started;
        try {
            started = await startVoice();
        } catch (error) {
            console.error('Voice interrupt failed:', error);
            started = false;
        }
        if (started === false) {
            // Voice never came up, so the reader is not handed over: it stays paused where it was.
            aiExplanationReaderState.interruptedForConversation = false;
            setAiExplanationReaderStatus('Voice could not connect. The reader is paused; press play to continue.', 'error');
            syncAiExplanationReaderControls();
        }
    } else {
        const connectBtn = $('ai-live-connect-btn');
        const micStartBtn = $('ai-live-mic-start-btn');
        if (connectBtn && !connectBtn.disabled) {
            connectBtn.click();
        } else if (micStartBtn && !micStartBtn.disabled) {
            micStartBtn.click();
        }
    }
    window.refreshGeminiLiveInterruptButton?.();
}

async function previewAiExplanationReaderVoice(
    voiceName = aiExplanationReaderState.settings.geminiVoice,
    { closeMenu = false, playbackRate = null, voiceUpdated = false } = {}
) {
    if (window.isMemoraProductFeatureAllowed?.('voice-agent') === false) return false;
    const selectedVoice = String(voiceName || aiExplanationReaderState.settings.geminiVoice || AI_EXPL_READER_DEFAULT_SETTINGS.geminiVoice).trim()
        || AI_EXPL_READER_DEFAULT_SETTINGS.geminiVoice;
    const selectedVoiceLabel = AI_EXPL_GEMINI_VOICES.find((voice) => voice.name === selectedVoice)?.label || selectedVoice;
    if (window.MemoraVoiceAgent?.stopPlayback) {
        window.MemoraVoiceAgent.stopPlayback({ except: 'explanation', keepStatus: false });
    } else {
        try { window.stopGeminiLiveQuestionReadout?.({ keepStatus: false }); } catch (_err) { }
    }
    stopAiExplanationReader({ keepStatus: true });
    clearAiExplanationReaderPrefetch();
    if (closeMenu) {
        closeAiExplanationVoiceMenu();
    }
    setAiExplanationReaderStatus(voiceUpdated ? 'Previewing · Voice Updated' : `Previewing ${selectedVoiceLabel}`, 'pending');
    syncAiExplanationReaderControls();
    const requestToken = aiExplanationReaderState.requestToken;
    const isCurrent = () => requestToken === aiExplanationReaderState.requestToken
        && selectedVoice === getAiExplanationReaderGeminiVoiceSetting()
        && window.isMemoraProductFeatureAllowed?.('voice-agent') !== false;
    let blob;
    try {
        blob = await primeAiExplanationVoicePreview(selectedVoice, { force: false });
    } catch (error) {
        if (!isCurrent()) return false;
        throw error;
    }
    if (!isCurrent()) return false;
    try {
        await playAiExplanationAudioBlob(blob, { playbackRate });
    } catch (error) {
        if (!isCurrent()) return false;
        throw error;
    }
    if (!isCurrent()) return false;
    setAiExplanationReaderStatus(voiceUpdated ? 'Voice Updated' : `${selectedVoiceLabel} preview ready`, voiceUpdated ? 'idle' : 'live');
    syncAiExplanationReaderControls();
}

function bindAiExplanationReaderControls() {
    const { panelToggle, playBtn, pauseBtn, stopBtn, readQuestionBtn, interruptBtn, closeBtn, voiceTrigger, voiceMenu, rateTrigger, rateMenu } = getAiExplanationReaderElements();
    if (playBtn) {
        playBtn.onclick = () => {
            playAiExplanationReader();
        };
    }
    if (pauseBtn) {
        pauseBtn.onclick = () => {
            const hasExplanationState = aiExplanationReaderState.isPlaying
                || aiExplanationReaderState.isPaused
                || hasAiExplanationReaderResumePoint();
            if (hasExplanationState) {
                pauseAiExplanationReader();
                return;
            }
            const pauseTask = window.MemoraVoiceAgent?.pauseOrResume
                ? window.MemoraVoiceAgent.pauseOrResume()
                : window.toggleGeminiLiveQuestionReadoutPause?.();
            void Promise.resolve(pauseTask).catch((error) => {
                console.error('Question readout pause toggle failed:', error);
                setAiExplanationReaderStatus(error?.message || 'Pause failed', 'error');
                syncAiExplanationReaderControls();
            });
        };
    }
    if (stopBtn) {
        stopBtn.onclick = () => {
            stopAiExplanationReader();
        };
    }
    if (readQuestionBtn) {
        readQuestionBtn.onclick = () => {
            void triggerAiExplanationReadQuestionShortcutAction().catch((error) => {
                console.error('Question readout failed:', error);
                setAiExplanationReaderStatus(error?.message || 'Question readout failed', 'error');
                syncAiExplanationReaderControls();
            });
        };
    }
    if (interruptBtn) {
        interruptBtn.onclick = () => {
            void toggleAiExplanationInterrupt().catch((error) => {
                console.error('Explanation interrupt toggle failed:', error);
                setAiExplanationReaderStatus(error?.message || 'Interrupt failed', 'error');
                syncAiExplanationReaderControls();
            });
        };
    }
    if (closeBtn) {
        closeBtn.onclick = () => {
            window.closeVoiceAgentModal?.('button');
        };
    }
    if (voiceTrigger) {
        voiceTrigger.onpointerdown = (event) => {
            if (event.button !== 0) return;
            event.preventDefault();
            event.stopPropagation();
            toggleAiExplanationVoiceMenu();
        };
        voiceTrigger.onclick = (event) => {
            event.preventDefault();
            event.stopPropagation();
        };
        voiceTrigger.onkeydown = (event) => {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            event.stopPropagation();
            toggleAiExplanationVoiceMenu({ restoreFocus: true });
        };
    }
    if (rateTrigger) {
        rateTrigger.onpointerdown = (event) => {
            if (event.button !== 0) return;
            event.preventDefault();
            event.stopPropagation();
            toggleAiExplanationSpeedMenu();
        };
        rateTrigger.onclick = (event) => {
            event.preventDefault();
            event.stopPropagation();
        };
        rateTrigger.onkeydown = (event) => {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            event.stopPropagation();
            toggleAiExplanationSpeedMenu({ restoreFocus: true });
        };
    }
    if (voiceMenu) {
        voiceMenu.onclick = (event) => {
            const previewBtn = event.target?.closest?.('.ai-expl-reader-voice-preview-btn');
            if (previewBtn) {
                event.preventDefault();
                event.stopPropagation();
                const voiceName = previewBtn.getAttribute('data-voice') || AI_EXPL_READER_DEFAULT_SETTINGS.geminiVoice;
                void previewAiExplanationReaderVoice(voiceName).catch((error) => {
                    console.error('Voice preview failed:', error);
                    setAiExplanationReaderStatus(error?.message || 'Voice preview failed', 'error');
                    syncAiExplanationReaderControls();
                });
                return;
            }
            const optionBtn = event.target?.closest?.('.ai-expl-reader-voice-option-btn');
            if (!optionBtn) return;
            event.preventDefault();
            event.stopPropagation();
            selectAiExplanationReaderVoice(
                optionBtn.getAttribute('data-voice') || AI_EXPL_READER_DEFAULT_SETTINGS.geminiVoice,
                { restoreFocus: true }
            );
        };
    }
    if (rateMenu) {
        rateMenu.onclick = (event) => {
            const optionBtn = event.target?.closest?.('.ai-expl-reader-speed-option');
            if (!optionBtn) return;
            event.preventDefault();
            event.stopPropagation();
            selectAiExplanationReaderRate(optionBtn.getAttribute('data-rate') || AI_EXPL_READER_DEFAULT_SETTINGS.rate, { restoreFocus: true });
        };
    }

    if (!aiExplanationReaderState.voiceMenuBound) {
        document.addEventListener('pointerdown', (event) => {
            if (!event.target?.closest?.('.ai-expl-reader-voice-picker')) {
                closeAiExplanationVoiceMenu();
            }
            if (!event.target?.closest?.('.ai-expl-reader-speed-picker')) {
                closeAiExplanationSpeedMenu();
            }
        });
        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                closeAiExplanationVoiceMenu();
                closeAiExplanationSpeedMenu();
            }
        });
        aiExplanationReaderState.voiceMenuBound = true;
    }

    bindVoiceModalControls();
    populateAiExplanationVoiceSelect();
    renderAiExplanationSpeedMenu();
    renderVoiceModalCard();
    syncAiExplanationReaderPanelState();
    setAiExplanationReaderStatus(aiExplanationReaderState.text ? 'Ready to read' : '', 'idle');
    syncAiExplanationReaderControls();
}

/* ===== Voice customization card =====
 *
 * The voice modal is a single card: an orb that reacts to whatever is currently speaking, a
 * carousel over AI_EXPL_GEMINI_VOICES, and three setting rows. Voice and speed write the shared
 * explanation-reader settings, so the picker in the modal and the reader are never out of step.
 * Intelligence writes the Live model/extended-thinking preference, which lives in app.ai.js. */

// Twenty voices is more indicators than the card can carry, so the strip is a window that slides
// with the selection and keeps a fixed footprint.
const VOICE_MODAL_DOT_WINDOW = 9;
// Long enough that holding an arrow through several voices fires one preview, not one per press.
const VOICE_MODAL_PREVIEW_DELAY_MS = 220;
let voiceModalPreviewTimer = 0;
// Bumped per request, so a preview still loading saved clips yields to a newer selection.
let voiceModalPreviewSequence = 0;
const VOICE_MODAL_PICKER_KEYS = Object.freeze(['speed', 'language']);
let voiceModalOpenPicker = '';
let voiceModalPickerGlobalsBound = false;

function getVoiceModalElements() {
    return {
        card: document.querySelector('#voice-agent-modal .voice-modal-card'),
        name: $('voice-modal-name'),
        desc: $('voice-modal-desc'),
        dots: $('voice-modal-dots'),
        prevBtn: $('voice-modal-prev'),
        nextBtn: $('voice-modal-next'),
        modes: $('voice-modal-modes'),
        speed: $('voice-modal-speed'),
        language: $('voice-modal-language')
    };
}

function getVoiceModalPickerParts(key) {
    const trigger = $(`voice-modal-${key}`);
    return {
        trigger,
        picker: trigger?.closest('.voice-modal-picker') || null,
        value: $(`voice-modal-${key}-value`),
        menu: $(`voice-modal-${key}-menu`)
    };
}

function getVoiceModalVoiceIndex() {
    const current = getAiExplanationReaderGeminiVoiceSetting();
    const index = AI_EXPL_GEMINI_VOICES.findIndex((voice) => voice.name === current);
    return index >= 0 ? index : 0;
}

function getVoiceModalDotWindow(index, total, max = VOICE_MODAL_DOT_WINDOW) {
    if (total <= max) return { start: 0, end: total };
    const half = Math.floor(max / 2);
    const start = Math.min(Math.max(index - half, 0), total - max);
    return { start, end: start + max };
}

function renderVoiceModalPicker(key, options, selectedValue) {
    const { trigger, menu, value } = getVoiceModalPickerParts(key);
    if (!trigger || !menu) return;
    const selected = options.find((option) => option.value === selectedValue) || options[0] || null;
    if (value) value.textContent = selected?.label || '';
    trigger.dataset.value = selected?.value || '';

    menu.innerHTML = '';
    options.forEach((option) => {
        const isSelected = option.value === selected?.value;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'voice-modal-picker-option';
        button.dataset.value = option.value;
        button.dataset.selected = isSelected ? 'true' : 'false';
        button.setAttribute('role', 'option');
        button.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        button.tabIndex = -1;
        if (option.title) button.title = option.title;

        const label = document.createElement('span');
        label.className = 'voice-modal-picker-option-label';
        label.textContent = option.label;

        const check = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        check.setAttribute('class', 'voice-modal-picker-option-check');
        check.setAttribute('viewBox', '0 0 24 24');
        check.setAttribute('aria-hidden', 'true');
        const checkPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        checkPath.setAttribute('d', 'm5 12.5 4.5 4.5L19 7.5');
        checkPath.setAttribute('fill', 'none');
        checkPath.setAttribute('stroke', 'currentColor');
        checkPath.setAttribute('stroke-width', '2');
        checkPath.setAttribute('stroke-linecap', 'round');
        checkPath.setAttribute('stroke-linejoin', 'round');
        check.appendChild(checkPath);

        button.appendChild(label);
        button.appendChild(check);
        menu.appendChild(button);
    });
}

/* The menu is fixed-positioned because .voice-modal-body scrolls and .voice-modal-card clips, so
   anything absolutely positioned inside a row would be cut off at the row it belongs to. */
function positionVoiceModalPickerMenu(trigger, menu) {
    // The card's fade animation creates a fixed-position containing block.
    // Keep viewport coordinates outside that transform and the clipped body.
    const modal = trigger.closest('#voice-agent-modal');
    if (modal && menu.parentElement !== modal) modal.appendChild(menu);
    const rect = trigger.getBoundingClientRect();
    const gap = 6;
    const edge = 8;
    menu.style.setProperty('--voice-picker-trigger-width', `${Math.round(rect.width)}px`);
    const menuRect = menu.getBoundingClientRect();
    let left = rect.right - menuRect.width;
    let top = rect.bottom + gap;
    if (top + menuRect.height > window.innerHeight - edge) {
        const above = rect.top - gap - menuRect.height;
        top = above >= edge ? above : Math.max(edge, window.innerHeight - edge - menuRect.height);
    }
    left = Math.min(Math.max(left, edge), Math.max(edge, window.innerWidth - menuRect.width - edge));
    menu.style.left = `${Math.round(left)}px`;
    menu.style.top = `${Math.round(top)}px`;
}

function closeVoiceModalPickers({ restoreFocus = false } = {}) {
    if (!voiceModalOpenPicker) return;
    const key = voiceModalOpenPicker;
    voiceModalOpenPicker = '';
    const { trigger, picker, menu } = getVoiceModalPickerParts(key);
    if (menu) menu.hidden = true;
    if (picker) picker.dataset.open = 'false';
    if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
        if (restoreFocus) trigger.focus();
    }
}

function openVoiceModalPicker(key) {
    const { trigger, picker, menu } = getVoiceModalPickerParts(key);
    if (!trigger || !menu || trigger.disabled) return;
    closeVoiceModalPickers();
    voiceModalOpenPicker = key;
    menu.hidden = false;
    picker.dataset.open = 'true';
    trigger.setAttribute('aria-expanded', 'true');
    positionVoiceModalPickerMenu(trigger, menu);
    const selected = menu.querySelector('.voice-modal-picker-option[data-selected="true"]');
    selected?.scrollIntoView({ block: 'nearest' });
    selected?.focus();
}

function toggleVoiceModalPicker(key) {
    if (voiceModalOpenPicker === key) {
        closeVoiceModalPickers({ restoreFocus: true });
        return;
    }
    openVoiceModalPicker(key);
}

function handleVoiceModalPickerSelection(key, value) {
    closeVoiceModalPickers({ restoreFocus: true });
    if (key === 'speed') handleVoiceModalSpeedChange(value);
}

function renderVoiceModalCard() {
    const ui = getVoiceModalElements();
    if (!ui.card) return;

    const index = getVoiceModalVoiceIndex();
    const voice = AI_EXPL_GEMINI_VOICES[index] || AI_EXPL_GEMINI_VOICES[0];
    if (ui.name) ui.name.textContent = voice?.title || voice?.name || '';
    if (ui.desc) ui.desc.textContent = voice?.desc || voice?.label || '';

    if (ui.dots) {
        const total = AI_EXPL_GEMINI_VOICES.length;
        const { start, end } = getVoiceModalDotWindow(index, total);
        ui.dots.innerHTML = '';
        for (let i = start; i < end; i += 1) {
            const entry = AI_EXPL_GEMINI_VOICES[i];
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'voice-modal-dot';
            dot.dataset.voice = entry.name;
            dot.dataset.selected = i === index ? 'true' : 'false';
            dot.setAttribute('aria-pressed', i === index ? 'true' : 'false');
            dot.setAttribute('aria-label', entry.label);
            dot.title = entry.label;
            ui.dots.appendChild(dot);
        }
    }

    renderVoiceModalPicker(
        'speed',
        AI_EXPL_READER_SPEED_OPTIONS.map((option) => ({ ...option })),
        getAiExplanationSelectedRateOption().value
    );


    // Live prompts and transcript filtering are English-only, so the row states that rather than offering a choice.
    renderVoiceModalPicker('language', [{ value: 'en', label: 'English' }], 'en');

    /* A missing API key blocks the audio preview, not the preference itself, so the controls stay
     * live and the note under them explains why nothing plays. Only the voice agent being switched
     * off makes these settings genuinely inert. */
    const supported = window.isMemoraProductFeatureAllowed?.('voice-agent') !== false;
    [ui.prevBtn, ui.nextBtn, ui.speed, ...(ui.modes ? ui.modes.querySelectorAll('.voice-modal-mode') : [])].forEach((el) => {
        if (el) el.disabled = !supported;
    });
    if (!supported) closeVoiceModalPickers();
}

/* Every change plays a sample so the student hears the voice and the tempo they just picked
 * instead of finding out on their next question. */
function scheduleVoiceModalPreview(reason = 'voice') {
    if (voiceModalPreviewTimer) {
        clearTimeout(voiceModalPreviewTimer);
        voiceModalPreviewTimer = 0;
    }
    const sequence = ++voiceModalPreviewSequence;
    // A selection invalidates an older sample already awaiting the shared clip fetch.
    const requestToken = ++aiExplanationReaderState.requestToken;
    if (window.isMemoraProductFeatureAllowed?.('voice-agent') === false) return;
    void hydrateAiExplanationPreviewStore();
    voiceModalPreviewTimer = window.setTimeout(async () => {
        voiceModalPreviewTimer = 0;
        await hydrateAiExplanationPreviewStore();
        if (sequence !== voiceModalPreviewSequence || requestToken !== aiExplanationReaderState.requestToken
            || window.isMemoraProductFeatureAllowed?.('voice-agent') === false) return;
        const voice = getAiExplanationReaderGeminiVoiceSetting();
        /* A saved clip plays on any profile. Fetching a missing one is a real Live TTS call on the
         * student's own key; the relay cannot stand in. */
        if (!getCachedAiExplanationPreviewBlob(voice)) {
            if (typeof window.hasMemoraVoiceByokKey === 'function' && !window.hasMemoraVoiceByokKey()) return;
            if (!String(getAiExplanationReaderApiKey() || '').trim()) return;
        }
        void previewAiExplanationReaderVoice(voice, {
            playbackRate: Number(getAiExplanationReaderRateSetting()) || 1,
            voiceUpdated: reason === 'voice'
        }).catch((error) => {
            if (error?.name === 'AbortError') return;
            console.warn(`Voice modal ${reason} preview failed:`, error);
            setAiExplanationReaderStatus(error?.message || 'Voice preview failed', 'error');
            syncAiExplanationReaderControls();
        });
    }, VOICE_MODAL_PREVIEW_DELAY_MS);
}

function selectVoiceModalVoice(voiceName) {
    const name = String(voiceName || '').trim();
    if (!name || name === getAiExplanationReaderGeminiVoiceSetting()) return;
    selectAiExplanationReaderVoice(name, { restoreFocus: false });
    renderVoiceModalCard();
    scheduleVoiceModalPreview('voice');
}

function stepVoiceModalVoice(delta) {
    const total = AI_EXPL_GEMINI_VOICES.length;
    if (!total) return;
    const next = (((getVoiceModalVoiceIndex() + delta) % total) + total) % total;
    selectVoiceModalVoice(AI_EXPL_GEMINI_VOICES[next]?.name);
}

function handleVoiceModalSpeedChange(rateValue) {
    selectAiExplanationReaderRate(rateValue, { restoreFocus: false });
    renderVoiceModalCard();
    scheduleVoiceModalPreview('speed');
}

function getVoiceModalModes() {
    return typeof window.getGeminiLiveThinkingLevels === 'function'
        ? window.getGeminiLiveThinkingLevels()
        : [];
}

/* A fixed Voice thinking level has no mode selector. */
function renderVoiceModalModes() {
    const { modes } = getVoiceModalElements();
    if (!modes) return;
    const levels = getVoiceModalModes();
    modes.hidden = levels.length < 2;
    if (levels.length < 2) { modes.replaceChildren(); return; }
    const current = typeof window.getGeminiLiveThinkingLevelPreference === 'function'
        ? window.getGeminiLiveThinkingLevelPreference()
        : levels[0].value;
    const restoreFocus = modes.contains(document.activeElement);
    modes.innerHTML = '';
    levels.forEach((level) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'voice-modal-mode';
        button.dataset.voiceMode = level.value;
        button.textContent = level.label;
        button.title = level.hint || '';
        button.setAttribute('role', 'radio');
        button.setAttribute('aria-checked', level.value === current ? 'true' : 'false');
        button.tabIndex = level.value === current ? 0 : -1;
        modes.appendChild(button);
    });
    if (restoreFocus) modes.querySelector('.voice-modal-mode[aria-checked="true"]')?.focus();
}

function handleVoiceModalModeChange(levelValue) {
    if (typeof window.setGeminiLiveThinkingLevelPreference !== 'function') return;
    const level = window.setGeminiLiveThinkingLevelPreference(levelValue);
    const label = getVoiceModalModes().find((entry) => entry.value === level)?.label || level;
    renderVoiceModalCard();
    setAiExplanationReaderStatus(`${label} mode`, 'idle');
    syncAiExplanationReaderControls();
}

function bindVoiceModalControls() {
    const ui = getVoiceModalElements();
    if (!ui.card) return;
    if (ui.prevBtn) ui.prevBtn.onclick = () => stepVoiceModalVoice(-1);
    if (ui.nextBtn) ui.nextBtn.onclick = () => stepVoiceModalVoice(1);
    if (ui.dots) {
        ui.dots.onclick = (event) => {
            const dot = event.target?.closest?.('.voice-modal-dot');
            if (!dot) return;
            selectVoiceModalVoice(dot.dataset.voice);
        };
    }
    if (ui.modes) {
        ui.modes.onclick = (event) => {
            const button = event.target?.closest?.('.voice-modal-mode');
            if (!button || button.disabled) return;
            event.preventDefault();
            handleVoiceModalModeChange(button.dataset.voiceMode);
        };
        ui.modes.onkeydown = (event) => {
            const button = event.target?.closest?.('.voice-modal-mode');
            if (!button || button.disabled) return;
            const buttons = Array.from(ui.modes.querySelectorAll('.voice-modal-mode'));
            const index = buttons.indexOf(button);
            let next;
            if (['ArrowRight', 'ArrowDown'].includes(event.key)) next = (index + 1) % buttons.length;
            else if (['ArrowLeft', 'ArrowUp'].includes(event.key)) next = (index + buttons.length - 1) % buttons.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = buttons.length - 1;
            else return;
            event.preventDefault();
            event.stopPropagation();
            handleVoiceModalModeChange(buttons[next].dataset.voiceMode);
        };
    }

    VOICE_MODAL_PICKER_KEYS.forEach((key) => {
        const { trigger, menu } = getVoiceModalPickerParts(key);
        if (trigger) {
            trigger.onclick = (event) => {
                event.preventDefault();
                event.stopPropagation();
                toggleVoiceModalPicker(key);
            };
            trigger.onkeydown = (event) => {
                if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
                event.preventDefault();
                event.stopPropagation();
                openVoiceModalPicker(key);
                if (event.key === 'Home' || event.key === 'End') {
                    const options = menu?.querySelectorAll('.voice-modal-picker-option');
                    options?.[event.key === 'Home' ? 0 : options.length - 1]?.focus();
                }
            };
        }
        if (menu) {
            menu.onclick = (event) => {
                const option = event.target?.closest?.('.voice-modal-picker-option');
                if (!option) return;
                event.preventDefault();
                event.stopPropagation();
                handleVoiceModalPickerSelection(key, option.dataset.value);
            };
            menu.onkeydown = (event) => {
                if (event.key === 'Tab') { closeVoiceModalPickers({ restoreFocus: true }); return; }
                const option = event.target?.closest?.('.voice-modal-picker-option');
                if (!option) return;
                const options = Array.from(menu.querySelectorAll('.voice-modal-picker-option'));
                const index = options.indexOf(option);
                let next;
                if (event.key === 'ArrowDown') next = (index + 1) % options.length;
                else if (event.key === 'ArrowUp') next = (index + options.length - 1) % options.length;
                else if (event.key === 'Home') next = 0;
                else if (event.key === 'End') next = options.length - 1;
                else return;
                event.preventDefault();
                event.stopPropagation();
                options[next]?.focus();
            };
        }
    });

    if (!voiceModalPickerGlobalsBound) {
        // A menu placed in viewport coordinates has to be dismissed by anything that moves the
        // trigger out from under it, not only by a click elsewhere.
        document.addEventListener('pointerdown', (event) => {
            if (!voiceModalOpenPicker) return;
            if (event.target?.closest?.('.voice-modal-picker, .voice-modal-picker-menu')) return;
            closeVoiceModalPickers();
        }, true);
        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && voiceModalOpenPicker) {
                event.preventDefault();
                event.stopImmediatePropagation();
                closeVoiceModalPickers({ restoreFocus: true });
            }
        }, true);
        window.addEventListener('resize', () => closeVoiceModalPickers());
        document.addEventListener('scroll', (event) => {
            if (event.target?.closest?.('.voice-modal-picker-menu')) return;
            closeVoiceModalPickers();
        }, true);
        voiceModalPickerGlobalsBound = true;
    }
}

function normalizePdfTitleToName(titleText) {
    const raw = String(titleText || '').trim();
    if (!raw) return '';
    return raw
        .replace(/\s*\(Page\s+\d+\)\s*$/i, '')
        .trim();
}

function getCurrentPdfNameForExplanationPane() {
    const fromTitle = normalizePdfTitleToName(els?.pdfTitle?.innerText);
    if (fromTitle && (loadedPdfFiles[fromTitle] || (sessionManifest?.pdfs || []).includes(fromTitle))) {
        return fromTitle;
    }
    const fromLast = normalizePdfTitleToName(lastPdfState?.title);
    if (fromLast && (loadedPdfFiles[fromLast] || (sessionManifest?.pdfs || []).includes(fromLast))) {
        return fromLast;
    }
    const loaded = Object.keys(loadedPdfFiles || {});
    if (loaded.length > 0) return loaded[0];
    if (sessionManifest?.pdfs?.length > 0) return sessionManifest.pdfs[0];
    return '';
}

async function getAiExplanationPdfCandidates() {
    const names = new Set();
    Object.keys(loadedPdfFiles || {}).forEach(name => names.add(name));
    (sessionManifest?.pdfs || []).forEach(name => names.add(name));
    if (typeof window.getPdfExplanationIndex === 'function') {
        try {
            const index = await window.getPdfExplanationIndex(currentSessionId || null);
            Object.keys(index || {}).forEach(name => names.add(name));
        } catch (err) {
            console.warn('Failed to load PDF explanation index for AI pane:', err);
        }
    }
    return Array.from(names).sort((a, b) => a.localeCompare(b));
}

async function populateAiExplanationPdfSelect(preferredName = '') {
    const select = $('ai-expl-pdf-select');
    if (!select) return '';

    const candidates = await getAiExplanationPdfCandidates();
    const requested = preferredName || select.value || getCurrentPdfNameForExplanationPane();

    select.innerHTML = '';
    if (candidates.length === 0) {
        const option = document.createElement('option');
        option.value = '';
        option.textContent = 'No PDFs Loaded';
        select.appendChild(option);
        select.value = '';
        return '';
    }

    candidates.forEach(name => {
        const option = document.createElement('option');
        option.value = name;
        option.textContent = name;
        select.appendChild(option);
    });

    if (requested && candidates.includes(requested)) {
        select.value = requested;
    } else {
        select.value = candidates[0];
    }
    return select.value;
}

function getAiExplanationRegeneratePromptKey(pdfName, record = null) {
    const sessionId = String(record?.sessionId || currentSessionId || 'default').trim() || 'default';
    const name = String(pdfName || record?.pdfName || 'pdf').trim() || 'pdf';
    return `${AI_EXPL_REGEN_PROMPT_STORAGE_KEY}::${sessionId}::${name}`;
}

function getAiExplanationDefaultPrompt(record = null) {
    const preset = record?.preset || 'slide_deep_dive';
    if (typeof window.getDefaultPdfExplanationPrompt === 'function') {
        return window.getDefaultPdfExplanationPrompt(preset) || '';
    }
    return 'Explain this PDF slide by slide with expert context, clear terminology, clinical relevance, and concise takeaways.';
}

function getAiExplanationRegeneratePrompt(pdfName, record = null) {
    try {
        const stored = localStorage.getItem(getAiExplanationRegeneratePromptKey(pdfName, record));
        if (stored && stored.trim()) return stored.trim();
    } catch (_err) { }
    return String(record?.prompt || getAiExplanationDefaultPrompt(record) || '').trim();
}

function setAiExplanationRegeneratePrompt(pdfName, record = null, value = '') {
    try {
        const key = getAiExplanationRegeneratePromptKey(pdfName, record);
        const clean = String(value || '').trim();
        if (clean) localStorage.setItem(key, clean);
        else localStorage.removeItem(key);
    } catch (_err) { }
}

function closeAiExplanationPromptEditor() {
    const modal = document.getElementById('ai-expl-regen-prompt-modal');
    if (modal) modal.remove();
}

function openAiExplanationPromptEditor(pdfName, record = null) {
    let modal = document.getElementById('ai-expl-regen-prompt-modal');
    if (!modal) {
        modal = document.createElement('div');
        modal.id = 'ai-expl-regen-prompt-modal';
        modal.innerHTML = `
            <div class="modal-content quiz-gen-prompt-expanded-content" role="dialog" aria-modal="true" aria-label="PDF explanation regeneration prompt editor">
                <button type="button" class="theme-close-btn quiz-gen-prompt-expanded-close" aria-label="Close PDF explanation prompt editor">&times;</button>
                <div class="quiz-gen-prompt-expanded-header">
                    <div>
                        <div class="quiz-gen-prompt-expanded-title">PDF Explanation Prompt</div>
                        <div class="quiz-gen-prompt-expanded-note">Applies when regenerating this PDF explanation.</div>
                    </div>
                    <div class="quiz-gen-prompt-expanded-actions">
                        <button type="button" id="ai-expl-regen-prompt-reset" class="source-filter-btn quiz-gen-prompt-header-btn">Reset</button>
                        <button type="button" id="ai-expl-regen-prompt-save" class="source-filter-btn quiz-gen-prompt-header-btn">Save</button>
                    </div>
                </div>
                <textarea id="ai-expl-regen-prompt-input" class="hide-scrollbar" spellcheck="false"></textarea>
            </div>
        `;
        modal.addEventListener('click', closeAiExplanationPromptEditor);
        modal.querySelector('.quiz-gen-prompt-expanded-content')?.addEventListener('click', (event) => event.stopPropagation());
        modal.querySelector('.quiz-gen-prompt-expanded-close')?.addEventListener('click', closeAiExplanationPromptEditor);
        document.body.appendChild(modal);
    }

    const input = modal.querySelector('#ai-expl-regen-prompt-input');
    const resetBtn = modal.querySelector('#ai-expl-regen-prompt-reset');
    const saveBtn = modal.querySelector('#ai-expl-regen-prompt-save');
    if (input) {
        input.value = getAiExplanationRegeneratePrompt(pdfName, record);
        input.placeholder = getAiExplanationDefaultPrompt(record);
    }
    if (resetBtn) {
        resetBtn.onclick = () => {
            setAiExplanationRegeneratePrompt(pdfName, record, '');
            if (input) input.value = getAiExplanationDefaultPrompt(record);
            showPopup('PDF explanation regeneration prompt reset.', null, false);
        };
    }
    if (saveBtn) {
        saveBtn.onclick = () => {
            setAiExplanationRegeneratePrompt(pdfName, record, input?.value || '');
            showPopup('PDF explanation regeneration prompt saved.', null, false);
            closeAiExplanationPromptEditor();
        };
    }
    requestAnimationFrame(() => {
        input?.focus();
        input?.setSelectionRange(input.value.length, input.value.length);
    });
}

async function confirmAiExplanationRegenerate(pdfName) {
    const name = String(pdfName || 'this PDF').trim();
    const message = `Regenerate the saved PDF explanation for ${name}? This will overwrite the current explanation for this session.`;
    if (typeof showThemeConfirm === 'function') {
        return await showThemeConfirm(message, {
            title: 'Regenerate PDF Explanation?',
            okText: 'Regenerate',
            cancelText: 'Cancel'
        });
    }
    return Promise.resolve(confirm(message));
}

async function regenerateAiPanePdfExplanation(pdfName, record = null, root = null) {
    if (typeof window.regeneratePdfExplanationRecord !== 'function') {
        showPopup('PDF explanation regeneration is not available yet.', null, true);
        return;
    }
    const confirmed = await confirmAiExplanationRegenerate(pdfName);
    if (!confirmed) return;

    const button = root?.querySelector?.('[data-ai-expl-action="regenerate"]') || null;
    const previousLabel = button?.textContent || '';
    try {
        if (button) {
            button.disabled = true;
            button.textContent = 'Regenerating...';
        }
        root?.classList?.add('is-regenerating');
        showPopupText(`Regenerating PDF explanation for ${pdfName}...`, null, false, 60000);
        await window.regeneratePdfExplanationRecord(pdfName, currentSessionId || record?.sessionId || null, {
            prompt: getAiExplanationRegeneratePrompt(pdfName, record),
            onProgress: (percent, status) => {
                if (button) button.textContent = `${Math.max(0, Math.min(100, Math.round(Number(percent) || 0)))}%`;
                if (status && typeof setQuizGenProgressPercentOnly === 'function') {
                    setQuizGenProgressPercentOnly(percent);
                }
            }
        });
        if (typeof dismissPopup === 'function') dismissPopup();
        showPopup('PDF explanation regenerated.', null, false);
        await renderPdfExplanationInAiPane(pdfName);
    } catch (err) {
        if (typeof dismissPopup === 'function') dismissPopup();
        console.warn('Failed to regenerate PDF explanation:', err);
        showPopupText(`Could not regenerate PDF explanation for ${pdfName}.`, null, true);
    } finally {
        root?.classList?.remove('is-regenerating');
        if (button) {
            button.disabled = false;
            button.textContent = previousLabel || 'Regenerate Explanation';
        }
    }
}

function bindAiExplanationRegenerateControls(root, pdfName, record = null) {
    if (!root) return;
    root.querySelectorAll('[data-ai-expl-action]').forEach((button) => {
        if (button.dataset.bound === '1') return;
        button.dataset.bound = '1';
        button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            const action = button.dataset.aiExplAction;
            if (action === 'customize-prompt') {
                openAiExplanationPromptEditor(pdfName, record);
                return;
            }
            if (action === 'regenerate') {
                void regenerateAiPanePdfExplanation(pdfName, record, root);
            }
        });
    });
}

async function renderPdfExplanationInAiPane(preferredName = '') {
    const content = $('ai-expl-content');
    if (!content) return;

    const selectedPdf = await populateAiExplanationPdfSelect(preferredName);
    const preserveReaderState = !!((
        aiExplanationReaderState.interruptedForConversation
        || aiExplanationReaderState.resumeAfterInterrupt
        || aiExplanationReaderState.resumeAfterPaneHide
    ) && selectedPdf && selectedPdf === aiExplanationReaderState.pdfName && hasAiExplanationReaderResumePoint());
    if (!preserveReaderState) {
        stopAiExplanationReader({ keepStatus: true });
        aiExplanationReaderState.text = '';
        aiExplanationReaderState.pdfName = selectedPdf || '';
    }
    if (!selectedPdf) {
        content.innerHTML = '<div class="ai-expl-empty">No PDF is loaded yet. Import a PDF first.</div>';
        return;
    }

    if (typeof window.getPdfExplanationRecord !== 'function') {
        content.innerHTML = '<div class="ai-expl-empty">PDF explanation service is not available yet.</div>';
        return;
    }

    let record = null;
    try {
        record = await window.getPdfExplanationRecord(selectedPdf, currentSessionId || null);
    } catch (err) {
        console.warn(`Failed to fetch explanation record for ${selectedPdf}:`, err);
    }

    if (!record || !record.text) {
        content.innerHTML = `<div class="ai-expl-empty">No saved explanation for <strong>${escapeHtml(selectedPdf)}</strong> yet.<br>Enable <strong>Generate PDF Explanations</strong> in the quiz generation modal, then generate.</div>`;
        return;
    }

    const generatedAt = record.generatedAt ? new Date(record.generatedAt).toLocaleString() : 'Unknown time';
    const scope = record.scopeLabel || 'all slides';
    const model = record.model || 'Unknown model';
    const formattedBody = (typeof formatAIResponse === 'function')
        ? formatAIResponse(record.text)
        : `<pre style="white-space:pre-wrap; margin:0;">${escapeHtml(record.text)}</pre>`;
    aiExplanationReaderState.text = String(record.text || '').trim();
    aiExplanationReaderState.pdfName = selectedPdf;

    content.innerHTML = `
        <div class="ai-expl-meta">
            <div><strong>${escapeHtml(selectedPdf)}</strong></div>
            <div>Generated: ${escapeHtml(generatedAt)} | Scope: ${escapeHtml(scope)} | Model: ${escapeHtml(model)}</div>
        </div>
        <div class="ai-expl-regenerate-toolbar">
            <button type="button" class="source-filter-btn ai-expl-regenerate-btn" data-ai-expl-action="regenerate">Regenerate Explanation</button>
            <button type="button" class="source-filter-btn ai-expl-customize-btn" data-ai-expl-action="customize-prompt">Customize Prompt</button>
        </div>
        ${formattedBody}
    `;

    bindAiExplanationRegenerateControls(content, selectedPdf, record);
    attachPdfExplanationSlideCards(content);
    bindAiExplanationReaderControls();
    if (preserveReaderState && !aiExplanationReaderState.interruptedForConversation) {
        setAiExplanationReaderStatus('Reader ready to resume', 'pending');
        syncAiExplanationReaderControls();
    }
}

window.startAiExplanationReaderFromSlideCard = function startAiExplanationReaderFromSlideCard(cardOrSlide) {
    const slideNumber = typeof cardOrSlide === 'number' || typeof cardOrSlide === 'string'
        ? Math.max(1, Number(cardOrSlide) || 0)
        : extractAiExplanationSlideNumberFromCard(cardOrSlide);
    return startAiExplanationReaderFromSlideNumber(slideNumber);
};

async function syncAiPaneModeViewOnce(forceMode = null, preferredPdfName = '') {
    const modeWrap = $('ai-pane-mode-wrap');
    const modeSelect = $('ai-pane-mode');
    const pdfSelect = $('ai-expl-pdf-select');
    const aiFrame = $('ai-frame');
    const aiTitle = $('ai-title');
    const explView = $('ai-expl-view');
    const askMemoraPaneView = $('ask-memora-pane-view');
    const popoutBtn = $('popout-ai-btn');
    const geminiLiveOptionAvailable = !!modeSelect?.querySelector?.('option[value="gemini-live"]');
    const pdfExplanationEnabled = isMemoraPdfExplanationEnabled();

    if (!modeSelect || !aiFrame || !explView) return;
    removeAiIframeExtensionRecommendation();
    syncMemoraPdfExplanationFeatureUi();

    const inTutorCheckpoint = !!els.workArea?.classList.contains('pdf-tutor-quiz-view');
    if (els.workArea?.classList.contains('pdf-tutor-view') && !inTutorCheckpoint) {
        const tutorPane = $('pdf-tutor-pane');
        els.workArea?.classList.remove('ai-pane-ask-active', 'ai-pane-pdf-explanation-active');
        if (aiTitle) aiTitle.innerText = 'Memoraful Tutor';
        if (modeWrap) modeWrap.style.display = 'none';
        aiFrame.style.display = 'none';
        explView.style.display = 'none';
        if (askMemoraPaneView) askMemoraPaneView.style.display = 'none';
        if (tutorPane) tutorPane.style.display = 'flex';
        if (pdfSelect) pdfSelect.style.display = 'none';
        if (popoutBtn) {
        popoutBtn.title = 'Tutor transcript is embedded in Memoraful';
            popoutBtn.disabled = true;
            popoutBtn.classList.add('disabled');
        }
        window.setGeminiLivePaneVisible?.(false);
        window.renderPdfTutorPane?.();
        return;
    }

    const previousMode = aiPaneMode;
    let requestedMode = (forceMode === AI_PANE_MODE_PDF_EXPLANATION || forceMode === AI_PANE_MODE_AI || forceMode === AI_PANE_MODE_GEMINI_LIVE)
        ? forceMode
        : (
            modeSelect.value === AI_PANE_MODE_PDF_EXPLANATION
                ? AI_PANE_MODE_PDF_EXPLANATION
                : (modeSelect.value === AI_PANE_MODE_GEMINI_LIVE ? AI_PANE_MODE_GEMINI_LIVE : AI_PANE_MODE_AI)
        );
    if (!isVoiceAgentAccessibilityEnabled() && requestedMode === AI_PANE_MODE_GEMINI_LIVE) {
        requestedMode = AI_PANE_MODE_AI;
    }
    if (requestedMode === AI_PANE_MODE_GEMINI_LIVE && !geminiLiveOptionAvailable) {
        requestedMode = AI_PANE_MODE_AI;
    }
    if (requestedMode === AI_PANE_MODE_PDF_EXPLANATION && !pdfExplanationEnabled) {
        requestedMode = AI_PANE_MODE_AI;
    }
    persistAiPaneMode(requestedMode);
    modeSelect.value = aiPaneMode;
    syncAiPaneHeaderActionButtons(aiPaneMode);

    const inTrioLayout = isTrioMode || els.workArea.classList.contains('trio-view');
    const inSplitAiLayout = els.workArea.classList.contains('split-view-ai');
    const aiPaneModeAvailable = inTrioLayout || inSplitAiLayout;
    const tutorPane = $('pdf-tutor-pane');
    if (tutorPane) tutorPane.style.display = 'none';
    els.workArea?.classList.toggle('ai-pane-ask-active', aiPaneModeAvailable && aiPaneMode === AI_PANE_MODE_AI);
    els.workArea?.classList.toggle('ai-pane-pdf-explanation-active', aiPaneModeAvailable && aiPaneMode === AI_PANE_MODE_PDF_EXPLANATION);
    if (modeWrap) modeWrap.style.display = aiPaneModeAvailable ? 'inline-flex' : 'none';

    if (aiPaneMode === AI_PANE_MODE_PDF_EXPLANATION && aiPaneModeAvailable) {
        if (aiTitle) aiTitle.innerText = 'PDF Explanation';
        aiFrame.style.display = 'none';
        if (askMemoraPaneView) askMemoraPaneView.style.display = 'none';
        explView.style.display = 'block';
        if (pdfSelect) pdfSelect.style.display = '';
        if (popoutBtn) {
            popoutBtn.title = 'Open AI website';
            popoutBtn.disabled = false;
            popoutBtn.classList.remove('disabled');
        }
        window.setGeminiLivePaneVisible?.(false);
        await renderPdfExplanationInAiPane(preferredPdfName);
        return;
    }

    if (previousMode === AI_PANE_MODE_PDF_EXPLANATION && (aiPaneMode !== AI_PANE_MODE_PDF_EXPLANATION || !aiPaneModeAvailable)) {
        if (!aiExplanationReaderState.interruptedForConversation && !aiExplanationReaderState.resumeAfterInterrupt) {
            if (!preserveAiExplanationReaderForResume('Reader paused. Reopen PDF Explanation to resume.')) {
                stopAiExplanationReader({ keepStatus: true });
            }
        }
    }

    if (aiPaneMode === AI_PANE_MODE_GEMINI_LIVE && aiPaneModeAvailable) {
        persistAiPaneMode(AI_PANE_MODE_AI);
        modeSelect.value = AI_PANE_MODE_AI;
        window.setGeminiLivePaneVisible?.(true);
        return syncAiPaneModeViewOnce(AI_PANE_MODE_AI, preferredPdfName);
    }

        if (aiTitle) aiTitle.innerText = 'Ask Memoraful';
    aiFrame.src = 'about:blank';
    aiFrame.style.display = 'none';
    explView.style.display = 'none';
    if (askMemoraPaneView) {
        askMemoraPaneView.style.display = aiPaneModeAvailable ? 'flex' : 'none';
    }
    if (pdfSelect) pdfSelect.style.display = 'none';
    if (popoutBtn) {
        popoutBtn.title = 'Ask Memoraful opens inside Memoraful';
        popoutBtn.disabled = true;
        popoutBtn.classList.add('disabled');
    }
    window.setGeminiLivePaneVisible?.(false);
    if (aiPaneModeAvailable) {
        window.renderAskMemoraInAiPane?.();
    }
}

async function syncAiPaneModeView(forceMode = null, preferredPdfName = '') {
    pendingAiPaneModeSyncArgs = [forceMode, preferredPdfName];
    if (aiPaneModeSyncInFlight) {
        return aiPaneModeSyncPromise;
    }

    aiPaneModeSyncInFlight = true;
    aiPaneModeSyncPromise = (async () => {
        try {
            while (pendingAiPaneModeSyncArgs) {
                const [nextForceMode, nextPreferredPdfName] = pendingAiPaneModeSyncArgs;
                pendingAiPaneModeSyncArgs = null;
                await syncAiPaneModeViewOnce(nextForceMode, nextPreferredPdfName);
            }
        } finally {
            aiPaneModeSyncInFlight = false;
            aiPaneModeSyncPromise = null;
        }
    })();

    return aiPaneModeSyncPromise;
}

window.toggleAiExplanationInterrupt = toggleAiExplanationInterrupt;
window.getAiExplanationReaderRateSetting = getAiExplanationReaderRateSetting;
window.getAiExplanationReaderGeminiVoiceSetting = getAiExplanationReaderGeminiVoiceSetting;
window.getAiExplanationInterruptState = () => ({
    available: aiExplanationReaderState.interruptedForConversation
        || aiExplanationReaderState.isPlaying
        || aiExplanationReaderState.isPaused
        || hasAiExplanationReaderResumePoint(),
    interrupted: !!aiExplanationReaderState.interruptedForConversation
});
window.getAiExplanationLiveContextSnapshot = getAiExplanationLiveContextSnapshot;
window.bindAiExplanationReaderControls = bindAiExplanationReaderControls;
window.refreshAiExplanationReaderControls = syncAiExplanationReaderControls;
window.stopAiExplanationReaderPlayback = stopAiExplanationReader;
window.toggleAiExplanationReaderPauseShortcutAction = toggleAiExplanationReaderPauseShortcutAction;
window.setAiExplanationReaderPausedAction = setAiExplanationReaderPausedAction;
window.triggerAiExplanationReadQuestionShortcutAction = triggerAiExplanationReadQuestionShortcutAction;
window.triggerAiExplanationReadExplanationVoiceAction = triggerAiExplanationReadExplanationVoiceAction;
window.toggleAiExplanationReaderVoiceMenu = toggleAiExplanationVoiceMenu;
window.toggleAiExplanationReaderSpeedMenu = toggleAiExplanationSpeedMenu;
window.getAiExplanationReaderVoiceOptions = () => AI_EXPL_GEMINI_VOICES.map((voice) => ({ ...voice }));
window.getAiExplanationReaderSpeedOptions = () => AI_EXPL_READER_SPEED_OPTIONS.map((option) => ({ ...option }));
window.setAiExplanationReaderGeminiVoiceSetting = (voiceName) => {
    selectAiExplanationReaderVoice(voiceName, { restoreFocus: false });
};
window.setAiExplanationReaderRateSetting = (rateValue) => {
    selectAiExplanationReaderRate(rateValue, { restoreFocus: false });
};
window.refreshVoiceModalCard = renderVoiceModalCard;
window.bindVoiceModalControls = bindVoiceModalControls;

function removeAiIframeExtensionRecommendation() {
    document.getElementById('trio-iframe-warning')?.remove();
}

function syncAiPaneHeaderActionButtons(mode = aiPaneMode) {
    const askMemoraBtn = $('ai-pane-ask-memora-btn');
    const pdfExplBtn = $('ai-pane-pdf-expl-btn');
    const pdfExplanationEnabled = isMemoraPdfExplanationEnabled();
    const isPdfExplanation = pdfExplanationEnabled && mode === AI_PANE_MODE_PDF_EXPLANATION;
    if (askMemoraBtn) {
        askMemoraBtn.classList.toggle('is-active', !isPdfExplanation);
        askMemoraBtn.setAttribute('aria-pressed', isPdfExplanation ? 'false' : 'true');
    }
    if (pdfExplBtn) {
        pdfExplBtn.hidden = !pdfExplanationEnabled;
        pdfExplBtn.disabled = !pdfExplanationEnabled;
        pdfExplBtn.classList.toggle('is-active', isPdfExplanation);
        pdfExplBtn.setAttribute('aria-pressed', isPdfExplanation ? 'true' : 'false');
    }
}

function openAskMemoraFromAiPaneHeader() {
    removeAiIframeExtensionRecommendation();
    persistAiPaneMode(AI_PANE_MODE_AI);
    syncAiPaneHeaderActionButtons(AI_PANE_MODE_AI);
    void syncAiPaneModeView(AI_PANE_MODE_AI);
    const opener = typeof window.openAskMemoraInAiPane === 'function'
        ? window.openAskMemoraInAiPane
        : null;
    if (opener) {
        void opener();
        return;
    }
    if (typeof showPopup === 'function') {
        showPopup('Ask Memoraful is still loading. Try again in a moment.', null, true);
    }
}

function setupAiPaneModeControls() {
    const modeSelect = $('ai-pane-mode');
    const pdfSelect = $('ai-expl-pdf-select');
    const askMemoraBtn = $('ai-pane-ask-memora-btn');
    const pdfExplBtn = $('ai-pane-pdf-expl-btn');
    if (!modeSelect || !pdfSelect) return;

    syncMemoraPdfExplanationFeatureUi();
    modeSelect.value = aiPaneMode;
    syncAiPaneHeaderActionButtons(aiPaneMode);
    modeSelect.onchange = () => {
        const mode = modeSelect.value === AI_PANE_MODE_PDF_EXPLANATION
            ? AI_PANE_MODE_PDF_EXPLANATION
            : (modeSelect.value === AI_PANE_MODE_GEMINI_LIVE ? AI_PANE_MODE_GEMINI_LIVE : AI_PANE_MODE_AI);
        persistAiPaneMode(mode);
        void syncAiPaneModeView(mode);
    };
    if (askMemoraBtn && !askMemoraBtn.dataset.askMemoraPaneBound) {
        askMemoraBtn.dataset.askMemoraPaneBound = 'true';
        askMemoraBtn.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            openAskMemoraFromAiPaneHeader();
        });
    }
    if (pdfExplBtn && !pdfExplBtn.dataset.pdfExplPaneBound) {
        pdfExplBtn.dataset.pdfExplPaneBound = 'true';
        pdfExplBtn.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            if (!isMemoraPdfExplanationEnabled()) {
                openAskMemoraFromAiPaneHeader();
                return;
            }
            persistAiPaneMode(AI_PANE_MODE_PDF_EXPLANATION);
            void syncAiPaneModeView(AI_PANE_MODE_PDF_EXPLANATION);
        });
    }
    pdfSelect.onchange = () => {
        if (aiPaneMode === AI_PANE_MODE_PDF_EXPLANATION) {
            void renderPdfExplanationInAiPane(pdfSelect.value);
        }
    };
}

function syncVoiceAgentAccessibilityState() {
    const voiceAgentEnabled = isVoiceAgentAccessibilityEnabled();
    if (!voiceAgentEnabled) {
        window.closeVoiceAgentModal?.('button');
        closeAiExplanationVoiceMenu();
        stopAiExplanationReader({ keepStatus: false });
        if (window.MemoraVoiceAgent?.disconnect) {
            try {
                window.MemoraVoiceAgent.disconnect({ keepMessages: true });
            } catch (_err) { }
        } else if (typeof window.disconnectGeminiLiveConversation === 'function') {
            try {
                window.disconnectGeminiLiveConversation({ keepMessages: true });
            } catch (_err) { }
        }
    }

    if (aiPaneMode === AI_PANE_MODE_GEMINI_LIVE && !voiceAgentEnabled) {
        persistAiPaneMode(AI_PANE_MODE_AI);
        void syncAiPaneModeView(AI_PANE_MODE_AI);
        return;
    }

    if (aiPaneMode === AI_PANE_MODE_PDF_EXPLANATION) {
        void renderPdfExplanationInAiPane($('ai-expl-pdf-select')?.value || '');
    }
}

window.refreshAiPanePdfExplanationIfVisible = (preferredPdfName = '') => {
    if (isMemoraPdfExplanationEnabled() && aiPaneMode === AI_PANE_MODE_PDF_EXPLANATION) {
        void syncAiPaneModeView(AI_PANE_MODE_PDF_EXPLANATION, preferredPdfName);
    }
};

const VIEWER_TOGGLE_SHAPES = Object.freeze({
    pdf: '<path d="M4 5.5c2.4-.9 5-.7 8 1v13c-3-1.7-5.6-1.9-8-1V5.5z"></path><path d="M12 6.5c3-1.7 5.6-1.9 8-1v13c-2.4-.9-5-.7-8 1V6.5z"></path>',
    ai: '<path d="M12 3.8l1.25 3.05 3.05 1.25-3.05 1.25L12 12.4l-1.25-3.05L7.7 8.1l3.05-1.25L12 3.8z"></path><path d="M18 12.6l.8 1.95 1.95.8-1.95.8L18 18.1l-.8-1.95-1.95-.8 1.95-.8.8-1.95z"></path><path d="M6.4 13.4l.7 1.7 1.7.7-1.7.7-.7 1.7-.7-1.7-1.7-.7 1.7-.7.7-1.7z"></path>'
});
const TRIO_TOGGLE_SHAPE = '<rect x="3.5" y="5" width="5" height="14" rx="1.4"></rect><rect x="9.5" y="5" width="5" height="14" rx="1.4"></rect><rect x="15.5" y="5" width="5" height="14" rx="1.4"></rect>';

function stripControlIconPrefix(label) {
    return String(label || '')
        .trim()
        .replace(/^(?:[\u2600-\u27BF]\uFE0F?|[\u{1F300}-\u{1FAFF}]\uFE0F?|\u2AF6)\s*/u, '')
        .trim();
}

function setDockControlSvgShape(svgId, shapeMarkup) {
    const svg = $(svgId);
    const shape = svg?.querySelector('[data-dock-icon-shape]');
    if (!shape) return false;
    shape.innerHTML = shapeMarkup;
    return true;
}

function setDockControlText(labelEl, text) {
    const textEl = labelEl?.querySelector?.('.dock-control-text, .quick-control-text');
    if (textEl) {
        textEl.textContent = text;
        return;
    }
    if (labelEl) labelEl.textContent = text;
}

function setViewerToggleLabel(label) {
    const btn = $('toggle-viewer-btn');
    const viewerLabel = btn?.querySelector('.quick-control-label');
    const actionText = stripControlIconPrefix(label) || 'Show PDF';
    if (viewerLabel) {
        const shape = /\bAI\b/i.test(actionText) ? VIEWER_TOGGLE_SHAPES.ai : VIEWER_TOGGLE_SHAPES.pdf;
        setDockControlSvgShape('viewer-toggle-svg', shape);
    }
    if (typeof syncQuizSourceButtonState === 'function') {
        syncQuizSourceButtonState();
    } else if (viewerLabel) {
        setDockControlText(viewerLabel, 'Source');
    }
    if (btn && !btn.disabled) {
        if (actionText === 'Hide PDF') {
            btn.setAttribute('title', 'Hide source PDF');
            btn.setAttribute('aria-label', 'Hide source PDF');
        } else if (actionText === 'Show PDF') {
            btn.setAttribute('title', 'Show source PDF');
            btn.setAttribute('aria-label', 'Show source PDF');
        } else if (actionText === 'Hide AI') {
            btn.setAttribute('title', 'Hide AI');
            btn.setAttribute('aria-label', 'Hide AI');
        } else {
            btn.setAttribute('title', actionText);
            btn.setAttribute('aria-label', actionText);
        }
    }
}

function setTrioToggleLabel(label) {
    const btn = $('toggle-trio-btn');
    const trioLabel = btn?.querySelector('.gradient-text');
    if (trioLabel) {
        const text = stripControlIconPrefix(label) || 'Trio';
        setDockControlSvgShape('trio-toggle-svg', TRIO_TOGGLE_SHAPE);
        setDockControlText(trioLabel, text);
    }
    if (btn) {
        const text = stripControlIconPrefix(label) || 'Trio';
        if (text.includes('Exit')) {
            btn.setAttribute('title', 'Exit Trio Mode');
        } else {
            btn.setAttribute('title', 'Open PDF + Quiz + AI in three panels');
        }
    }
}

function resetPanelResizeColumnsForModeSwitch() {
    const workArea = els?.workArea || $('work-area');
    if (!workArea) return;
    workArea.style.gridTemplateColumns = '';
    if (!isQuizSlidePaneSourceDeferred() && typeof scheduleAdvancedPdfResponsiveScaleRefresh === 'function') {
        scheduleAdvancedPdfResponsiveScaleRefresh({ preservePage: true });
    }
}

let questionPaneTransitionTimer = 0;
let paneOpenTransitionTimer = 0;
let paneCloseTransitionTimer = 0;
let paneCloseLayoutCommitTimer = 0;
let paneCloseCollapseFrame = 0;
let paneOpenExpandFrame = 0;
let paneOpenExpandTransitionState = null;
let paneOpenGlidePins = null;
let paneOpenCardStartRect = null;
let paneQuizCardGlideOrigin = null;
let paneRailWidthTransition = null;
let paneQuizCardGlideAnimation = null;
let paneOpenLayoutTarget = '';
let paneOpenLayoutRefreshTimer = 0; // Monotonic token for the pre-paint refresh.
let paneCloseLayoutRefreshTimer = 0;
let paneCloseLayoutRefreshFrame = 0;
const PANE_CLOSE_LAYOUT_REFRESH_DELAYS = [120, 220, 180];

// Structural pane motion follows the shared motion policy (app.core.js): the structural tokens time
// every glide, fade, guard and commit. Calm keeps the timing but drops the glides (smooth-mode.css);
// reduced has no pane motion, so every guard and commit settles on the next task.
function getPaneMotionMs(phase = 'in') {
    return getMemoraMotionDuration('structural', phase);
}

const paneLayoutSettledCallbacks = new Set();

function isPaneLayoutTransitioning() {
    const workArea = els?.workArea || $('work-area');
    if (!workArea) return false;
    return !!(
        paneOpenTransitionTimer
        || paneCloseLayoutCommitTimer
        || paneCloseTransitionTimer
        || paneOpenExpandFrame
        || (paneQuizCardGlideAnimation && paneQuizCardGlideAnimation.playState !== 'finished')
        || paneRailWidthTransition
        || questionPaneTransitionTimer
        || workArea.classList.contains('pane-open-expanding')
        || workArea.classList.contains('pane-open-transitioning')
        || workArea.classList.contains('pane-close-transitioning')
        || workArea.classList.contains('pane-close-crushing')
        || workArea.classList.contains('question-pane-transitioning')
    );
}

// One fallback timer guards the whole queue, instead of one per registration.
// Settle passes re-register every frame during a transition, so per-call
// timers piled up (~150 per open). The generation stamps which batch armed the
// timer; a flush bumps it, so a timer can never flush a later batch.
let paneLayoutSettledFallbackTimer = 0;
let paneLayoutSettledGeneration = 0;

function flushPaneLayoutSettledCallbacks() {
    if (paneLayoutSettledFallbackTimer) {
        clearTimeout(paneLayoutSettledFallbackTimer);
        paneLayoutSettledFallbackTimer = 0;
    }
    paneLayoutSettledGeneration += 1;
    if (!paneLayoutSettledCallbacks.size) return;
    const cbs = Array.from(paneLayoutSettledCallbacks);
    paneLayoutSettledCallbacks.clear();
    // Callbacks that register during this loop land in the fresh queue and
    // arm their own fallback, so reentrant work is kept, not dropped.
    cbs.forEach((cb) => {
        try { cb(); } catch (err) { console.error(err); }
    });
}

function whenPaneLayoutSettled(callback) {
    if (typeof callback !== 'function') return;
    if (!isPaneLayoutTransitioning()) {
        requestAnimationFrame(callback);
        return;
    }
    paneLayoutSettledCallbacks.add(callback);
    if (paneLayoutSettledFallbackTimer) return;
    const generation = paneLayoutSettledGeneration;
    paneLayoutSettledFallbackTimer = setTimeout(() => {
        paneLayoutSettledFallbackTimer = 0;
        if (generation !== paneLayoutSettledGeneration) return;
        flushPaneLayoutSettledCallbacks();
    }, getPaneMotionMs('in') + 40);
}

window.whenPaneLayoutSettled = whenPaneLayoutSettled;
window.isPaneLayoutTransitioning = isPaneLayoutTransitioning;

function getPredictedPaneWidth(paneId = 'pdf-pane', targetLayout = null, { round = true } = {}) {
    const workArea = els?.workArea || $('work-area');
    const layout = targetLayout
        || paneOpenLayoutTarget
        || (workArea?.classList.contains('pane-layout-target-trio') || workArea?.classList.contains('trio-view')
            ? 'trio'
            : (workArea?.classList.contains('pane-layout-target-duo') || workArea?.classList.contains('split-view') || workArea?.classList.contains('split-view-ai')
                ? 'duo'
                : (workArea?.classList.contains('pane-layout-target-single') ? 'single' : 'duo')));
    // The glide pins the final tracks, including the user's saved divider ratio.
    // Reuse that measured destination for the card and its Ask/Notes companions.
    if (paneOpenLayoutTarget === layout && workArea?.classList.contains('pane-open-gliding')) {
        const pane = $(paneId);
        const width = pane?.getBoundingClientRect?.().width;
        if (width > 0) return round ? Math.round(width) : width;
    }
    const stacksDuoPanes = layout === 'duo'
        && window.matchMedia?.('(max-width: 768px)')?.matches;
    let workAreaWidth = Number(workArea?.clientWidth) || window.innerWidth || 1000;
    // The left rail collapses for a pairing and expands back for solo a moment after this runs;
    // predict against the rail width the layout lands with. Width plus the rail margin is constant
    // through the rail's own transition.
    const railPreview = window.MemoraLiveLeftRailPreview;
    if (workArea && railPreview?.mounted && typeof railPreview.predictedWidth === 'function'
        && document.body?.classList.contains('memora-live-left-rail-preview')
        && !document.documentElement.classList.contains('phone-device')) {
        const railNow = Number.parseFloat(getComputedStyle(workArea).marginLeft) || 0;
        const railLanding = railPreview.predictedWidth(layout !== 'single');
        if (railLanding > 0) workAreaWidth = Math.max(320, workAreaWidth + railNow - railLanding);
    }
    if (layout === 'single') {
        return Math.max(320, workAreaWidth);
    }
    const paneCount = layout === 'trio' ? 3 : 2;
    const handleCount = layout === 'trio' ? 2 : 1;
    const predictedPaneWidth = stacksDuoPanes
        ? workAreaWidth - 2
        : (workAreaWidth - handleCount) / paneCount;
    // The tracks split the width exactly (661.5px, not 662); callers that size the card to its
    // landing width need the fraction, or the card lands half a pixel off and re-settles.
    return Math.max(200, round ? Math.round(predictedPaneWidth) : predictedPaneWidth);
}

window.getPredictedPaneWidth = getPredictedPaneWidth;

function completePaneOpenTransition(workArea = els?.workArea || $('work-area')) {
    paneOpenTransitionTimer = 0;
    if (!workArea) return;
    workArea.classList.add('no-transition');
    if (paneOpenLayoutTarget) {
        resetQuizCardPosition({ forceLayoutDefault: true, layoutMode: paneOpenLayoutTarget });
        paneOpenLayoutTarget = '';
        commitPaneLayoutTargetGeometry(workArea);
        clearPaneLayoutTarget(workArea);
    }
    // Pre-paint refreshes use a sequence token instead of a timer.
    // Invalidate any queued refresh if cleanup is forced early.
    paneOpenLayoutRefreshTimer += 1;

    clearPaneOpenExpansion(workArea, { resetColumns: true });
    window.restorePanelResizeRatio?.();
    workArea.classList.remove('pane-open-transitioning');
    void workArea.offsetHeight;
    workArea.classList.remove('no-transition');
    // A slide deferred under Ask/Notes is unseen; its reveal loads and scales it.
    const sourceDeferred = isQuizSlidePaneSourceDeferred();
    if (!sourceDeferred && typeof scheduleAdvancedPdfResponsiveScaleRefresh === 'function') {
        scheduleAdvancedPdfResponsiveScaleRefresh({ preservePage: true });
    }
    flushPaneLayoutSettledCallbacks();
    if (!sourceDeferred && typeof syncPdfScaleForCurrentLayoutModeSwitch === 'function') {
        void syncPdfScaleForCurrentLayoutModeSwitch();
    }
}

function schedulePaneOpenTransitionCleanup(
    workArea = els?.workArea || $('work-area'),
    delayMs = getPaneMotionMs('in')
) {
    if (!workArea) return;
    if (paneOpenTransitionTimer) clearTimeout(paneOpenTransitionTimer);
    const delay = Number(delayMs);
    paneOpenTransitionTimer = setTimeout(
        () => completePaneOpenTransition(workArea),
        Number.isFinite(delay) ? Math.max(0, delay) : getPaneMotionMs('in')
    );
}

function markQuestionPaneTransitioning() {
    const workArea = els?.workArea || $('work-area');
    if (!workArea) return;
    if (questionPaneTransitionTimer) {
        clearTimeout(questionPaneTransitionTimer);
        questionPaneTransitionTimer = 0;
    }
    if (getMemoraMotionMode() === 'reduced') {
        workArea.classList.remove('question-pane-transitioning');
        return;
    }
    workArea.classList.add('question-pane-transitioning');
    questionPaneTransitionTimer = setTimeout(() => {
        questionPaneTransitionTimer = 0;
        workArea.classList.remove('question-pane-transitioning');
    }, 420);
}

function markPaneOpenTransitioning({ targetLayout = '' } = {}) {
    const workArea = els?.workArea || $('work-area');
    if (!workArea) return;
    // Capture before the rail and target layout move the card.
    paneOpenCardStartRect = (els?.quizCard || $('quiz-card'))?.getBoundingClientRect?.();
    if (typeof window.triggerMemoraSurfaceSettle === 'function') {
        window.triggerMemoraSurfaceSettle('pane', getPaneMotionMs('in') + 90);
    }
    window.followQuizCompanionsThroughPaneTransition?.();
    const interruptedPaneClose = !!paneCloseLayoutCommitTimer
        || workArea.classList.contains('pane-close-crushing')
        || workArea.classList.contains('pane-close-transitioning');
    if (paneCloseLayoutCommitTimer) {
        clearTimeout(paneCloseLayoutCommitTimer);
        paneCloseLayoutCommitTimer = 0;
    }
    if (interruptedPaneClose) {
        clearPaneCloseCollapse(workArea, { clearPaneAnimations: true });
        resetPanelResizeColumnsForModeSwitch();
    }
    if (paneOpenTransitionTimer) {
        clearTimeout(paneOpenTransitionTimer);
        paneOpenTransitionTimer = 0;
    }
    clearPaneOpenExpansion(workArea, { resetColumns: true });
    clearPaneLayoutTarget(workArea);
    paneOpenLayoutTarget = targetLayout;
    if (targetLayout) {
        setPaneLayoutTarget(workArea, targetLayout);
        const paneOpenLayoutRefreshToken = ++paneOpenLayoutRefreshTimer;
        // Resolve the destination content geometry before the browser's first
        // paint. A delayed mid-animation measurement samples an in-between
        // pane size and visibly retargets the card height/content scale.
        queueMicrotask(() => {
            if (paneOpenLayoutRefreshTimer !== paneOpenLayoutRefreshToken || paneOpenLayoutTarget !== targetLayout || !workArea.classList.contains('pane-open-transitioning')) return;
            if (typeof applyQuizCardContentScale === 'function') applyQuizCardContentScale();
            setPaneLayoutTarget(workArea, targetLayout, {
                useCurrentPaneSize: false,
                normalizeHeight: true
            });
        });
    }
    workArea.classList.add('pane-open-transitioning');
    if (!isQuizSlidePaneSourceDeferred() && typeof scheduleAdvancedPdfResponsiveScaleRefresh === 'function') {
        scheduleAdvancedPdfResponsiveScaleRefresh({ preservePage: true });
    }
    schedulePaneOpenTransitionCleanup(workArea);
}

function getPaneCloseGridColumn(workArea, rect) {
    const workRect = workArea?.getBoundingClientRect?.();
    const columns = String(getComputedStyle(workArea).gridTemplateColumns || '')
        .trim()
        .split(/\s+/)
        .map((column) => Number.parseFloat(column));
    if (!workRect || !columns.length || columns.some((width) => !Number.isFinite(width))) return 1;

    const centerX = Number(rect.left) - Number(workRect.left) + (Number(rect.width) / 2);
    let offset = 0;
    let bestColumn = 1;
    let bestDistance = Number.POSITIVE_INFINITY;
    columns.forEach((width, index) => {
        const left = offset;
        const right = offset + width;
        const mid = left + (width / 2);
        const containsCenter = centerX >= left - 1 && centerX <= right + 1;
        const distance = containsCenter ? 0 : Math.abs(centerX - mid);
        if (width > 1 && distance < bestDistance) {
            bestDistance = distance;
            bestColumn = index + 1;
        }
        offset = right;
    });
    return bestColumn;
}

function pinPaneCloseGridPlacement(workArea, pane, rect) {
    if (!workArea || !pane || !rect) return;
    if (pane.dataset.memoraPaneCloseGridPinned !== '1') {
        pane.dataset.memoraPaneCloseGridPinned = '1';
        pane.dataset.memoraPaneCloseGridColumn = pane.style.gridColumn || '';
        pane.dataset.memoraPaneCloseGridRow = pane.style.gridRow || '';
    }
    pane.style.gridColumn = String(getPaneCloseGridColumn(workArea, rect));
    pane.style.gridRow = '1';
}

function restorePaneCloseGridPlacement(pane) {
    if (!pane || pane.dataset.memoraPaneCloseGridPinned !== '1') return;
    const previousColumn = pane.dataset.memoraPaneCloseGridColumn || '';
    const previousRow = pane.dataset.memoraPaneCloseGridRow || '';
    if (previousColumn) pane.style.gridColumn = previousColumn;
    else pane.style.removeProperty('grid-column');
    if (previousRow) pane.style.gridRow = previousRow;
    else pane.style.removeProperty('grid-row');
    delete pane.dataset.memoraPaneCloseGridPinned;
    delete pane.dataset.memoraPaneCloseGridColumn;
    delete pane.dataset.memoraPaneCloseGridRow;
}

function clearPaneCloseAnimation(pane) {
    if (!pane) return;
    pane.classList.remove('pane-soft-closing');
    pane.classList.remove('pane-soft-closing-in-flow');
    pane.classList.remove('pane-soft-closing-to-wall');
    pane.style.removeProperty('--pane-close-left');
    pane.style.removeProperty('--pane-close-top');
    pane.style.removeProperty('--pane-close-width');
    pane.style.removeProperty('--pane-close-height');
    pane.style.removeProperty('--pane-close-shift');
    pane.style.removeProperty('--pane-close-origin-x');
    restorePaneCloseGridPlacement(pane);
}

function clearPaneLayoutTarget(workArea = els?.workArea || $('work-area')) {
    if (!workArea) return;
    workArea.classList.remove('pane-layout-target-single', 'pane-layout-target-duo', 'pane-layout-target-trio');
    const card = els?.quizCard || $('quiz-card');
    card?.style.removeProperty('--pane-layout-target-card-width');
    card?.style.removeProperty('--pane-layout-target-card-height');
}

function commitPaneLayoutTargetGeometry(workArea = els?.workArea || $('work-area')) {
    if (!workArea?.classList.contains('pane-layout-target-single')
        && !workArea?.classList.contains('pane-layout-target-duo')
        && !workArea?.classList.contains('pane-layout-target-trio')) return;
    const card = els?.quizCard || $('quiz-card');
    if (!card || card.classList.contains('is-floating') || card.classList.contains('quiz-card-expanded')) return;
    const isPhoneLayout = typeof isPhoneQuizCardGeometryLocked === 'function'
        && isPhoneQuizCardGeometryLocked();
    if (isPhoneLayout) {
        card.style.width = '';
        card.style.height = '';
        clearPaneLayoutTarget(workArea);
        if (typeof syncQuizCardCustomGeometryState === 'function') syncQuizCardCustomGeometryState();
        return;
    }
    const rect = card.getBoundingClientRect();
    const targetWidth = Number.parseFloat(card.style.getPropertyValue('--pane-layout-target-card-width'));
    const targetHeight = Number.parseFloat(card.style.getPropertyValue('--pane-layout-target-card-height'));
    const width = Number.isFinite(targetWidth) ? targetWidth : rect.width;
    const height = Number.isFinite(targetHeight) ? targetHeight : rect.height;
    if (!Number.isFinite(width) || !Number.isFinite(height)) return;
    card.style.width = `${Math.round(width)}px`;
    card.style.height = `${Math.round(height)}px`;
    if (typeof syncQuizCardCustomGeometryState === 'function') syncQuizCardCustomGeometryState();
}

function clearPaneCloseCollapse(
    workArea = els?.workArea || $('work-area'),
    { commitCardGeometry = false, clearPaneAnimations = false } = {}
) {
    if (!workArea) return;
    if (commitCardGeometry) commitPaneLayoutTargetGeometry(workArea);
    if (clearPaneAnimations) {
        if (paneCloseTransitionTimer) {
            clearTimeout(paneCloseTransitionTimer);
            paneCloseTransitionTimer = 0;
        }
        workArea.classList.remove('pane-close-transitioning');
        [els?.pdfPane || $('pdf-pane'), $('ai-pane')].forEach((pane) => {
            if (!pane) return;
            if (pane._memoraPaneCloseTimer) {
                clearTimeout(pane._memoraPaneCloseTimer);
                pane._memoraPaneCloseTimer = 0;
            }
            clearPaneCloseAnimation(pane);
        });
    }
    if (paneCloseLayoutRefreshTimer) {
        clearTimeout(paneCloseLayoutRefreshTimer);
        paneCloseLayoutRefreshTimer = 0;
    }
    if (paneCloseLayoutRefreshFrame) {
        cancelAnimationFrame(paneCloseLayoutRefreshFrame);
        paneCloseLayoutRefreshFrame = 0;
    }
    if (paneCloseCollapseFrame) {
        cancelAnimationFrame(paneCloseCollapseFrame);
        paneCloseCollapseFrame = 0;
    }
    workArea.classList.remove('pane-close-crushing', 'pane-close-crush-left', 'pane-close-crush-right');
    clearPaneLayoutTarget(workArea);
    flushPaneLayoutSettledCallbacks();
}

function clearPaneOpenAnimation(pane) {
    if (!pane) return;
    pane.classList.remove('pane-soft-opening-from-wall', 'pane-glide-opening-from-wall');
    pane.style.removeProperty('--pane-open-origin-x');
    pane.style.removeProperty('--pane-open-glide-from');
}

function clearPaneQuizCardBoundsAnimation() {
    paneQuizCardGlideAnimation?.cancel();
    paneQuizCardGlideAnimation = null;
    if (!paneQuizCardGlideOrigin) return;
    const { card, value, priority } = paneQuizCardGlideOrigin;
    paneQuizCardGlideOrigin = null;
    if (value) card.style.setProperty('transform-origin', value, priority);
    else card.style.removeProperty('transform-origin');
}

// Lay out once, then interpolate the complete visible bounds on the compositor.
function animatePaneQuizCardBounds(card, startRect, phase) {
    clearPaneQuizCardBoundsAnimation();
    if (!card || !startRect || !memoraMotionAllowsSpatial('structural')) return;
    const endRect = card.getBoundingClientRect();
    if (!(startRect.width > 0 && startRect.height > 0 && endRect.width > 0 && endRect.height > 0)) return;
    paneQuizCardGlideOrigin = {
        card,
        value: card.style.getPropertyValue('transform-origin'),
        priority: card.style.getPropertyPriority('transform-origin')
    };
    card.style.setProperty('transform-origin', 'top left');
    window.syncQuizCompanionVerticalGeometry?.();
    const animation = card.animate([
        { transform: `translate(${startRect.left - endRect.left}px, ${startRect.top - endRect.top}px) scale(${startRect.width / endRect.width}, ${startRect.height / endRect.height})` },
        { transform: 'translate(0, 0) scale(1, 1)' }
    ], { duration: getPaneMotionMs(phase), easing: getMemoraMotionEasing('soft') });
    paneQuizCardGlideAnimation = animation;
    animation.onfinish = () => {
        if (paneQuizCardGlideAnimation !== animation) return;
        clearPaneQuizCardBoundsAnimation();
        if (!isPaneLayoutTransitioning()) flushPaneLayoutSettledCallbacks();
    };
}

function clearPaneOpenExpansion(
    workArea = els?.workArea || $('work-area'),
    { resetColumns = false } = {}
) {
    if (!workArea) return;
    clearPaneQuizCardBoundsAnimation();
    if (paneOpenExpandFrame) {
        cancelAnimationFrame(paneOpenExpandFrame);
        paneOpenExpandFrame = 0;
    }
    if (paneOpenExpandTransitionState?.workArea === workArea) {
        const { value, priority } = paneOpenExpandTransitionState;
        if (value) {
            workArea.style.setProperty('transition', value, priority);
        } else {
            workArea.style.removeProperty('transition');
        }
        paneOpenExpandTransitionState = null;
    }
    workArea.classList.remove('pane-open-expanding', 'pane-open-gliding');
    releasePaneOpenGlidePins();
    delete workArea.dataset.paneOpenTargetLayout;
    [els?.pdfPane || $('pdf-pane'), $('ai-pane')].forEach(clearPaneOpenAnimation);
    if (resetColumns) workArea.style.gridTemplateColumns = '';
}

/* Pin the settled left inset before measuring the landing position. Auto margins would move
   the card a second time when the temporary transition geometry is released. */
function pinPaneOpenGlideGeometry(card, quizPane) {
    releasePaneOpenGlidePins();
    const landingWidth = Number.parseFloat(card?.style.getPropertyValue('--pane-layout-target-card-width'));
    if (!card || !quizPane || !Number.isFinite(landingWidth)) return;
    paneOpenGlidePins = {
        card,
        quizPane,
        marginLeft: card.style.getPropertyValue('margin-left'),
        marginLeftPriority: card.style.getPropertyPriority('margin-left'),
        transition: quizPane.style.getPropertyValue('transition'),
        transitionPriority: quizPane.style.getPropertyPriority('transition')
    };
    // Take the landing layout once; only the card's transform and opacity animate.
    quizPane.style.setProperty('transition', 'none', 'important');
    const paneStyles = getComputedStyle(quizPane);
    const contentWidth = quizPane.getBoundingClientRect().width
        - (Number.parseFloat(paneStyles.borderLeftWidth) || 0)
        - (Number.parseFloat(paneStyles.borderRightWidth) || 0)
        - (Number.parseFloat(paneStyles.paddingLeft) || 0)
        - (Number.parseFloat(paneStyles.paddingRight) || 0);
    if (!(contentWidth > landingWidth)) return;
    // The rail's duo card is not centred: it sits a fixed inset from the rail, leaving the Tools
    // tab its room on the right (live-left-rail-polish.css). Pin to that so it does not hop at the end.
    const railInset = Number.parseFloat(getComputedStyle(document.body).getPropertyValue('--memora-rail-duo-card-inset'));
    const marginLeft = Number.isFinite(railInset) && getRailSplitQuizCardGutter() > 0
        ? railInset
        : (contentWidth - landingWidth) / 2;
    card.style.setProperty('margin-left', `${marginLeft}px`, 'important');
}

function releasePaneOpenGlidePins() {
    if (!paneOpenGlidePins) return;
    const { card, quizPane, marginLeft, marginLeftPriority, transition, transitionPriority } = paneOpenGlidePins;
    paneOpenGlidePins = null;
    if (marginLeft) card.style.setProperty('margin-left', marginLeft, marginLeftPriority);
    else card.style.removeProperty('margin-left');
    if (transition) quizPane.style.setProperty('transition', transition, transitionPriority);
    else quizPane.style.removeProperty('transition');
}

/* Lay out the destination once, then transform the card's complete recorded bounds to it.
   The visible width, height and position all move without reflowing the question each frame. */
function beginPaneOpenCardGlide(workArea, startWidths, widths, openingPanes) {
    const card = els?.quizCard || $('quiz-card');
    if (!card || typeof card.animate !== 'function'
        || card.classList.contains('is-floating')
        || card.classList.contains('quiz-card-expanded')
        || getComputedStyle(card).display === 'none') return false;
    paneOpenExpandTransitionState = {
        workArea,
        value: workArea.style.getPropertyValue('transition'),
        priority: workArea.style.getPropertyPriority('transition')
    };
    workArea.style.setProperty('transition', 'none', 'important');
    workArea.style.gridTemplateColumns = startWidths.map((width) => `${width}px`).join(' ');
    const startRect = paneOpenCardStartRect || card.getBoundingClientRect();
    paneOpenCardStartRect = null;
    workArea.style.gridTemplateColumns = widths.map((width) => `${width}px`).join(' ');
    // Unclamps the card (layout.css) before the landing measurement, so the glide starts from
    // exactly where the solo card stood.
    workArea.classList.add('pane-open-gliding');
    pinPaneOpenGlideGeometry(card, els?.quizPane || $('quiz-pane'));
    openingPanes.forEach((pane) => {
        const fromLeftWall = pane.style.getPropertyValue('--pane-open-origin-x') === 'left';
        const width = Math.round(pane.getBoundingClientRect().width) || 0;
        pane.classList.remove('pane-soft-opening-from-wall');
        pane.style.setProperty('--pane-open-glide-from', `${fromLeftWall ? -width : width}px`);
        pane.classList.add('pane-glide-opening-from-wall');
    });
    const token = paneOpenLayoutRefreshTimer;
    queueMicrotask(() => {
        if (token !== paneOpenLayoutRefreshTimer || !workArea.classList.contains('pane-open-gliding')) return;
        animatePaneQuizCardBounds(card, startRect, 'in');
        schedulePaneOpenTransitionCleanup(workArea, getPaneMotionMs('in') + 40);
    });
    return true;
}

// Restore the rail frame and its content pins without starting a second width transition.
function clearPaneRailWidthTransition() {
    if (!paneRailWidthTransition) return;
    const { rail, width, widthPriority, transition, transitionPriority, overflow, overflowPriority, children, timer } = paneRailWidthTransition;
    clearTimeout(timer);
    document.body.classList.remove('memora-rail-width-animating');
    children.forEach(({ node, width, widthPriority, align, alignPriority }) => {
        if (width) node.style.setProperty('width', width, widthPriority);
        else node.style.removeProperty('width');
        if (align) node.style.setProperty('align-self', align, alignPriority);
        else node.style.removeProperty('align-self');
    });
    if (overflow) rail.style.setProperty('overflow', overflow, overflowPriority);
    else rail.style.removeProperty('overflow');
    rail.style.setProperty('transition', 'none', 'important');
    if (width) rail.style.setProperty('width', width, widthPriority);
    else rail.style.removeProperty('width');
    // A style flush is enough to commit the start width; a layout here would lay out the whole page.
    void getComputedStyle(rail).transitionProperty;
    if (transition) rail.style.setProperty('transition', transition, transitionPriority);
    else rail.style.removeProperty('transition');
    paneRailWidthTransition = null;
}

function animatePaneRailWidth(rail, fromWidth, toWidth, phase, { childWidths = null, workSurface = '' } = {}) {
    if (!(fromWidth > 0 && toWidth > 0) || Math.abs(fromWidth - toWidth) < 1 || !memoraMotionAllowsSpatial('structural')) return;
    const state = {
        rail,
        width: rail.style.getPropertyValue('width'),
        widthPriority: rail.style.getPropertyPriority('width'),
        transition: rail.style.getPropertyValue('transition'),
        transitionPriority: rail.style.getPropertyPriority('transition'),
        overflow: rail.style.getPropertyValue('overflow'),
        overflowPriority: rail.style.getPropertyPriority('overflow'),
        children: [],
        timer: 0
    };
    // Keep the rail's contents at their landing widths while only its outer frame resizes.
    // This avoids re-centering compact icons and re-wrapping labels on every frame.
    state.children = Array.from(rail.children).map((node, index) => ({
        node,
        pixels: childWidths ? childWidths[index] : node.getBoundingClientRect().width,
        width: node.style.getPropertyValue('width'),
        widthPriority: node.style.getPropertyPriority('width'),
        align: node.style.getPropertyValue('align-self'),
        alignPriority: node.style.getPropertyPriority('align-self')
    })).filter(({ pixels }) => pixels > 0);
    state.children.forEach(({ node, pixels }) => {
        node.style.setProperty('width', `${pixels}px`, 'important');
        node.style.setProperty('align-self', 'flex-start', 'important');
    });
    rail.style.setProperty('overflow', 'hidden', 'important');
    paneRailWidthTransition = state;
    // Until the rail lands, the strip it has yet to cover shows the work surface, not the page background.
    const gapSurface = workSurface || getComputedStyle(els?.workArea || $('work-area') || document.body).backgroundColor;
    if (gapSurface) document.body.style.setProperty('--memora-rail-gap-bg', gapSurface);
    document.body.classList.add('memora-rail-width-animating');
    rail.style.setProperty('transition', 'none', 'important');
    rail.style.setProperty('width', `${fromWidth}px`, 'important');
    // A style flush is enough to commit the start width; a layout here would lay out the whole page.
    void getComputedStyle(rail).transitionProperty;
    queueMicrotask(() => {
        if (paneRailWidthTransition !== state) return;
        const duration = getPaneMotionMs(phase);
        rail.style.setProperty('transition', `width ${duration}ms ${getMemoraMotionEasing('soft')}`, 'important');
        rail.style.setProperty('width', `${toWidth}px`, 'important');
        state.timer = setTimeout(() => {
            if (paneRailWidthTransition !== state) return;
            clearPaneRailWidthTransition();
            if (!isPaneLayoutTransitioning()) flushPaneLayoutSettledCallbacks();
        }, duration + 40);
    });
}

function settleLeftRailForPairing(workArea, paired = true) {
    const railPreview = window.MemoraLiveLeftRailPreview;
    if (!workArea) return;
    const rail = $('controls-bar');
    const fromWidth = rail?.getBoundingClientRect?.().width || 0;
    if (fromWidth > 0) clearPaneRailWidthTransition();
    // Measure the workspace at its landing width once. The rail replays its visible width
    // independently, so its motion does not resize the question or source layout per frame.
    const transitionStates = [workArea, $('controls-bar')].filter(Boolean).map((node) => ({
        node,
        value: node.style.getPropertyValue('transition'),
        priority: node.style.getPropertyPriority('transition')
    }));
    transitionStates.forEach(({ node }) => node.style.setProperty('transition', 'none', 'important'));
    let toWidth = 0;
    let childWidths = null;
    let workSurface = '';
    try {
        if (railPreview?.mounted && typeof railPreview.syncCompact === 'function') railPreview.syncCompact(paired);
        if (paired) window.restorePanelResizeRatio?.();
        void workArea.offsetWidth;
        // Read the rail's landing geometry from this layout. After the transitions are restored,
        // each read would cost another full style pass inside the click.
        if (fromWidth > 0) {
            toWidth = rail.getBoundingClientRect().width;
            childWidths = Array.from(rail.children).map((node) => node.getBoundingClientRect().width);
            workSurface = getComputedStyle(workArea).backgroundColor;
        }
    } finally {
        transitionStates.forEach(({ node, value, priority }) => {
            if (value) node.style.setProperty('transition', value, priority);
            else node.style.removeProperty('transition');
        });
    }
    if (fromWidth > 0) animatePaneRailWidth(rail, fromWidth, toWidth, paired ? 'in' : 'out', { childWidths, workSurface });
}

function beginPaneOpenExpansion(targets = [], { targetLayout = '' } = {}) {
    const workArea = els?.workArea || $('work-area');
    // Restore the saved divider before taking the destination measurement, for every motion mode.
    if (!workArea) return false;
    settleLeftRailForPairing(workArea);
    // Without structural travel the panes land at their final tracks and only fade (calm) or
    // appear (reduced); markPaneOpenTransitioning already scheduled that cleanup.
    if (!memoraMotionAllowsSpatial('structural')) return false;
    // This open owns the tracks now; retain the restored ratio while clearing old animation state.
    clearPaneOpenExpansion(workArea, { resetColumns: false });
    setPaneLayoutTarget(workArea, targetLayout, { useCurrentPaneSize: true, normalizeHeight: true });

    const columns = String(getComputedStyle(workArea).gridTemplateColumns || '')
        .trim()
        .split(/\s+/);
    const widths = columns.map((column) => Number.parseFloat(column));
    if (![3, 5].includes(columns.length) || widths.some((width) => !Number.isFinite(width))) return false;

    const targetList = Array.isArray(targets) ? targets : [targets];
    const paneMap = {
        pdf: els?.pdfPane || $('pdf-pane'),
        ai: $('ai-pane')
    };
    const openingPanes = [];
    const collapsedTrackIndexes = new Set();
    // Read once: after the first pane's class write every clientWidth read forces a style pass.
    const workAreaWidth = workArea.clientWidth;
    targetList.forEach((target) => {
        const pane = paneMap[target];
        if (!pane) return;
        const gridColumn = Number.parseInt(getComputedStyle(pane).gridColumnStart || pane.style.gridColumn, 10);
        if (!Number.isInteger(gridColumn) || gridColumn < 1 || gridColumn > columns.length) return;
        const paneTrackIndex = gridColumn - 1;
        collapsedTrackIndexes.add(paneTrackIndex);
        if (paneTrackIndex > 0) collapsedTrackIndexes.add(paneTrackIndex - 1);
        if (paneTrackIndex < columns.length - 1) collapsedTrackIndexes.add(paneTrackIndex + 1);
        const paneCenter = widths.slice(0, paneTrackIndex).reduce((sum, width) => sum + width, 0)
            + (widths[paneTrackIndex] / 2);
        pane.style.setProperty('--pane-open-origin-x', paneCenter < (workAreaWidth / 2) ? 'left' : 'right');
        pane.classList.add('pane-soft-opening-from-wall');
        openingPanes.push(pane);
    });
    if (!openingPanes.length) return false;

    const startWidths = widths.map((width, index) => collapsedTrackIndexes.has(index) ? 0 : width);
    const survivingPaneIndexes = startWidths
        .map((width, index) => ({ width, index }))
        .filter(({ width, index }) => index % 2 === 0 && width > 0 && !collapsedTrackIndexes.has(index));
    const survivingPaneWidth = survivingPaneIndexes.reduce((sum, { width }) => sum + width, 0);
    const missingWidth = Math.max(0, workAreaWidth - startWidths.reduce((sum, width) => sum + width, 0));
    if (!survivingPaneIndexes.length || survivingPaneWidth < 1) {
        openingPanes.forEach(clearPaneOpenAnimation);
        return false;
    }
    survivingPaneIndexes.forEach(({ width, index }) => {
        startWidths[index] += missingWidth * (width / survivingPaneWidth);
    });

    if (targetLayout === 'duo' && survivingPaneIndexes.length === 1
        && beginPaneOpenCardGlide(workArea, startWidths, widths, openingPanes)) {
        schedulePaneOpenTransitionCleanup(workArea, getPaneMotionMs('in') + 40);
        return true;
    }

    workArea.classList.add('pane-open-expanding');
    workArea.dataset.paneOpenTargetLayout = String(targetLayout || '');
    paneOpenExpandTransitionState = {
        workArea,
        value: workArea.style.getPropertyValue('transition'),
        priority: workArea.style.getPropertyPriority('transition')
    };
    workArea.style.setProperty('transition', 'none', 'important');
    workArea.style.gridTemplateColumns = startWidths.map((width) => `${width}px`).join(' ');
    void workArea.offsetWidth;
    let startedAt = 0;
    const expandMs = Math.max(1, getPaneMotionMs('in'));
    const expandFrame = (timestamp) => {
        if (!workArea.classList.contains('pane-open-expanding')) {
            paneOpenExpandFrame = 0;
            return;
        }
        if (!startedAt) startedAt = timestamp;
        const progress = Math.min(1, Math.max(0, (timestamp - startedAt) / expandMs));
        const easedProgress = 1 - Math.pow(1 - progress, 3);
        const currentWidths = startWidths.map((startWidth, index) => {
            return startWidth + ((widths[index] - startWidth) * easedProgress);
        });
        workArea.style.gridTemplateColumns = currentWidths.map((width) => `${width.toFixed(3)}px`).join(' ');
        // Companions follow the card inside the layout this write already requires.
        window.followQuizCompanionsForPaneFrame?.();
        if (progress < 1) {
            paneOpenExpandFrame = requestAnimationFrame(expandFrame);
            return;
        }
        paneOpenExpandFrame = 0;
        workArea.style.gridTemplateColumns = widths.map((width) => `${width}px`).join(' ');
    };
    paneOpenExpandFrame = requestAnimationFrame(expandFrame);
    schedulePaneOpenTransitionCleanup(workArea, getPaneMotionMs('in') + 40);
    return true;
}

// The rail host caps a solo quiz card at its pane's content width minus the Tools-tab reserve
// (app.live-left-rail-host.js). A pane close animates toward this width so it lands without the
// cap snapping it narrower afterwards. #quiz-pane pads 1.5rem per side in solo.
function getRailSoloQuizCardWidthCap(workArea, card) {
    const root = document.documentElement;
    if (!document.body?.classList.contains('memora-live-left-rail-preview')
        || root.classList.contains('phone-device')
        || document.body.classList.contains('ask-ai-docked-open')
        || workArea?.dataset?.memoraStage !== 'quiz'
        || card?.dataset?.quizManualGeometry === '1'
        || !window.matchMedia?.('(min-width: 1200px)')?.matches) return 0;
    const rootStyle = getComputedStyle(root);
    const reserve = Number.parseFloat(rootStyle.getPropertyValue('--memora-rail-solo-card-reserve'));
    if (!Number.isFinite(reserve)) return 0;
    const remPx = Number.parseFloat(rootStyle.fontSize) || 16;
    const paneContentWidth = (Number(workArea?.clientWidth) || 0) - (2 * 1.5 * remPx);
    return paneContentWidth > reserve ? Math.floor(paneContentWidth - reserve) : 0;
}

// Beside a pane the rail keeps this much room on each side of the card, so the Tools tab hanging
// off its right edge stays inside the quiz pane (app.live-left-rail-host.js). 0 elsewhere.
function getRailSplitQuizCardGutter() {
    if (!document.body?.classList.contains('memora-live-left-rail-preview')
        || document.documentElement.classList.contains('phone-device')) return 0;
    const gutter = Number.parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--memora-rail-split-card-gutter'));
    return Number.isFinite(gutter) && gutter > 0 ? gutter : 0;
}

function setPaneLayoutTarget(workArea, targetLayout = 'single', {
    useCurrentPaneSize = false,
    normalizeHeight = false
} = {}) {
    const card = els?.quizCard || $('quiz-card');
    if (!card || card.classList.contains('quiz-card-expanded')) return;
    const isPhoneLayout = typeof isPhoneQuizCardGeometryLocked === 'function'
        && isPhoneQuizCardGeometryLocked();
    if (isPhoneLayout) {
        card.style.width = '';
        card.style.height = '';
        clearPaneLayoutTarget(workArea);
        if (typeof syncQuizCardCustomGeometryState === 'function') syncQuizCardCustomGeometryState();
        return;
    }
    if (card.classList.contains('is-floating')) {
        if (typeof resetQuizCardPosition === 'function') {
            resetQuizCardPosition({ forceLayoutDefault: true, layoutMode: targetLayout });
        }
        if (card.classList.contains('is-floating')) return;
    }

    workArea.classList.add(`pane-layout-target-${targetLayout}`);
    const quizPane = els?.quizPane || $('quiz-pane');
    const quizRect = quizPane?.getBoundingClientRect?.() || null;
    const cardRect = card.getBoundingClientRect();
    const stacksDuoPanes = targetLayout === 'duo'
        && window.matchMedia?.('(max-width: 768px)')?.matches;
    const predictedPaneHeight = stacksDuoPanes
        ? (Number(workArea?.clientHeight) || window.innerHeight) / 2
        : Number(workArea?.clientHeight) || window.innerHeight;
    const paneHeight = Math.max(
        300,
        Number(useCurrentPaneSize && quizRect?.height) || predictedPaneHeight
    );
    const topOffset = Math.max(0, Number(cardRect?.top) - Number(quizRect?.top) || 0);
    const bottomClearance = targetLayout === 'single' ? 12 : 10;
    const maxHeight = Math.max(220, Math.min(paneHeight - 24, paneHeight - topOffset - bottomClearance));
    const singleDefault = typeof QUIZ_CARD_DEFAULT_GEOMETRY !== 'undefined'
        ? QUIZ_CARD_DEFAULT_GEOMETRY.single
        : null;
    let targetWidth = Number(singleDefault?.width) || 1120;
    let targetHeight = Math.min(Number(singleDefault?.height) || 620, maxHeight);

    if (targetLayout === 'duo' || targetLayout === 'trio') {
        const predictedPaneWidth = getPredictedPaneWidth('quiz-pane', targetLayout, { round: false });
        const paneWidth = Math.max(
            320,
            Number(useCurrentPaneSize && quizRect?.width) || predictedPaneWidth
        );
        const maxWidth = Math.max(320, Math.min(Math.round(paneWidth - 24), 900));
        targetWidth = Math.round(maxWidth * (targetLayout === 'trio' ? 0.96 : 0.94));
        // A settled split pane pads 1rem per side and caps the card at 100% - 2rem (the rail keeps
        // a wider gutter for the Tools tab). Resolve against that cap exactly, borders and the
        // fractional track included, so the card lands at the width its content scale was set for
        // and nothing re-settles after the transition.
        const remPx = Number.parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
        const quizPaneStyles = quizPane ? getComputedStyle(quizPane) : null;
        const paneBorderX = (Number.parseFloat(quizPaneStyles?.borderLeftWidth) || 0)
            + (Number.parseFloat(quizPaneStyles?.borderRightWidth) || 0);
        const cardGutter = Math.max(remPx, getRailSplitQuizCardGutter());
        const columnWidth = paneWidth - paneBorderX - (2 * remPx) - (2 * cardGutter);
        // On the rail the duo card fills its column up to the Tools tab, uncapped. It is a pixel
        // width, not CSS calc(100% - ...): a percentage width re-resolved against the full-width
        // column when the pane closed, and the card ballooned before easing back to solo.
        targetWidth = targetLayout === 'duo' && getRailSplitQuizCardGutter() > 0
            ? columnWidth
            : Math.min(targetWidth, columnWidth);
        targetHeight = targetLayout === 'duo'
            ? Math.min(Number(typeof QUIZ_CARD_DEFAULT_GEOMETRY !== 'undefined' ? QUIZ_CARD_DEFAULT_GEOMETRY.duo?.height : 700) || 700, maxHeight)
            : maxHeight;
    } else {
        try {
            const store = JSON.parse(localStorage.getItem('quiz_card_geometry_v2') || '{}');
            // Only a size the learner chose by resizing outlives a change to the default.
            const manual = store?.single?.manual === true;
            const savedWidth = manual ? Number(store?.single?.width) : Number.NaN;
            const savedHeight = manual ? Number(store?.single?.height) : Number.NaN;
            if (Number.isFinite(savedWidth) && savedWidth > 0) targetWidth = savedWidth;
            if (Number.isFinite(savedHeight) && savedHeight > 0) targetHeight = Math.min(savedHeight, maxHeight);
        } catch (_err) {
            // Use the default solo-card dimensions when local storage is unavailable.
        }
        const soloCap = getRailSoloQuizCardWidthCap(workArea, card);
        if (soloCap > 0) targetWidth = Math.min(targetWidth, soloCap);
    }

    if (normalizeHeight) {
        const navRow = $('nav-row');
        const navRect = navRow?.getBoundingClientRect?.() || null;
        const cardStyles = getComputedStyle(card);
        const paddingBottom = Number.parseFloat(cardStyles.paddingBottom) || 0;
        const cssMinHeight = Math.max(0, Number.parseFloat(cardStyles.minHeight) || 0);
        const bounds = typeof getQuizCardSizeBounds === 'function'
            ? getQuizCardSizeBounds(targetLayout)
            : null;
        const minHeight = Math.max(cssMinHeight, Number(bounds?.minH) || 0);
        if (Number.isFinite(navRect?.bottom) && Number.isFinite(cardRect?.top)) {
            const normalizedHeight = Math.round(Math.max(
                minHeight,
                (navRect.bottom - cardRect.top) + paddingBottom + 12
            ));
            targetHeight = Math.max(minHeight, Math.min(targetHeight, normalizedHeight));
        }
    }

    const availableWidth = Math.max(320, Number(workArea?.clientWidth) - 24 || 0);
    const landingWidth = Math.min(1656, availableWidth, targetWidth);
    card.style.setProperty('--pane-layout-target-card-width', `${Math.round(landingWidth * 100) / 100}px`);
    card.style.setProperty('--pane-layout-target-card-height', `${Math.round(targetHeight)}px`);
    if (typeof scheduleQuizCardContentScaleSync === 'function') scheduleQuizCardContentScaleSync();
}

// Commit the solo grid once, under the closing pane, then slide and fade the live card.
function snapPaneCloseColumnsWithCardGlide(workArea, targetColumns, { startRect = null } = {}) {
    const card = els?.quizCard || $('quiz-card');
    // A caller that moved the layout first (the rail expanding) passes where the card stood before.
    const firstRect = startRect || card?.getBoundingClientRect?.();
    // The rail stylesheet sets this transition with !important; only an inline !important stops it.
    workArea.style.setProperty('transition', 'none', 'important');
    workArea.style.gridTemplateColumns = targetColumns.map((width) => `${width}px`).join(' ');
    // Measure with the same solo selectors the caller commits immediately after this returns.
    workArea.classList.remove('split-view', 'split-view-ai');
    void workArea.offsetWidth;
    workArea.style.removeProperty('transition');
    if (!card || typeof card.animate !== 'function') return;
    const token = paneOpenLayoutRefreshTimer;
    queueMicrotask(() => {
        if (token !== paneOpenLayoutRefreshTimer || !workArea.classList.contains('pane-close-crushing')) return;
        if (typeof applyQuizCardContentScale === 'function') applyQuizCardContentScale();
        animatePaneQuizCardBounds(card, firstRect, 'out');
    });
}

function beginPaneCloseCollapse(workArea, closingPane, { targetLayout = 'single' } = {}) {
    const quizPane = els?.quizPane || $('quiz-pane');
    if (!workArea || !closingPane || !quizPane) return false;

    const quizRect = quizPane.getBoundingClientRect();
    const closingRect = closingPane.getBoundingClientRect();
    const columns = String(getComputedStyle(workArea).gridTemplateColumns || '')
        .trim()
        .split(/\s+/);
    const widths = columns.map((column) => Number.parseFloat(column));
    if (widths.some((width) => !Number.isFinite(width))) return false;

    const expandedWidth = Math.max(0, workArea.clientWidth);
    if (expandedWidth < 8) return false;

    const closingOnLeft = closingRect.left < quizRect.left;
    let targetColumns = null;
    if (targetLayout === 'single' && (columns.length === 3 || columns.length === 5)) {
        const quizColumn = getPaneCloseGridColumn(workArea, quizRect);
        targetColumns = widths.map((_width, index) => index === quizColumn - 1 ? expandedWidth : 0);
    } else if (targetLayout === 'duo' && columns.length === 5) {
        const workRect = workArea.getBoundingClientRect();
        const capturedLeft = Number.parseFloat(closingPane.style.getPropertyValue('--pane-close-left'));
        const capturedWidth = Number.parseFloat(closingPane.style.getPropertyValue('--pane-close-width'));
        const hasCapturedBounds = Number.isFinite(capturedLeft) && Number.isFinite(capturedWidth);
        const closesLeftWall = hasCapturedBounds
            ? capturedLeft <= 2
            : closingRect.left <= workRect.left + 2;
        const closesRightWall = hasCapturedBounds
            ? capturedLeft + capturedWidth >= expandedWidth - 2
            : closingRect.right >= workRect.right - 2;
        if (!closesLeftWall && !closesRightWall) return false;
        const keptHandleWidth = closesLeftWall ? widths[3] : widths[1];
        const duoPaneWidth = Math.max(0, (expandedWidth - keptHandleWidth) / 2);
        targetColumns = closesLeftWall
            ? [0, 0, duoPaneWidth, keptHandleWidth, duoPaneWidth]
            : [duoPaneWidth, keptHandleWidth, duoPaneWidth, 0, 0];
    }
    if (!targetColumns) return false;

    clearPaneCloseCollapse(workArea);
    setPaneLayoutTarget(workArea, targetLayout);
    workArea.classList.add('pane-close-crushing', closingOnLeft ? 'pane-close-crush-left' : 'pane-close-crush-right');
    closingPane.style.setProperty('--pane-close-shift', closingOnLeft ? '-22px' : '22px');
    if (targetLayout === 'single') {
        // The rail expands back for solo. Expanding it after the tracks were pinned left the column
        // at the compact-rail width until the close ended, then the card jumped; settle it first
        // and size the quiz track to the work area it lands in.
        const startRect = paneCloseCardStartRect || (els?.quizCard || $('quiz-card'))?.getBoundingClientRect?.();
        paneCloseCardStartRect = null;
        settleLeftRailForPairing(workArea, false);
        const landedWidth = Math.max(0, workArea.clientWidth);
        if (landedWidth >= 8 && landedWidth !== expandedWidth) {
            targetColumns = targetColumns.map((width) => (width > 0 ? landedWidth : 0));
        }
        snapPaneCloseColumnsWithCardGlide(workArea, targetColumns, { startRect });
        return true;
    }
    workArea.style.gridTemplateColumns = widths.map((width) => `${width}px`).join(' ');
    paneCloseCollapseFrame = requestAnimationFrame(() => {
        paneCloseCollapseFrame = 0;
        if (!workArea.classList.contains('pane-close-crushing')) return;
        workArea.style.gridTemplateColumns = targetColumns.map((width) => `${width}px`).join(' ');
    });
    return true;
}

// Where the quiz card stood when a close began, before any layout class moved it (the rail's duo
// card has its own left inset, which stops applying as the close classes land).
let paneCloseCardStartRect = null;

function markPaneCloseTransitioning(targets = [], options = {}) {
    const workArea = els?.workArea || $('work-area');
    if (!workArea) return;
    paneCloseCardStartRect = (els?.quizCard || $('quiz-card'))?.getBoundingClientRect?.() || null;
    if (typeof window.triggerMemoraSurfaceSettle === 'function') {
        window.triggerMemoraSurfaceSettle('pane', getPaneMotionMs('out') + 120);
    }
    window.followQuizCompanionsThroughPaneTransition?.();
    const paneCloseMs = getPaneMotionMs('out');
    if (paneOpenTransitionTimer) {
        clearTimeout(paneOpenTransitionTimer);
        paneOpenTransitionTimer = 0;
    }
    // A close can supersede an open before its pre-paint microtask runs.
    // Advancing the token makes that queued refresh a no-op.
    paneOpenLayoutRefreshTimer += 1;

    if (paneCloseLayoutRefreshTimer) {
        clearTimeout(paneCloseLayoutRefreshTimer);
        paneCloseLayoutRefreshTimer = 0;
    }
    if (paneCloseLayoutRefreshFrame) {
        cancelAnimationFrame(paneCloseLayoutRefreshFrame);
        paneCloseLayoutRefreshFrame = 0;
    }
    paneOpenLayoutTarget = '';
    clearPaneOpenExpansion(workArea, { resetColumns: true });
    workArea.classList.remove('pane-open-transitioning');
    clearPaneLayoutTarget(workArea);
    const preserveFlow = !!options?.preserveFlow;
    const targetLayout = String(options?.targetLayout || 'single');
    const detachFlow = !!options?.detachFlow
        || (preserveFlow && (targetLayout === 'single' || targetLayout === 'duo'));
    if (preserveFlow) {
        setPaneLayoutTarget(workArea, targetLayout, {
            normalizeHeight: targetLayout === 'single'
        });
    }
    const targetList = Array.isArray(targets) ? targets : [targets];
    const paneMap = {
        pdf: els?.pdfPane || $('pdf-pane'),
        ai: $('ai-pane')
    };
    const workRect = workArea.getBoundingClientRect();
    let collapsePane = null;

    targetList.forEach(target => {
        const pane = paneMap[target];
        if (!pane || !workRect.width || !workRect.height) return;
        const rect = pane.getBoundingClientRect();
        if (rect.width < 8 || rect.height < 8) return;

        if (pane._memoraPaneCloseTimer) {
            clearTimeout(pane._memoraPaneCloseTimer);
            pane._memoraPaneCloseTimer = 0;
        }
        clearPaneCloseAnimation(pane);
        pane.style.setProperty('--pane-close-left', `${rect.left - workRect.left}px`);
        pane.style.setProperty('--pane-close-top', `${rect.top - workRect.top}px`);
        pane.style.setProperty('--pane-close-width', `${rect.width}px`);
        pane.style.setProperty('--pane-close-height', `${rect.height}px`);
        if (preserveFlow && detachFlow) {
            const closesLeftWall = (rect.left + (rect.width / 2)) < (workRect.left + (workRect.width / 2));
            pane.style.setProperty('--pane-close-origin-x', closesLeftWall ? 'left' : 'right');
            pane.style.setProperty('--pane-close-shift', closesLeftWall ? '-22px' : '22px');
            workArea.classList.add('pane-close-crushing', closesLeftWall ? 'pane-close-crush-left' : 'pane-close-crush-right');
        } else if (preserveFlow) {
            pinPaneCloseGridPlacement(workArea, pane, rect);
        }
        void pane.offsetWidth;
        if (preserveFlow && detachFlow) {
            pane.classList.add('pane-soft-closing', 'pane-soft-closing-to-wall');
        } else {
            pane.classList.add(preserveFlow ? 'pane-soft-closing-in-flow' : 'pane-soft-closing');
        }
        if (preserveFlow && !collapsePane) collapsePane = pane;
        pane._memoraPaneCloseTimer = setTimeout(() => {
            pane._memoraPaneCloseTimer = 0;
            clearPaneCloseAnimation(pane);
        }, preserveFlow ? paneCloseMs + 40 : Math.min(340, paneCloseMs + 40));
    });

    if (paneCloseTransitionTimer) {
        clearTimeout(paneCloseTransitionTimer);
        paneCloseTransitionTimer = 0;
    }
    workArea.classList.add('pane-close-transitioning');
    const collapseStarted = collapsePane
        ? beginPaneCloseCollapse(workArea, collapsePane, { targetLayout })
        : false;
    if (preserveFlow && !collapseStarted) setPaneLayoutTarget(workArea, targetLayout);
    if (preserveFlow) {
        const refreshTarget = (remainingDelays = PANE_CLOSE_LAYOUT_REFRESH_DELAYS) => {
            if (!workArea.classList.contains('pane-close-transitioning')) return;
            // Keep the predeclared card geometry stable through the entire pane
            // collapse. Measuring the nav row while its source pane is still
            // shrinking produces a shorter temporary solo card, followed by a
            // visible bottom-edge stretch once the final layout settles.
            setPaneLayoutTarget(workArea, targetLayout);
            const [nextDelay, ...rest] = remainingDelays;
            if (!Number.isFinite(nextDelay)) return;
            paneCloseLayoutRefreshTimer = setTimeout(() => {
                paneCloseLayoutRefreshTimer = 0;
                paneCloseLayoutRefreshFrame = requestAnimationFrame(() => {
                    paneCloseLayoutRefreshFrame = 0;
                    refreshTarget(rest);
                });
            }, nextDelay);
        };
        paneCloseLayoutRefreshFrame = requestAnimationFrame(() => {
            paneCloseLayoutRefreshFrame = 0;
            refreshTarget();
        });
    }
    paneCloseTransitionTimer = setTimeout(() => {
        paneCloseTransitionTimer = 0;
        workArea.classList.remove('pane-close-transitioning');
        // Work queued in the 160ms tail after the commit flush would otherwise
        // wait for the fallback timer.
        if (!isPaneLayoutTransitioning()) flushPaneLayoutSettledCallbacks();
    }, paneCloseMs ? paneCloseMs + 160 : 0);
    return collapseStarted;
}

let paneCloseLayoutCommitCallback = null;

function runPaneCloseLayoutCommit() {
    paneCloseLayoutCommitTimer = 0;
    const callback = paneCloseLayoutCommitCallback;
    paneCloseLayoutCommitCallback = null;
    callback?.();
    flushPaneLayoutSettledCallbacks();
}

function commitAfterPaneClosePreview(callback, delayMs = getPaneMotionMs('out')) {
    if (paneCloseLayoutCommitTimer) {
        clearTimeout(paneCloseLayoutCommitTimer);
        paneCloseLayoutCommitTimer = 0;
    }
    paneCloseLayoutCommitCallback = callback;
    const delay = Number(delayMs);
    paneCloseLayoutCommitTimer = setTimeout(
        runPaneCloseLayoutCommit,
        Number.isFinite(delay) ? Math.max(0, delay) : getPaneMotionMs('out')
    );
}

// A motion preference that changes mid-transition finishes this owner's presentation at once: the
// card glide jumps to its end, the tracks land, and the pending commit and settle callbacks run now.
function finishPaneTransitionsForMotionChange() {
    const workArea = els?.workArea || $('work-area');
    if (!workArea || getMemoraMotionMode() === 'standard') return;
    clearPaneRailWidthTransition();
    (els?.quizCard || $('quiz-card'))?.getAnimations?.().forEach((animation) => {
        if (Object.getPrototypeOf(animation) === Animation.prototype) animation.finish();
    });
    if (paneOpenExpandFrame) {
        cancelAnimationFrame(paneOpenExpandFrame);
        paneOpenExpandFrame = 0;
    }
    if (paneOpenTransitionTimer) {
        clearTimeout(paneOpenTransitionTimer);
        completePaneOpenTransition(workArea);
    }
    if (paneCloseLayoutCommitTimer) {
        clearTimeout(paneCloseLayoutCommitTimer);
        runPaneCloseLayoutCommit();
    }
    [els?.pdfPane || $('pdf-pane'), $('ai-pane')].forEach((pane) => {
        if (!pane?._memoraPaneCloseTimer) return;
        clearTimeout(pane._memoraPaneCloseTimer);
        pane._memoraPaneCloseTimer = 0;
        clearPaneCloseAnimation(pane);
    });
    if (paneCloseTransitionTimer) {
        clearTimeout(paneCloseTransitionTimer);
        paneCloseTransitionTimer = 0;
        workArea.classList.remove('pane-close-transitioning');
    }
    if (questionPaneTransitionTimer) {
        clearTimeout(questionPaneTransitionTimer);
        questionPaneTransitionTimer = 0;
        workArea.classList.remove('question-pane-transitioning');
    }
    if (!isPaneLayoutTransitioning()) flushPaneLayoutSettledCallbacks();
}
document.addEventListener('memora:motion-mode-changed', finishPaneTransitionsForMotionChange);

let quizCardPaneTransitionRefreshToken = 0;

function scheduleQuizCardPaneTransitionRefresh({
    layoutMode = 'duo',
    expectedClass = '',
    forceLayoutDefault = true
} = {}) {
    const workArea = els?.workArea || $('work-area');
    if (!workArea) return;
    const token = ++quizCardPaneTransitionRefreshToken;
    const run = () => {
        if (token !== quizCardPaneTransitionRefreshToken) return;
        if (expectedClass && !workArea.classList.contains(expectedClass)) return;
        if (document.body?.classList?.contains('quiz-card-expanded-mode')) return;
        const card = els?.quizCard || $('quiz-card');
        if (card?.classList?.contains('is-floating')) {
            if (typeof resetQuizCardPosition === 'function') {
                resetQuizCardPosition({ forceLayoutDefault, layoutMode });
            }
            return;
        }
        if (typeof resetQuizCardPosition === 'function') {
            resetQuizCardPosition({ forceLayoutDefault, layoutMode });
        } else if (typeof scheduleQuizCardContentScaleSync === 'function') {
            scheduleQuizCardContentScaleSync();
        }
    };
    requestAnimationFrame(() => {
        run();
        requestAnimationFrame(run);
    });
    setTimeout(run, getPaneMotionMs('out') + 40);
    setTimeout(run, getPaneMotionMs('out') + 100);
}

function closeTransientQuestionPanesForNavigation({
    closePdf = true,
    closePdfExplanation = true,
    preserveExpandedLock = false
} = {}) {
    const workArea = els?.workArea || $('work-area');
    if (!workArea || workArea.classList.contains('pdf-tutor-view')) return false;

    const pdfLayoutVisible = !!(
        isViewerOpen
        || isTrioMode
        || workArea.classList.contains('split-view')
        || workArea.classList.contains('trio-view')
    );
    const aiLayoutVisible = !!(
        workArea.classList.contains('split-view-ai')
        || workArea.classList.contains('trio-view')
        || isTrioMode
    );
    const pdfExplanationVisible = !!(
        aiPaneMode === AI_PANE_MODE_PDF_EXPLANATION
        && aiLayoutVisible
    );
    // Ask or Notes open over the side pane owns that slot (the shared Slide/Ask/Notes box).
    // Closing the source beneath it on Next dropped the card to solo and pushed the surface out
    // with the pane, so the question change looked like Ask/Notes closing and reopening, and
    // Slide afterwards had to swipe the pane back in from the wall instead of crossfading. The
    // source is hidden under the surface anyway; keep the slot as the student left it.
    const sideSurfaceOwnsPane = (() => {
        if (workArea.classList.contains('trio-view')) return false;
        const askModal = $('ask-ai-modal');
        if (askModal?.classList.contains('active')
            && !askModal.classList.contains('is-closing')
            && askModal.dataset.layoutMode === 'pane') return true;
        return isQuizSideSurfaceInPane() && !!$('notes-modal')?.classList.contains('active');
    })();
    const shouldClosePdf = !!(closePdf && pdfLayoutVisible && !sideSurfaceOwnsPane);
    const shouldClosePdfExplanation = !!(closePdfExplanation && pdfExplanationVisible);
    if (!shouldClosePdf && !shouldClosePdfExplanation) return false;
    const quizCardResetOptions = preserveExpandedLock ? { preserveExpandedLock: true } : {};
    const keepPdf = pdfLayoutVisible && !shouldClosePdf;
    const keepAi = aiLayoutVisible && !shouldClosePdfExplanation;
    const closingPdfExplanationOnly = shouldClosePdfExplanation && !shouldClosePdf;
    const closingAllToSingle = !keepPdf && !keepAi;
    // A source opened from docked Ask left Ask as the pill; closing that source hands the dock
    // straight back. Collapsing toward the solo card first and then re-docking reads as the
    // layout closing and reopening at another size, so swap the source out in one step.
    // Read before notifyAskMemoraPdfPaneClosing, which consumes the dock origin; that call waits
    // until the closed layout is committed so the dock is restored in the same frame.
    const returnsToAskDock = shouldClosePdf
        && closingAllToSingle
        && window.willAskMemoraRedockAfterSourceClose?.() === true;
    if (shouldClosePdf) {
        window.closePdfEvidenceAskCardForPaneClose?.();
        if (!returnsToAskDock) window.notifyAskMemoraPdfPaneClosing?.();
    }
    if (returnsToAskDock) {
        if (isPdfPaneExpanded) togglePdfPaneExpanded(false);
        const cardLeftBeforeClose = (els?.quizCard || $('quiz-card'))?.getBoundingClientRect().left;
        detachSmartLineListeners();
        isTrioMode = false;
        isViewerOpen = false;
        setViewerToggleLabel('Show PDF');
        setTrioToggleLabel('⫶ Trio');
        if (isPdfPaneInAiMode()) {
            els.pdfFrame.src = '';
            setPdfPaneMode('pdf');
        }
        workArea.classList.add('no-transition');
        workArea.classList.remove('trio-view', 'split-view', 'split-view-ai');
        resetPanelResizeColumnsForModeSwitch();
        void syncAiPaneModeView(aiPaneMode);
        applyPanelOrderLayout();
        void workArea.offsetHeight;
        workArea.classList.remove('no-transition');
        window.notifyAskMemoraPdfPaneClosing?.({ immediate: true, cardLeftBeforeClose });
        flushPaneLayoutSettledCallbacks();
        return true;
    }

    // Collapse the expanded (fixed, full-viewport) PDF surface BEFORE the close
    // transition measures pane bounds. Otherwise the close ghost animates with
    // the expanded geometry and briefly overlaps the quiz card and the header.
    if (shouldClosePdf && isPdfPaneExpanded) togglePdfPaneExpanded(false);

    markQuestionPaneTransitioning();
    markPaneCloseTransitioning([
        shouldClosePdf ? 'pdf' : null,
        shouldClosePdfExplanation ? 'ai' : null
    ].filter(Boolean), { preserveFlow: closingAllToSingle, targetLayout: 'single' });
    if (closingAllToSingle) {
        workArea.classList.remove('split-view', 'split-view-ai', 'trio-view');
        setPaneLayoutTarget(workArea, 'single');
    }

    if (shouldClosePdf) detachSmartLineListeners();
    if (shouldClosePdfExplanation) {
        preserveAiExplanationReaderForResume('Reader paused. Question changed; reopen PDF Explanation to resume.');
        persistAiPaneMode(AI_PANE_MODE_AI);
        const modeSelect = $('ai-pane-mode');
        if (modeSelect) modeSelect.value = AI_PANE_MODE_AI;
    }

    if (closingAllToSingle) {
        isTrioMode = false;
        isViewerOpen = false;
        setViewerToggleLabel('Show PDF');
        setTrioToggleLabel('\u2AF6 Trio');

        if (shouldClosePdf && isPdfPaneInAiMode()) {
            els.pdfFrame.src = '';
            setPdfPaneMode('pdf');
        }

        commitAfterPaneClosePreview(() => {
            workArea.classList.add('no-transition');
            workArea.classList.remove('trio-view', 'split-view', 'split-view-ai');
            resetPanelResizeColumnsForModeSwitch();
            resetQuizCardPosition(quizCardResetOptions);
            void syncAiPaneModeView(aiPaneMode);
            applyPanelOrderLayout();
            clearPaneCloseCollapse(workArea, { commitCardGeometry: true, clearPaneAnimations: true });
            void workArea.offsetHeight;
            workArea.classList.remove('no-transition');
        });
        return true;
    }

    workArea.classList.remove('trio-view', 'split-view', 'split-view-ai');

    if (keepPdf && keepAi) {
        workArea.classList.add('trio-view');
        isTrioMode = true;
        isViewerOpen = true;
        setViewerToggleLabel('Hide PDF');
        setTrioToggleLabel('\u2AF6 Exit Trio');
        setPdfPaneMode('pdf');
        resetQuizCardPosition(quizCardResetOptions);
    } else if (keepPdf) {
        workArea.classList.add('split-view');
        isTrioMode = false;
        isViewerOpen = true;
        setViewerToggleLabel('Hide PDF');
        setTrioToggleLabel('\u2AF6 Trio');
        setPdfPaneMode('pdf');
        scheduleQuizCardPositionReset({ forceLayoutDefault: true, layoutMode: 'duo', ...quizCardResetOptions });
    } else if (keepAi) {
        workArea.classList.add('split-view-ai');
        isTrioMode = false;
        isViewerOpen = false;
        setViewerToggleLabel('Show PDF');
        setTrioToggleLabel('\u2AF6 Trio');
        scheduleQuizCardPositionReset({ forceLayoutDefault: true, layoutMode: 'duo', ...quizCardResetOptions });
    } else {
        isTrioMode = false;
        isViewerOpen = false;
        setViewerToggleLabel('Show PDF');
        setTrioToggleLabel('\u2AF6 Trio');
        resetQuizCardPosition(quizCardResetOptions);
    }

    if (shouldClosePdf && isPdfPaneInAiMode()) {
        els.pdfFrame.src = '';
        setPdfPaneMode('pdf');
    }

    resetPanelResizeColumnsForModeSwitch();
    void syncAiPaneModeView(aiPaneMode);
    applyPanelOrderLayout();

    if (closingPdfExplanationOnly && keepPdf) {
        void syncPdfScaleForCurrentLayoutModeSwitch();
    }
    return true;
}

window.closeTransientQuestionPanesForNavigation = closeTransientQuestionPanesForNavigation;
window.markPaneOpenTransitioning = markPaneOpenTransitioning;
window.beginPaneOpenExpansion = beginPaneOpenExpansion;
window.markPaneCloseTransitioning = markPaneCloseTransitioning;
window.clearPaneCloseCollapse = clearPaneCloseCollapse;

function openAI(type) {
    let url = '';
    let title = '';

    if (type === 'chatgpt') {
        url = 'https://chatgpt.com';
        title = 'ChatGPT';
    } else if (type === 'gemini') {
        url = 'https://gemini.google.com/app';
        title = 'Gemini';
    } else if (type === 'notebooklm') {
        url = 'https://notebooklm.google.com';
        title = 'NotebookLM';
    }
    if (!url) {
        url = 'https://gemini.google.com/app';
        title = 'Gemini';
    }
    lastOpenedAiUrl = url;
    lastOpenedAiTitle = title;

    const aiDropdown = $('ai-dropdown') || $('menu-dropdown');
    if (aiDropdown) aiDropdown.classList.remove('active');

    if (isTauriApp && window.__TAURI__.core) {
        const aiPane = $('ai-pane');
        if (aiPane) aiPane.style.display = 'none';

        window.__TAURI__.core.invoke('open_ai_panel', { url, title })
            .then(() => {
                console.log('Opened native AI panel:', title);
                $('ai-title').innerText = `${title} (Native)`;
            })
            .catch(err => {
                console.error('Tauri AI panel error:', err);
                window.open(url, '_blank');
            });
        return;
    }

    if (isTrioMode) {
        const aiFrame = $('ai-frame');
        const aiTitle = $('ai-title');
        if (aiFrame) aiFrame.src = url;
        if (aiTitle) aiTitle.innerText = title;
        void syncAiPaneModeView(AI_PANE_MODE_AI);
        return;
    }

    const workArea = $('work-area');
    const pdfPane = $('pdf-pane');
    const animateDuoOpen = !workArea.classList.contains('split-view');
    if (animateDuoOpen) markPaneOpenTransitioning({ targetLayout: 'duo' });
    workArea.classList.add('split-view');
    pdfPane.style.display = 'flex';

    setPdfPaneMode('ai');

    els.quizCard.style.width = '';
    els.quizCard.style.position = '';
    els.quizCard.style.left = '';
    els.quizCard.style.top = '';
    els.quizCard.style.margin = '';
    els.quizCard.style.height = '';
    els.quizCard.style.zIndex = '';
    els.quizCard.style.display = 'block';
    syncQuizCardCustomGeometryState();

    const frame = $('pdf-frame');
    frame.src = url;
    els.pdfTitle.innerText = title;

    const popoutBtn = $('popout-pdf-btn');
    popoutBtn.onclick = () => window.open(url, '_blank');

    setViewerToggleLabel('Hide AI');
    isViewerOpen = true;
    applyPanelOrderLayout();
    if (animateDuoOpen) beginPaneOpenExpansion('pdf', { targetLayout: 'duo' });
}

// Slide, Ask and Notes share the quiz's side one at a time. The outgoing surface fades for the
// same 170ms Ask and Notes use for each other, then closes before the next one opens.
const QUIZ_SIDE_SURFACE_FADE_MS = 170;

// Reduced motion has no fade to wait for, so the handoff runs on the next task.
function getQuizSideSurfaceFadeMs() {
    return getMemoraMotionMode() === 'reduced' ? 0 : QUIZ_SIDE_SURFACE_FADE_MS;
}

function isQuizSlidePaneOpen() {
    const workArea = els?.workArea || $('work-area');
    return !!isViewerOpen && !isTrioMode
        && !!workArea?.classList.contains('split-view')
        && !workArea.classList.contains('split-view-ai');
}

function handOffQuizSideSurfaceToSlide(openSlide) {
    if (document.documentElement.classList.contains('phone-device')) return false;
    // In the shared pane the slide is already laid out under Ask/Notes; closing them reveals it.
    if (isQuizSideSurfaceInPane()) quizSideSurfaceRevealingSlide = true;
    const askModal = $('ask-ai-modal');
    if (askModal?.classList.contains('active') && !askModal.classList.contains('is-closing')
        && typeof closeAskAIModal === 'function') {
        getAskAIModalContentEl?.()?.classList.add('surface-switch-out');
        window.setTimeout(() => {
            closeAskAIModal('button');
            openSlide();
        }, getQuizSideSurfaceFadeMs());
        return true;
    }
    if ($('notes-modal')?.classList.contains('active') && typeof requestNotesEditorTransition === 'function') {
        void requestNotesEditorTransition(() => {
            $('notes-modal-content')?.classList.add('surface-switch-out');
            window.setTimeout(() => {
                teardownNotesEditorSurface();
                openSlide();
            }, getQuizSideSurfaceFadeMs());
        });
        return true;
    }
    quizSideSurfaceRevealingSlide = false;
    return false;
}

// Ask and Notes opened from the quiz card sit in the slide pane's own box (the duo layout stays
// open with the slide faded out underneath), so Slide, Ask and Notes share one container: the
// quiz card never moves and each switch is a crossfade in place.
let quizSideSurfacePaneObserver = null;
let quizSideSurfaceRevealingSlide = false;
// Ask/Notes opened the duo without loading the slide under them (openQuizDuoFrameForSideSurface).
let quizSlidePaneSourceDeferred = false;

/* What the concealed slide would show. Ask ranks and excerpts its context from the "currently
   visible PDF page" (getAskMemoraVisiblePdfInfo, app.ai.js); while the slide is deferred the
   viewer holds nothing or an older page, so report the current question's source and cited page
   (clamped as loadPdfInPane clamps it), or, with no linked source, what the pane would restore. */
function getQuizSlidePaneDeferredSource() {
    if (!quizSlidePaneSourceDeferred || !isQuizSideSurfaceInPane()) return null;
    try {
        const question = questions[filteredIndices[currentQIndex]];
        const fileName = question ? findBestPdfForQuestion(question) : '';
        if (fileName && loadedPdfFiles?.[fileName]) {
            const cited = Math.max(1, Number(getQuestionCitationInfo(question).page) || 1);
            const pageCount = fileName === pdfViewerFileName ? Number(pdfViewerDoc?.numPages) || 0 : 0;
            return { fileName, pageNumber: pageCount ? Math.min(pageCount, cited) : cited };
        }
        const restorePdf = typeof getPreferredPdfForRestore === 'function' ? getPreferredPdfForRestore() : '';
        if (!restorePdf) return null;
        return { fileName: restorePdf, pageNumber: Math.max(1, Number(lastPdfState?.page) || 1) };
    } catch (_error) {
        return null;
    }
}
window.getQuizSlidePaneDeferredSource = getQuizSlidePaneDeferredSource;

function isQuizSlidePaneSourceDeferred() {
    // Slide opens concealed too, before Ask/Notes has claimed the shared pane.
    return quizSlidePaneSourceDeferred;
}

// The duo pane's content when no question source applies: the last document, or the empty state.
function restorePdfPaneContentForDuo() {
    const restorePdf = getPreferredPdfForRestore();
    if (restorePdf) {
        const restorePage = Math.max(1, Number(lastPdfState?.page) || 1);
        const restoreSearch = String(lastPdfState?.searchTerm || '').trim();
        loadPdfInPane(restorePdf, {
            page: restorePage,
            searchTerm: restoreSearch,
            smooth: false,
            ensureViewer: false,
            maintainScale: true
        });
    } else {
        showEmptyPdfPaneState('Add a file to see it here');
    }
}

function isQuizSideSurfaceInPane() {
    return !!document.body?.classList.contains('quiz-side-surface-in-pane');
}

function getQuizSideSurfacePaneRect() {
    if (!isQuizSideSurfaceInPane()) return null;
    const pane = els?.pdfPane || $('pdf-pane');
    const workArea = els?.workArea || $('work-area');
    /* While the duo opens, the (faded) slide pane is still growing out of the right wall. Ask and
       Notes take its final box straight away and fade in with the card's move, instead of
       waiting for the layout to settle: the right half of the work area, at the pane's own
       layout top and height (neither is animated). */
    if (pane && workArea?.classList.contains('pane-open-transitioning') && workArea.classList.contains('split-view')) {
        const workRect = workArea.getBoundingClientRect();
        const width = workArea.classList.contains('pane-open-gliding')
            ? pane.getBoundingClientRect().width
            : (Number.parseFloat(getComputedStyle(workArea).gridTemplateColumns.split(/\s+/)[2])
                || getPredictedPaneWidth('pdf-pane', 'duo'));
        // The rail sizes the pane's vertical box from these variables (margin-top and height,
        // live-left-rail-polish.css), and the companion follower moves them with the card each
        // frame; reading them avoids a forced layout of the pane.
        const railTop = Number.parseFloat(workArea.style.getPropertyValue('--quiz-source-panel-top'));
        const railHeight = Number.parseFloat(workArea.style.getPropertyValue('--quiz-source-panel-height'));
        const railBox = document.body.classList.contains('memora-live-left-rail-preview')
            && !document.documentElement.classList.contains('phone-device')
            && Number.isFinite(railTop) && Number.isFinite(railHeight);
        const top = railBox
            ? workRect.top + railTop
            : (pane.offsetParent?.getBoundingClientRect?.().top ?? workRect.top) + pane.offsetTop;
        const height = railBox ? railHeight : pane.offsetHeight;
        if (width >= 120 && height >= 120) {
            const left = (pane.offsetParent?.getBoundingClientRect?.().left ?? workRect.left) + pane.offsetLeft;
            return { left, top, width, height };
        }
    }
    const rect = pane?.getBoundingClientRect?.();
    if (!rect || rect.width < 120 || rect.height < 120) return null;
    return { left: rect.left, top: rect.top, width: rect.width, height: rect.height };
}
window.getQuizSideSurfacePaneRect = getQuizSideSurfacePaneRect;

const QUIZ_SIDE_SURFACE_RECT_PROPS = ['left', 'top', 'right', 'bottom', 'width', 'height', 'max-width', 'max-height'];

// Rail CSS sizes Ask and Notes with !important; only an inline !important can place them in the
// slide pane's box. releaseQuizSideSurfacePane clears these so docked/overlay layouts own them again.
function applyQuizSideSurfacePaneRect(element, rect) {
    if (!element || !rect) return;
    const values = {
        left: `${Math.round(rect.left)}px`,
        top: `${Math.round(rect.top)}px`,
        right: 'auto',
        bottom: 'auto',
        width: `${Math.round(rect.width)}px`,
        height: `${Math.round(rect.height)}px`,
        'max-width': 'none',
        'max-height': 'none'
    };
    for (const prop of QUIZ_SIDE_SURFACE_RECT_PROPS) {
        // Unchanged values are skipped so a repeat placement does not dirty style.
        if (element.style.getPropertyValue(prop) === values[prop]
            && element.style.getPropertyPriority(prop) === 'important') continue;
        element.style.setProperty(prop, values[prop], 'important');
    }
}
window.applyQuizSideSurfacePaneRect = applyQuizSideSurfacePaneRect;

function clearQuizSideSurfacePaneRect(element) {
    if (!element) return;
    for (const prop of QUIZ_SIDE_SURFACE_RECT_PROPS) {
        if (element.style.getPropertyPriority(prop) === 'important') element.style.removeProperty(prop);
    }
}

// Only the surface on screen follows the pane; the inactive companion has nothing to place.
function syncQuizSideSurfacesToPane() {
    if ($('ask-ai-modal')?.classList.contains('active') && typeof syncAskAIModalPosition === 'function') {
        syncAskAIModalPosition();
    }
    if ($('notes-modal')?.classList.contains('active') && typeof syncNotesSurfaceLayout === 'function') {
        syncNotesSurfaceLayout();
    }
}

function runQuizSideSurfacePaneSettlePass() {
    if (isQuizSideSurfaceInPane()) syncQuizSideSurfacesToPane();
}

// While the duo opens, the surface already holds the pane's predicted final box (see
// getQuizSideSurfacePaneRect), so per-frame resize deliveries only re-measure the same rect.
// One named settle pass corrects it after the open; divider drags and other resizes still
// follow the pane every frame.
function handleQuizSideSurfacePaneResize() {
    if (!isQuizSideSurfaceInPane()) return;
    const workArea = els?.workArea || $('work-area');
    if (workArea?.classList.contains('pane-open-transitioning')) {
        whenPaneLayoutSettled(runQuizSideSurfacePaneSettlePass);
        return;
    }
    syncQuizSideSurfacesToPane();
}

function enterQuizSideSurfacePane() {
    const pane = els?.pdfPane || $('pdf-pane');
    pane?.classList.add('surface-switch-out');
    document.body.classList.add('quiz-side-surface-in-pane');
    if (!quizSideSurfacePaneObserver && pane && typeof ResizeObserver === 'function') {
        quizSideSurfacePaneObserver = new ResizeObserver(handleQuizSideSurfacePaneResize);
        quizSideSurfacePaneObserver.observe(pane);
    }
}

// Called when Ask or Notes finishes closing. A swap between the two keeps the pane; the Slide
// button reveals the slide in place; any other close returns to the solo quiz card.
function releaseQuizSideSurfacePane() {
    if (!isQuizSideSurfaceInPane() || document.body.classList.contains('quiz-side-surface-switching')) return;
    // A button switch in flight owns the pane; its outgoing surface closing is not a return to solo.
    if (isQuizSideSurfaceSwitchRunning() && !quizSideSurfaceRevealingSlide) return;
    const askModal = $('ask-ai-modal');
    const askOpen = !!askModal?.classList.contains('active') && !askModal.classList.contains('is-closing');
    if (askOpen || $('notes-modal')?.classList.contains('active')) return;
    // Ask still fading out keeps its pane box, or it drops to its floating spot mid-fade; its
    // close calls back here once it is gone.
    if (askModal?.classList.contains('is-closing')) return;
    document.body.classList.remove('quiz-side-surface-in-pane');
    quizSideSurfacePaneObserver?.disconnect();
    quizSideSurfacePaneObserver = null;
    clearQuizSideSurfacePaneRect(getAskAIModalContentEl?.());
    clearQuizSideSurfacePaneRect($('notes-modal-content'));
    const pane = els?.pdfPane || $('pdf-pane');
    if (quizSideSurfaceRevealingSlide) {
        // revealQuizSlideUnderSideSurface owns the fade back in (and the deferred slide load).
        quizSideSurfaceRevealingSlide = false;
        return;
    }
    quizSlidePaneSourceDeferred = false;
    if (isQuizSlidePaneOpen()) toggleViewer(false);
    // Reopened meanwhile: the slide stays hidden under the new Ask/Notes.
    window.setTimeout(() => {
        if (!isQuizSideSurfaceInPane()) pane?.classList.remove('surface-switch-out');
    }, 700);
}
window.releaseQuizSideSurfacePane = releaseQuizSideSurfacePane;

// Ask's leave toward the wall; closeAskAIModal keeps the surface rendered this long (modals.css).
const QUIZ_SIDE_SURFACE_LEAVE_MS = 260;
window.QUIZ_SIDE_SURFACE_LEAVE_MS = QUIZ_SIDE_SURFACE_LEAVE_MS;

/* Ask closing back to the solo card. The card used to wait for Ask's whole fade-out before it
   began its return, so a close read as a pause and then a second motion. The return now starts
   the moment Ask starts leaving: Ask keeps its pane box and eases out toward the wall while the
   card glides back underneath it, one motion. A switch to Slide or Notes keeps the pane. */
// True when closing this surface now returns the quiz to its solo card (no switch, no Slide handoff).
function willQuizSideSurfaceReturnToSolo(target = 'ask') {
    return target === 'ask' && isQuizSideSurfaceInPane()
        && !quizSideSurfaceRevealingSlide
        && !isQuizSideSurfaceSwitchRunning()
        && !document.body.classList.contains('quiz-side-surface-switching')
        && !$('notes-modal')?.classList.contains('active')
        && $('ask-ai-modal')?.dataset.layoutMode === 'pane';
}
window.willQuizSideSurfaceReturnToSolo = willQuizSideSurfaceReturnToSolo;

function beginQuizSideSurfacePaneReturn(target = 'ask') {
    if (!willQuizSideSurfaceReturnToSolo(target)) return false;
    const askModal = $('ask-ai-modal');
    const content = getAskAIModalContentEl?.();
    if (!askModal?.classList.contains('is-closing')) return false;
    content?.classList.add('quiz-side-surface-leaving');
    // Ask keeps the rect it already holds; without the in-pane class nothing re-places it.
    document.body.classList.remove('quiz-side-surface-in-pane');
    quizSideSurfacePaneObserver?.disconnect();
    quizSideSurfacePaneObserver = null;
    quizSlidePaneSourceDeferred = false;
    const pane = els?.pdfPane || $('pdf-pane');
    if (isQuizSlidePaneOpen()) toggleViewer(false);
    window.setTimeout(() => {
        content?.classList.remove('quiz-side-surface-leaving');
        // Reopened meanwhile: the new open owns the rect and the pane.
        if (isQuizSideSurfaceInPane()) return;
        clearQuizSideSurfacePaneRect(content);
        clearQuizSideSurfacePaneRect($('notes-modal-content'));
    }, QUIZ_SIDE_SURFACE_LEAVE_MS);
    window.setTimeout(() => {
        if (!isQuizSideSurfaceInPane()) pane?.classList.remove('surface-switch-out');
    }, 700);
    return true;
}
window.beginQuizSideSurfacePaneReturn = beginQuizSideSurfacePaneReturn;

// The Slide button's own action: jump to the question's slide (which opens the duo layout), or
// toggle the viewer when the question has no linked slide.
function openQuizSlideFromButton({ keepOpen = false } = {}) {
    // A second press while the card is still gliding in: the slide is already on its way.
    if (quizSlideLandingPending && isQuizSlidePaneOpen()) return;
    (els?.pdfPane || $('pdf-pane'))?.classList.remove('surface-switch-out');
    // Nothing is loaded to show: link a source instead of opening an empty viewer.
    if (!Object.keys(loadedPdfFiles || {}).length && !isQuizSlidePaneOpen()) {
        openQuizSourceLinkFlow();
        return;
    }
    if (openQuizSlideAfterDuoGlide()) return;
    if (typeof triggerEvidence === 'function' && triggerEvidence({ smoothJump: false, minimizeDockedAsk: true })) return;
    // Coming from Ask/Notes the slide is the destination; never toggle it closed.
    if (keepOpen && isQuizSlidePaneOpen()) return;
    toggleViewer(keepOpen ? true : undefined);
}

/* Load the side surface after the card lands. A percentage timer started PDF rendering and
   Ask/Notes layout while the card was still moving, competing for the same frames. Wait for the
   transition owner's cleanup, then give the landed card a paint before starting that work. */
let quizSlideLandingPending = false;

function waitForQuizDuoGlideToLand() {
    return new Promise((resolve) => {
        const afterLayout = () => {
            // A fallback settle notification can arrive before an extended or interrupted glide.
            if (isPaneLayoutTransitioning()) {
                whenPaneLayoutSettled(afterLayout);
                return;
            }
            requestAnimationFrame(() => requestAnimationFrame(resolve));
        };
        afterLayout();
    });
}

function canGlideQuizIntoDuoBeforeLoading() {
    const workArea = els?.workArea || $('work-area');
    return !isQuizSlidePaneOpen()
        && !isQuizSideSurfaceInPane()
        && !document.documentElement.classList.contains('phone-device')
        && !isTrioMode
        && !!workArea
        && !workArea.classList.contains('split-view-ai')
        && !workArea.classList.contains('trio-view')
        && !workArea.classList.contains('pdf-tutor-view');
}

// Slide from the solo card: the pane opens concealed, the card glides, and the question's page
// loads into the settled pane and fades in once it has painted. A question with no linked source
// keeps the immediate path (its notice, or the restore load).
function openQuizSlideAfterDuoGlide() {
    if (!canGlideQuizIntoDuoBeforeLoading()) return false;
    try {
        const question = questions[filteredIndices[currentQIndex]];
        const sourceName = question ? findBestPdfForQuestion(question) : '';
        if (!sourceName || !loadedPdfFiles?.[sourceName]) return false;
    } catch (_error) {
        return false;
    }
    void openQuizDuoFrameForSideSurface();
    const openSeq = ++quizSlideRevealSeq;
    quizSlideLandingPending = true;
    void waitForQuizDuoGlideToLand().then(() => {
        quizSlideLandingPending = false;
        if (openSeq !== quizSlideRevealSeq) return;
        if (!isQuizSlidePaneOpen()) {
            // Closed again before the card landed: leave nothing concealed or deferred behind.
            quizSlidePaneSourceDeferred = false;
            (els?.pdfPane || $('pdf-pane'))?.classList.remove('surface-switch-out');
            return;
        }
        // Ask/Notes took the pane meanwhile; they keep the slide deferred under them.
        if (!quizSlidePaneSourceDeferred || !isQuizSideSurfaceShown('slide') || isQuizSideSurfaceInPane()) return;
        revealQuizSlideUnderSideSurface();
    });
    return true;
}

function openQuizSourceLinkFlow() {
    if (typeof window.MemoraLiveLeftRailContext?.open === 'function') {
        void window.MemoraLiveLeftRailContext.open('');
        return;
    }
    showPopup('Add the lecture PDF or slides to link a source to this question.', null, false);
}

// True when the current question's slide is not the one already on screen. The cited page is
// clamped to the document as loadPdfInPane clamps it, and compared with the page the viewer was
// asked for: a citation past the last page, or PDF.js's transient page-1 report while a pane
// opens, otherwise read as "another page" and re-ran the jump on every reveal.
function quizSlideNeedsJumpForCurrentQuestion() {
    try {
        const question = questions[filteredIndices[currentQIndex]];
        if (!question) return false;
        const sourceName = findBestPdfForQuestion(question);
        const cited = Math.max(1, Number(getQuestionCitationInfo(question).page) || 1);
        if (typeof isMemoraPptxSourceName === 'function' && isMemoraPptxSourceName(sourceName)) {
            if (sourceName !== memoraPptxViewerFileName) return true;
            const slideCount = Number(memoraPptxViewerSlideCount) || 0;
            return Number(memoraPptxViewerCurrentSlide) !== (slideCount ? Math.min(slideCount, cited) : cited);
        }
        if (sourceName !== pdfViewerFileName) return true;
        const pageCount = Number(pdfViewerDoc?.numPages) || 0;
        const page = pageCount ? Math.min(pageCount, cited) : cited;
        const shownPage = typeof getAdvancedPdfPageToKeep === 'function'
            ? getAdvancedPdfPageToKeep()
            : Number(pdfViewerInstance?.currentPageNumber);
        return Number(shownPage) !== page;
    } catch (_error) {
        return true;
    }
}

// A reveal waits for its page at most this long, then shows the pane's loading or error state.
const QUIZ_SLIDE_REVEAL_MAX_WAIT_MS = 1200;
let quizSlideRevealSeq = 0;

/* Back to the slide from Ask/Notes. The slide is already laid out under them, so this is a
   crossfade: jump only if the question now points at another page (while it is still faded out),
   then fade it back in. Re-running the Slide button's jump here scrolled and re-rendered pages
   after they were visible, which read as the slide sweeping in again. */
function revealQuizSlideUnderSideSurface() {
    const pane = els?.pdfPane || $('pdf-pane');
    if (!pane || !isQuizSlidePaneOpen()) {
        openQuizSlideFromButton({ keepOpen: true });
        return;
    }
    const revealToken = ++quizSlideRevealSeq;
    const fadeIn = () => {
        // Ask or Notes came back (or a newer reveal started) before this page was ready.
        // (A closing Ask still carries the in-pane class, so ask whether one is actually shown.)
        if (revealToken !== quizSlideRevealSeq || !isQuizSideSurfaceShown('slide')) return;
        pane.classList.add('surface-switch-in');
        pane.classList.remove('surface-switch-out');
        window.setTimeout(() => pane.classList.remove('surface-switch-in'), 280);
    };
    // Opened from Ask/Notes, the slide was never loaded: load it now, while it is still faded out.
    const deferred = quizSlidePaneSourceDeferred;
    quizSlidePaneSourceDeferred = false;
    if ((!deferred && !quizSlideNeedsJumpForCurrentQuestion()) || typeof triggerEvidence !== 'function') {
        if (deferred) restorePdfPaneContentForDuo();
        fadeIn();
        return;
    }
    const requests = window.MemoraPdfPaneRequests;
    const requestBefore = requests?.latest?.()?.id ?? null;
    if (!triggerEvidence({ smoothJump: false, minimizeDockedAsk: true, silentIfMissing: deferred }) && deferred) {
        // No linked source: show what opening the pane would have restored.
        restorePdfPaneContentForDuo();
    }
    // The pane crossfades in as a whole; the page stack's own entrance animation would replay
    // underneath it and read as the slide sweeping in.
    const pagesRoot = els?.pdfJsPages || $('pdfjs-pages');
    if (pagesRoot) delete pagesRoot.dataset.pdfPagesEnteringPending;
    const requestAfter = requests?.latest?.()?.id ?? null;
    if (requestAfter == null || requestAfter === requestBefore) {
        // No tracked request (PPTX, iframe renderer, no linked source): keep the short delay.
        window.setTimeout(fadeIn, 220);
        return;
    }
    // Fade in once the requested page has painted rather than on a guessed delay.
    Promise.race([
        requests.awaitCompletion(requestAfter),
        new Promise((resolve) => window.setTimeout(resolve, QUIZ_SLIDE_REVEAL_MAX_WAIT_MS))
    ]).then(fadeIn, fadeIn);
}

function isQuizSideSurfaceShown(target) {
    const askModal = $('ask-ai-modal');
    const askShown = !!askModal?.classList.contains('active') && !askModal.classList.contains('is-closing');
    const notesShown = !!$('notes-modal')?.classList.contains('active');
    if (target === 'ask') return askShown && !notesShown;
    if (target === 'notes') return notesShown && !askShown;
    return !askShown && !notesShown;
}

function waitForQuizSideSurfaceStep(test, timeoutMs) {
    return new Promise((resolve) => {
        const started = Date.now();
        const poll = () => {
            if (test() || Date.now() - started >= timeoutMs) {
                resolve();
                return;
            }
            window.setTimeout(poll, 40);
        };
        poll();
    });
}

function openQuizDuoFrameForSideSurface() {
    // The same open the slide's own load uses (loadPdfInPane opens the pane with skipRestoreLoad),
    // so the quiz card lands in exactly the geometry it has beside the slide. The slide itself is
    // not loaded: it stays faded out under Ask/Notes, and opening, jumping and rendering a document
    // nobody can see cost ~100ms of every Ask/Notes open. The Slide button loads it on reveal.
    const pane = els?.pdfPane || $('pdf-pane');
    quizSlidePaneSourceDeferred = true;
    pane?.classList.add('surface-switch-out');
    toggleViewer(true, { skipRestoreLoad: true });
    // No wait for the layout to settle: the surface takes the pane's final box at once (see
    // getQuizSideSurfacePaneRect) so it arrives with the card, as the slide does.
    return Promise.resolve();
}

async function performQuizSideSurfaceSwitch(target) {
    if (target === 'slide') {
        await new Promise((resolve) => {
            const finish = () => {
                revealQuizSlideUnderSideSurface();
                resolve();
            };
            if (!handOffQuizSideSurfaceToSlide(finish)) {
                openQuizSlideFromButton();
                resolve();
            }
            // A Notes save that fails keeps Notes open and never calls finish.
            window.setTimeout(resolve, 2500);
        });
        return;
    }
    const open = () => (target === 'ask' ? openAskAIModal() : openNotesModal());
    const workArea = els?.workArea || $('work-area');
    const canUsePane = !document.documentElement.classList.contains('phone-device')
        && !isTrioMode
        && !workArea?.classList.contains('split-view-ai')
        && !workArea?.classList.contains('trio-view')
        && !workArea?.classList.contains('pdf-tutor-view');
    if (canUsePane && !isQuizSideSurfaceInPane()) {
        const slideWasOpen = isQuizSlidePaneOpen();
        enterQuizSideSurfacePane();
        if (slideWasOpen) {
            await new Promise((resolve) => window.setTimeout(resolve, getQuizSideSurfaceFadeMs()));
        } else {
            await openQuizDuoFrameForSideSurface();
            // Ask/Notes render as the card lands rather than while it travels.
            await waitForQuizDuoGlideToLand();
        }
    }
    // Ask <-> Notes inside the pane use their own crossfade handoff.
    void open();
    await waitForQuizSideSurfaceStep(() => isQuizSideSurfaceShown(target), 2500);
}

// Drops the side-surface state without touching the layout: a solo landing, or Ask leaving the
// slide pane's box for its own AI pane (Split View), after which a card Ask opens the duo afresh.
function detachQuizSideSurfacePane() {
    document.body.classList.remove('quiz-side-surface-in-pane');
    quizSideSurfacePaneObserver?.disconnect();
    quizSideSurfacePaneObserver = null;
    quizSideSurfaceRevealingSlide = false;
    quizSlidePaneSourceDeferred = false;
    clearQuizSideSurfacePaneRect(getAskAIModalContentEl?.());
    clearQuizSideSurfacePaneRect($('notes-modal-content'));
    (els?.pdfPane || $('pdf-pane'))?.classList.remove('surface-switch-out', 'surface-switch-in');
}
window.detachQuizSideSurfacePane = detachQuizSideSurfacePane;

/* Opening a quiz (picker Open/Resume, Dashboard Resume) always lands on the solo card, whatever
   layout was left behind and even with Auto-Sources on: the first question's automatic source is
   skipped, and Auto-Sources resumes from the next question. Runs under the route shield, so the
   layout is reset instantly rather than animated. Plain returns to Quizzes keep their layout. */
function landQuizInSoloLayout() {
    const askModal = $('ask-ai-modal');
    if (askModal?.classList.contains('active') && typeof closeAskAIModalForDuoHandoff === 'function') {
        closeAskAIModalForDuoHandoff();
    }
    if ($('notes-modal')?.classList.contains('active') && typeof requestNotesEditorTransition === 'function') {
        void requestNotesEditorTransition(teardownNotesEditorSurface);
    }
    detachQuizSideSurfacePane();
    if (typeof prepareSessionLandingSoloMode === 'function') prepareSessionLandingSoloMode();
}
window.landQuizInSoloLayout = landQuizInSoloLayout;

// Clicks on Slide / Ask / Notes run one switch at a time. A click during a switch only records the
// destination; the runner then goes straight to the last one requested. Overlapping switches used to
// let a delayed open land after a newer one, or close both surfaces and collapse to the solo card.
const quizSideSurfaceSwitch = { running: false, queued: '' };

function isQuizSideSurfaceSwitchRunning() {
    return quizSideSurfaceSwitch.running;
}

async function switchQuizSideSurface(target = '') {
    if (!['slide', 'ask', 'notes'].includes(target)) return;
    quizSideSurfaceSwitch.queued = target;
    if (quizSideSurfaceSwitch.running) return;
    quizSideSurfaceSwitch.running = true;
    try {
        while (quizSideSurfaceSwitch.queued) {
            const next = quizSideSurfaceSwitch.queued;
            quizSideSurfaceSwitch.queued = '';
            // A queued Ask/Notes that is already on screen needs no second pass.
            if (next !== 'slide' && isQuizSideSurfaceInPane() && isQuizSideSurfaceShown(next)) continue;
            try {
                await performQuizSideSurfaceSwitch(next);
            } catch (error) {
                console.warn('Quiz side surface switch failed:', error);
            }
        }
    } finally {
        quizSideSurfaceSwitch.running = false;
    }
    // If the requested surface never appeared, do not leave a faded, empty pane behind.
    if (isQuizSideSurfaceInPane() && isQuizSideSurfaceShown('slide')) releaseQuizSideSurfacePane();
}
window.switchQuizSideSurface = switchQuizSideSurface;

function toggleViewer(f, { skipRestoreLoad = false } = {}) {
    if (typeof window.togglePdfTutorQuizBreakoutViewer === 'function'
        && window.togglePdfTutorQuizBreakoutViewer(f)) {
        return;
    }

    if (isTrioMode && (f === false || (f === undefined && isViewerOpen))) {
        closePdfInTrio();
        return;
    }

    if ((f === true || (f === undefined && !isViewerOpen)) && window.isAskMemoraDocked?.()) {
        window.revealAskMemoraForSourceEvidence?.();
    }

    if (els.workArea.classList.contains('split-view-ai') && (f === true || (f === undefined && !isViewerOpen))) {
        markPaneOpenTransitioning({ targetLayout: 'trio' });
        els.workArea.classList.remove('split-view-ai');
        els.workArea.classList.add('trio-view');
        els.pdfPane.style.display = '';
        if (els.pdfTitle) els.pdfTitle.style.display = '';
        resetPanelResizeColumnsForModeSwitch();
        resetQuizCardPosition();

        setViewerToggleLabel('Hide PDF');
        setTrioToggleLabel('\u2AF6 Exit Trio');
        isTrioMode = true;
        isViewerOpen = true;
        setPdfPaneMode('pdf');
        const restorePdf = getPreferredPdfForRestore();
        if (restorePdf) {
            const restorePage = Math.max(1, Number(lastPdfState?.page) || 1);
            const restoreSearch = String(lastPdfState?.searchTerm || '').trim();
            loadPdfInPane(restorePdf, {
                page: restorePage,
                searchTerm: restoreSearch,
                smooth: false,
                ensureViewer: false,
                maintainScale: true
            });
        } else {
            showEmptyPdfPaneState('No PDF Loaded');
        }
        void syncAiPaneModeView(aiPaneMode);
        applyPanelOrderLayout();
        beginPaneOpenExpansion('pdf', { targetLayout: 'trio' });
        return;
    }

    isViewerOpen = f !== undefined ? f : !isViewerOpen;
    setViewerToggleLabel(isViewerOpen ? 'Hide PDF' : 'Show PDF');

    let openingViewerPane = '';
    if (isViewerOpen) {
        markPaneOpenTransitioning({ targetLayout: 'duo' });
        openingViewerPane = 'pdf';
        els.workArea.classList.add('split-view');
        els.pdfPane.style.display = '';
        setPdfPaneMode('pdf');
        $('pdf-title').style.display = '';
        resetPanelResizeColumnsForModeSwitch();
        if (!skipRestoreLoad) restorePdfPaneContentForDuo();

        if (typeof scheduleQuizCardContentScaleSync === 'function') scheduleQuizCardContentScaleSync();
    } else {
        window.closePdfEvidenceAskCardForPaneClose?.();
        window.notifyAskMemoraPdfPaneClosing?.();
        if (isPdfPaneExpanded) togglePdfPaneExpanded(false);
        detachSmartLineListeners();
        const closingSidePane = els.workArea.classList.contains('split-view-ai') ? 'ai' : 'pdf';
        markPaneCloseTransitioning(closingSidePane, { preserveFlow: true, targetLayout: 'single' });
        els.workArea.classList.remove('split-view');
        els.workArea.classList.remove('split-view-ai');
        setPaneLayoutTarget(els.workArea, 'single');

        if (isPdfPaneInAiMode()) {
            els.pdfFrame.src = '';
        }

        setPdfPaneMode('pdf');
        els.pdfPane.style.display = '';
        commitAfterPaneClosePreview(() => {
            els.workArea.classList.add('no-transition');
            els.workArea.classList.remove('split-view');
            els.workArea.classList.remove('split-view-ai');
            resetPanelResizeColumnsForModeSwitch();
            resetQuizCardPosition();
            applyPanelOrderLayout();
            clearPaneCloseCollapse(els.workArea, { commitCardGeometry: true, clearPaneAnimations: true });
            void els.workArea.offsetHeight;
            els.workArea.classList.remove('no-transition');
        });
        return;
    }

    applyPanelOrderLayout();
    if (openingViewerPane) beginPaneOpenExpansion(openingViewerPane, { targetLayout: 'duo' });
}

function toggleTrio(f, { skipPdfRestore = false, preserveExpandedLock = false } = {}) {
    if (typeof window.togglePdfTutorQuizBreakoutTrio === 'function'
        && window.togglePdfTutorQuizBreakoutTrio(f)) {
        return;
    }

    const wasTrioMode = isTrioMode;
    const openingTrioPanes = els.workArea.classList.contains('split-view-ai')
        ? ['pdf']
        : (els.workArea.classList.contains('split-view') ? ['ai'] : ['pdf', 'ai']);
    isTrioMode = f !== undefined ? f : !isTrioMode;
    const aiFrame = $('ai-frame');
    const aiTitle = $('ai-title');

    if (isTrioMode) {
        markPaneOpenTransitioning({ targetLayout: 'trio' });
        els.workArea.classList.remove('split-view');
        els.workArea.classList.remove('split-view-ai');
        els.workArea.classList.add('trio-view');
        els.pdfPane.style.display = '';
        if (els.pdfTitle) els.pdfTitle.style.display = '';
        resetPanelResizeColumnsForModeSwitch();

        setPdfPaneMode('pdf');
        const restorePdf = getPreferredPdfForRestore();
        if (restorePdf && !skipPdfRestore) {
            loadPdfInPane(restorePdf, {
                page: Math.max(1, Number(lastPdfState?.page) || 1),
                searchTerm: String(lastPdfState?.searchTerm || '').trim(),
                smooth: false,
                ensureViewer: false,
                maintainScale: true
            });
        } else {
            showEmptyPdfPaneState('No PDF Loaded');
        }

        if (isTauriApp && window.__TAURI__.core) {
            window.__TAURI__.core.invoke('open_ai_panel', {
                url: lastOpenedAiUrl || 'https://gemini.google.com/app',
                title: lastOpenedAiTitle || 'Gemini'
            }).then(() => {
                console.log('Opened native Gemini panel');
            }).catch(err => console.error('Tauri AI panel error:', err));

            aiFrame.src = 'about:blank';
            aiTitle.innerText = `${lastOpenedAiTitle || 'Gemini'} (Native)`;
        } else {
            aiFrame.src = 'about:blank';
            aiTitle.innerText = 'Ask Memoraful';
            removeAiIframeExtensionRecommendation();
        }

        resetQuizCardPosition(preserveExpandedLock ? { preserveExpandedLock: true } : {});

        isViewerOpen = true;
        setViewerToggleLabel('Hide PDF');
        setTrioToggleLabel('\u2AF6 Exit Trio');
        void syncAiPaneModeView(aiPaneMode);
    } else {
        window.closePdfEvidenceAskCardForPaneClose?.();
        window.notifyAskMemoraPdfPaneClosing?.();
        markPaneCloseTransitioning(['pdf', 'ai'], { preserveFlow: true, targetLayout: 'single' });
        els.workArea.classList.remove('trio-view');
        els.workArea.classList.remove('split-view');
        els.workArea.classList.remove('split-view-ai');
        setPaneLayoutTarget(els.workArea, 'single');

        aiFrame.src = '';
        isViewerOpen = false;
        setViewerToggleLabel('Show PDF');
        setTrioToggleLabel('\u2AF6 Trio');

        commitAfterPaneClosePreview(() => {
            els.workArea.classList.add('no-transition');
            els.workArea.classList.remove('trio-view');
            els.workArea.classList.remove('split-view');
            els.workArea.classList.remove('split-view-ai');
            resetPanelResizeColumnsForModeSwitch();
            resetQuizCardPosition();
            void syncAiPaneModeView(aiPaneMode);
            applyPanelOrderLayout();
            clearPaneCloseCollapse(els.workArea, { commitCardGeometry: true, clearPaneAnimations: true });
            void els.workArea.offsetHeight;
            els.workArea.classList.remove('no-transition');
        });
    }
    applyPanelOrderLayout();
    if (isTrioMode && !wasTrioMode) beginPaneOpenExpansion(openingTrioPanes, { targetLayout: 'trio' });
}

function closePdfInTrio() {
    window.closePdfEvidenceAskCardForPaneClose?.();
    window.notifyAskMemoraPdfPaneClosing?.();
    if (typeof window.closePdfTutorQuizBreakoutSidePane === 'function'
        && window.closePdfTutorQuizBreakoutSidePane('pdf')) {
        return;
    }

    if (isPdfPaneExpanded) togglePdfPaneExpanded(false);
    if (!isTrioMode) {
        toggleViewer(false);
        return;
    }
    if (aiPaneMode === AI_PANE_MODE_PDF_EXPLANATION) {
        preserveAiExplanationReaderForResume('Reader paused. PDF panel closed; resume is preserved.');
    }

    const collapseStarted = markPaneCloseTransitioning('pdf', {
        preserveFlow: true,
        targetLayout: 'duo'
    });
    if (collapseStarted) {
        els.workArea.classList.remove('trio-view');
        els.workArea.classList.remove('split-view');
        els.workArea.classList.add('split-view-ai');
        setPaneLayoutTarget(els.workArea, 'duo');
    }
    setViewerToggleLabel('Show PDF');
    setTrioToggleLabel('\u2AF6 Trio');
    isTrioMode = false;
    isViewerOpen = false;
    detachSmartLineListeners();

    const commitDuoLayout = () => {
        els.workArea.classList.add('no-transition');
        els.workArea.classList.remove('trio-view');
        els.workArea.classList.remove('split-view');
        els.workArea.classList.add('split-view-ai');
        resetPanelResizeColumnsForModeSwitch();
        applyPanelOrderLayout();
        resetQuizCardPosition({ forceLayoutDefault: true, layoutMode: 'duo' });
        void syncAiPaneModeView(aiPaneMode);
        clearPaneCloseCollapse(els.workArea, { commitCardGeometry: true, clearPaneAnimations: true });
        void els.workArea.offsetHeight;
        els.workArea.classList.remove('no-transition');
    };
    if (collapseStarted) {
        commitAfterPaneClosePreview(commitDuoLayout);
        return;
    }
    commitDuoLayout();
}

function closeAiInTrio() {
    if (typeof window.closePdfTutorQuizBreakoutSidePane === 'function'
        && window.closePdfTutorQuizBreakoutSidePane('ai')) {
        return;
    }

    const wasTrioMode = isTrioMode;
    const wasSplitViewAi = els.workArea.classList.contains('split-view-ai');
    const closesSplitAiToSingle = wasSplitViewAi && !wasTrioMode && !isViewerOpen;
    if (aiPaneMode === AI_PANE_MODE_PDF_EXPLANATION) {
        preserveAiExplanationReaderForResume('Reader paused. AI pane closed; reopen PDF Explanation to resume.');
    }

    const collapseStarted = wasTrioMode
        ? markPaneCloseTransitioning('ai', { preserveFlow: true, targetLayout: 'duo' })
        : markPaneCloseTransitioning('ai', {
            preserveFlow: closesSplitAiToSingle,
            targetLayout: 'single'
        });
    $('ai-frame').src = '';

    if (closesSplitAiToSingle) {
        isTrioMode = false;
        setTrioToggleLabel('\u2AF6 Trio');
        els.workArea.classList.remove('trio-view');
        els.workArea.classList.remove('split-view-ai');
        els.workArea.classList.remove('split-view');
        setPaneLayoutTarget(els.workArea, 'single');
        commitAfterPaneClosePreview(() => {
            els.workArea.classList.add('no-transition');
            els.workArea.classList.remove('trio-view');
            els.workArea.classList.remove('split-view-ai');
            els.workArea.classList.remove('split-view');
            resetPanelResizeColumnsForModeSwitch();
            resetQuizCardPosition();
            void syncAiPaneModeView(aiPaneMode);
            applyPanelOrderLayout();
            clearPaneCloseCollapse(els.workArea, { commitCardGeometry: true, clearPaneAnimations: true });
            void els.workArea.offsetHeight;
            els.workArea.classList.remove('no-transition');
        });
        return;
    }

    if (collapseStarted && wasTrioMode) {
        els.workArea.classList.remove('trio-view');
        els.workArea.classList.remove('split-view-ai');
        els.workArea.classList.add('split-view');
        isTrioMode = false;
        setTrioToggleLabel('\u2AF6 Trio');
        setPaneLayoutTarget(els.workArea, 'duo');
    }

    const commitRemainingLayout = () => {
        els.workArea.classList.add('no-transition');
        els.workArea.classList.remove('trio-view');
        els.workArea.classList.remove('split-view-ai');
        els.workArea.classList.remove('split-view');

        if (wasTrioMode) {
            els.workArea.classList.add('split-view');
            isTrioMode = false;
        } else if (wasSplitViewAi) {
            isTrioMode = false;
        } else if (isViewerOpen) {
            els.workArea.classList.add('split-view');
        }

        resetPanelResizeColumnsForModeSwitch();
        if (els.workArea.classList.contains('split-view')) {
            setPdfPaneMode('pdf');
            applyPanelOrderLayout();
            resetQuizCardPosition({ forceLayoutDefault: true, layoutMode: 'duo' });
            void syncPdfScaleForCurrentLayoutModeSwitch();
        } else {
            resetQuizCardPosition();
            applyPanelOrderLayout();
        }

        setTrioToggleLabel('\u2AF6 Trio');
        void syncAiPaneModeView(aiPaneMode);
        clearPaneCloseCollapse(els.workArea, { commitCardGeometry: true, clearPaneAnimations: true });
        void els.workArea.offsetHeight;
        els.workArea.classList.remove('no-transition');
    };
    if (collapseStarted) {
        commitAfterPaneClosePreview(commitRemainingLayout);
        return;
    }
    commitRemainingLayout();
}

function bindPaneTestIds() {
    $('work-area')?.setAttribute('data-testid', 'work-area');
    $('quiz-pane')?.setAttribute('data-testid', 'quiz-pane');
    $('toggle-viewer-btn')?.setAttribute('data-testid', 'viewer-toggle');
    $('toggle-trio-btn')?.setAttribute('data-testid', 'trio-toggle');
    $('pdf-pane')?.setAttribute('data-testid', 'pdf-pane');
    $('close-viewer-btn')?.setAttribute('data-testid', 'pdf-close');
    $('pdf-expand-btn')?.setAttribute('data-testid', 'pdf-expand');
    $('ai-pane')?.setAttribute('data-testid', 'ai-pane');
    $('ai-pane-mode')?.setAttribute('data-testid', 'ai-pane-mode');
    $('ai-expl-pdf-select')?.setAttribute('data-testid', 'ai-expl-pdf-select');
    $('ai-expl-view')?.setAttribute('data-testid', 'ai-expl-view');
    $('ai-expl-content')?.setAttribute('data-testid', 'ai-expl-content');
    $('close-ai-btn')?.setAttribute('data-testid', 'ai-close');
    $('popout-ai-btn')?.setAttribute('data-testid', 'ai-popout');
}

function shouldHandleAiExplanationReaderPauseShortcut(event) {
    if (!event || event.defaultPrevented) return false;
    const matchesPauseShortcut = typeof window.matchesShortcutActionEvent === 'function'
        ? window.matchesShortcutActionEvent(event, 'pauseReader')
        : (!!event.shiftKey && !event.ctrlKey && !event.metaKey && !event.altKey && String(event.key || '').toLowerCase() === 'p');
    if (!matchesPauseShortcut) return false;
    const aiExplView = $('ai-expl-view');
    const voiceAgentModal = $('voice-agent-modal');
    const hasReaderSurfaceVisible = !!(voiceAgentModal?.classList.contains('active')
        || (aiPaneMode === AI_PANE_MODE_PDF_EXPLANATION && aiExplView && aiExplView.style.display !== 'none'));
    if (!hasReaderSurfaceVisible) return false;

    const target = event.target;
    if (target instanceof HTMLElement) {
        const tagName = String(target.tagName || '').toLowerCase();
        if (target.isContentEditable) return false;
        if (['input', 'textarea', 'select'].includes(tagName)) return false;
        if (target.closest('input, textarea, select, [contenteditable="true"]')) return false;
    }
    const hasExplanationState = !!(aiExplanationReaderState.isPlaying || aiExplanationReaderState.isPaused || hasAiExplanationReaderResumePoint());
    const hasLiveReadout = typeof window.hasGeminiLivePlaybackActivity === 'function'
        ? !!window.hasGeminiLivePlaybackActivity()
        : false;
    return hasExplanationState || hasLiveReadout;
}

/* Voice "pause" and "resume" name the state they want, unlike the shortcut, which flips it. Returns
 * what happened to the explanation reader, or "" when it holds nothing so another player can answer. */
function setAiExplanationReaderPausedAction(mode = 'toggle') {
    if (!isVoiceAgentAccessibilityEnabled()) return '';
    const { isPlaying, isPaused } = aiExplanationReaderState;
    if (!isPlaying && !isPaused) return hasAiExplanationReaderResumePoint() ? 'idle' : '';
    const pause = mode === 'toggle' ? !isPaused : mode === 'pause';
    if (pause === isPaused) return isPaused ? 'already-paused' : 'already-playing';
    if (pause) pauseAiExplanationReader();
    else resumeAiExplanationReader();
    return pause ? 'paused' : 'resumed';
}

async function toggleAiExplanationReaderPauseShortcutAction() {
    if (!isVoiceAgentAccessibilityEnabled()) return false;
    const hasExplanationState = aiExplanationReaderState.isPlaying || aiExplanationReaderState.isPaused || hasAiExplanationReaderResumePoint();
    if (hasExplanationState) {
        pauseAiExplanationReader();
        return true;
    }
    if (window.MemoraVoiceAgent?.pauseOrResume) {
        return !!(await window.MemoraVoiceAgent.pauseOrResume());
    }
    if (typeof window.toggleGeminiLiveQuestionReadoutPause === 'function') {
        return !!(await window.toggleGeminiLiveQuestionReadoutPause());
    }
    return false;
}

function shouldHandleAiExplanationInterruptShortcut(event) {
    if (!event || event.defaultPrevented) return false;
    if (event.ctrlKey || event.metaKey || event.altKey) return false;
    if (String(event.key || '').toLowerCase() !== 'i') return false;
    const host = String(window.location?.hostname || '').trim().toLowerCase();
    const protocol = String(window.location?.protocol || '').trim().toLowerCase();
    const isLocalTestingMode = protocol === 'file:' || host === 'localhost' || host === '127.0.0.1';
    if (!isLocalTestingMode) return false;

    const target = event.target;
    if (target instanceof HTMLElement) {
        const tagName = String(target.tagName || '').toLowerCase();
        if (target.isContentEditable) return false;
        if (['input', 'textarea', 'select'].includes(tagName)) return false;
        if (target.closest('input, textarea, select, [contenteditable="true"]')) return false;
    }

    const state = typeof window.getAiExplanationInterruptState === 'function'
        ? window.getAiExplanationInterruptState()
        : null;
    return !!state?.available;
}

(function initializePaneUiSurface() {
    bindPaneTestIds();
    document.addEventListener('keydown', (event) => {
        if (!shouldHandleAiExplanationReaderPauseShortcut(event)) return;
        event.preventDefault();
        void toggleAiExplanationReaderPauseShortcutAction().catch((error) => {
            console.error('Explanation pause shortcut failed:', error);
            setAiExplanationReaderStatus(error?.message || 'Pause failed', 'error');
            syncAiExplanationReaderControls();
        });
    });
    document.addEventListener('keydown', (event) => {
        if (!shouldHandleAiExplanationInterruptShortcut(event)) return;
        event.preventDefault();
        void toggleAiExplanationInterrupt().catch((error) => {
            console.error('Explanation interrupt shortcut failed:', error);
            setAiExplanationReaderStatus(error?.message || 'Interrupt failed', 'error');
            syncAiExplanationReaderControls();
        });
    });
    $('toggle-viewer-btn').onclick = () => {
        const btn = $('toggle-viewer-btn');
        if (btn?.disabled || btn?.classList.contains('is-disabled')) return;
        if (btn?.hasAttribute('data-source-missing') && !isQuizSlidePaneOpen()) {
            openQuizSourceLinkFlow();
            return;
        }
        void switchQuizSideSurface('slide');
    };
    $('toggle-trio-btn').onclick = () => {
        toggleTrio();
    };
    $('pdf-explanation-feature-toggle')?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        toggleMemoraPdfExplanationFeature({ showNotice: true });
    });
    $('close-viewer-btn').onclick = () => {
        closePdfInTrio();
    };
    $('close-ai-btn').onclick = closeAiInTrio;
    $('popout-ai-btn').onclick = () => {
        if (aiPaneMode === AI_PANE_MODE_GEMINI_LIVE) {
            return;
        }
        if (aiPaneMode === AI_PANE_MODE_PDF_EXPLANATION) {
            window.open(lastOpenedAiUrl || 'https://gemini.google.com/app', '_blank');
            return;
        }
        const aiFrame = $('ai-frame');
        const src = aiFrame.src;
        if (src && src !== 'about:blank') {
            window.open(src, '_blank');
        } else {
            window.open(lastOpenedAiUrl || 'https://gemini.google.com/app', '_blank');
        }
    };

    setupAiPaneModeControls();
    syncMemoraPdfExplanationFeatureUi();
    window.addEventListener('memora:accessibility-preferences-changed', syncVoiceAgentAccessibilityState);
    syncVoiceAgentAccessibilityState();
    void syncAiPaneModeView(aiPaneMode);
})();
